import type { Dict } from '../types';

export const uk: Dict = {
  'chat.amrCard.switchTitle': 'Не вдалося викликати модель — це виконання призупинено',
  'chat.amrCard.switchBody': 'Перейдіть на офіційний сервіс моделей Open Design Cloud — без налаштування API-ключа. Після входу, авторизації та поповнення це виконання буде повторено автоматично.',
  'chat.amrCard.chipOfficial': 'Офіційний хостинг',
  'chat.amrCard.chipNoKey': 'Без API-ключа',
  'chat.amrCard.chipAutoRetry': 'Авто-повтор після входу',
  'chat.amrCard.switchCta': 'Перейти на Open Design Cloud і повторити',
  'chat.amrError.authMessage': 'Ваш обліковий запис Open Design Cloud ще не авторизовано. Авторизуйте, і це виконання буде повторено автоматично.',
  'chat.amrError.balanceMessage': 'Баланс Open Design Cloud вичерпано. Поповніть, щоб продовжити це виконання.',
  'chat.amrError.authorizeCta': 'Авторизувати та повторити',
  'chat.amrError.rechargeCta': 'Поповнити Open Design Cloud',
  'chat.amrBalanceGate.title': 'Покращте тариф і продовжуйте творити',
  'chat.amrBalanceGate.message': 'Недостатньо кредитів (залишилось {balance}). Покращте тариф або поповніть баланс — і завдання одразу запуститься.',
  'chat.amrBalanceGate.benefitsTitle': 'Що дає Open Design Cloud',
  'chat.amrBalanceGate.benefit1': 'Без API-ключів — великий вибір моделей',
  'chat.amrBalanceGate.benefit2': 'Вбудований SOTA-агент для дизайну, без налаштувань',
  'chat.amrBalanceGate.benefit3': 'Офіційний сервіс — надійно',
  'chat.amrBalanceGate.benefit4': 'Постійно розвивається: деплой в 1 клік, мультимодальність, команди тощо',
  'chat.amrBalanceGate.laterCta': 'Не зараз',
  'chat.amrBalanceGate.plansCta': 'Покращити тариф',
  'chat.amrBalanceGate.signedOutTitle': 'Увійдіть, щоб почати творити',
  'chat.amrBalanceGate.signedOutMessage': 'Ви використовуєте агент Open Design Cloud — увійдіть, і це завдання одразу запуститься.',
  'chat.amrBalanceGate.signInCta': 'Увійти',
  'chat.amrBalanceGate.watchingWallet': 'Продовжимо автоматично, щойно баланс оновиться.',
  'chat.amrLowBalance.title': 'Кредити закінчуються',
  'chat.amrLowBalance.message': 'Залишилося лише {balance} — ймовірно, не вистачить, щоб завершити завдання. Спершу поповніть баланс або покращте тариф.',
  'chat.amrLowBalance.rechargeCta': 'Поповнити',
  'chat.amrLowBalance.proceedCta': 'Все одно запустити',
  'chat.amrLowBalance.dontRemind': 'Більше не питати',
  'chat.antigravityError.launchTerminalCta': 'Увійти через термінал',
  'chat.antigravityError.launchSwitchModelCta': 'Змінити модель у терміналі',
  'chat.connectionDropped': 'З’єднання зі службою моделі обірвалося до завершення відповіді — зазвичай через нестабільну мережу або проксі. Повторіть спробу.',
  'chat.runError.title.authRequired': 'Потрібна авторизація',
  'chat.runError.title.balance': 'Недостатньо коштів',
  'chat.runError.title.connectionDropped': 'З’єднання обірвано',
  'chat.runError.title.signInRequired': 'Потрібен вхід',
  'chat.runError.title.rateLimited': 'Досягнуто ліміту використання',
  'chat.runError.title.generic': 'Завдання не виконано',
  'chat.runError.signInMessage.amr': 'Агент Open Design Cloud ще не ввійшов — увійдіть, щоб почати користуватися ним.',
  'chat.runError.signInMessage.other': '{agent} не ввійшов. Перевірте стан входу локально. Рекомендуємо агента Open Design Cloud — стабільніший і вигідніший.',
  'chat.runError.agentFallback': 'агент',
  'chat.runError.sourceLabel': 'Джерело помилки',
  'chat.runError.sourceExpandAria': 'Розгорнути джерело помилки',
  'chat.runError.sourceCollapseAria': 'Згорнути джерело помилки',
  'chat.runError.title.cliMissing': 'Агента не встановлено',
  'chat.runError.title.promptTooLarge': 'Занадто довгий ввід',
  'chat.runError.title.modelUnavailable': 'Модель недоступна',
  'chat.runError.title.upstreamUnavailable': 'Сервіс тимчасово недоступний',
  'chat.runError.title.toolLoop': 'Застрягло в циклі',
  'chat.runError.title.outputInvalid': 'Некоректний вивід моделі',
  'chat.runError.title.runtimeConfig': 'Помилка конфігурації',
  'chat.runError.cliMissingMessage': 'Інструмент командного рядка {agent} не знайдено. Установіть його та переконайтеся, що він у PATH, потім повторіть.',
  'chat.runError.promptTooLargeMessage': 'Цей запит перевищив ліміт контексту моделі. Скоротіть запит, приберіть вкладення або почніть нову розмову й повторіть.',
  'chat.runError.modelUnavailableMessage': 'Вибрана модель недоступна або не існує. Перемкніться на іншу модель у налаштуваннях і повторіть.',
  'chat.runError.rateLimitedMessage': 'Досягнуто ліміту використання сервісу моделі. Зачекайте трохи й повторіть або перемкніться на іншу модель чи сервіс.',
  'chat.runError.upstreamUnavailableMessage': 'Сервіс моделі тимчасово недоступний — зазвичай через нестабільність вищого сервісу або проблему мережі/проксі. Повторіть за мить.',
  'chat.runError.toolLoopMessage': '{agent} повторював ту саму дію без прогресу й був зупинений. Перевірте цільовий файл або команду та повторіть.',
  'chat.runError.outputInvalidMessage': 'Модель видала некоректний вивід, і цей запит було перервано. Зазвичай допомагає повторення.',
  'chat.runError.runtimeConfigMessage': 'Конфігурація середовища виконання вибраного агента недійсна, тому запуск не вдався. Оновіться до останньої версії або зверніться до підтримки.',
  'chat.runError.title.quotaExhausted': "Ліміт вичерпано",
  'chat.runError.quotaExhaustedMessage': "Квоту або платіжний ліміт вашого модельного сервісу вичерпано, тож повторна спроба не допоможе. Поповніть баланс у постачальника або перемкніться на іншу модель чи сервіс.",
  'chat.runError.workspaceCreditsMessage': "У вашому робочому просторі закінчилися кредити. Додайте кредити (або попросіть власника простору поповнити) чи перемкніться на іншу модель або сервіс.",
  'common.cancel': 'Скасувати',
  'chat.selectFromLibrary': 'Імпортувати з бібліотеки',
  'chat.importFigma': 'Імпортувати з Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Імпортувати з бібліотеки',
  'designFiles.library.title': 'Імпортувати з бібліотеки',
  'libraryPicker.title': 'Імпортувати з бібліотеки',
  'libraryPicker.searchPlaceholder': 'Пошук у бібліотеці…',
  'libraryPicker.empty': 'У вашій бібліотеці поки немає ресурсів',
  'libraryPicker.allKinds': 'Усі',
  'libraryPicker.add': 'Імпортувати',
  'libraryPicker.loading': 'Завантаження…',
  'common.save': 'Зберегти',
  'common.close': 'Закрити',
  'common.clear': 'Очистити',
  'common.delete': 'Видалити',
  'common.rename': 'Перейменувати',
  'common.edit': 'Редагувати',
  'common.preview': 'Переглянути',
  'common.share': 'Поділитися',
  'common.search': 'Пошук',
  'common.searchEllipsis': 'Пошук…',
  'common.loading': 'Завантаження…',
  'common.all': 'Все',
  'common.none': 'Жодного',
  'common.default': 'За замовчуванням',
  'common.installed': 'встановлено',
  'common.notInstalled': 'не встановлено',
  'common.active': 'активно',
  'common.offline': 'вимкнено',
  'common.selected': 'вибрано',
  'common.create': 'Створити',
  'common.openPreview': 'Відкрити попередній перегляд',
  'common.exitFullscreen': 'Вийти з повноекранного режиму',
  'common.fullscreen': 'Повноекранний режим',
  'common.openInNewTab': 'Відкрити в новій вкладці',
  'common.exportPdf': 'Експортувати як PDF',
  'common.exportZip': 'Завантажити як .zip',
  'common.exportHtml': 'Експортувати як HTML автономно',
  'common.exportImage': 'Експортувати як зображення',
  'common.exportImageFailed': 'Не вдалося захопити зображення. Спробуйте ще раз або скористайтеся інструментом знімків екрана браузера.',
  'common.justNow': 'щойно',
  'common.minutesAgo': '{n}хв тому',
  'common.hoursAgo': '{n}г тому',
  'common.daysAgo': '{n}дн тому',
  'common.weeksAgo': '{n} тиж. тому',
  'common.now': 'тепер',
  'common.minutesShort': '{n}хв',
  'common.hoursShort': '{n}г',
  'common.daysShort': '{n}дн',
  'common.untitled': 'Без назви',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'Step 2: click Download Page here, wait for the saved snapshot success, then return to the left Next Step card and click Continue extraction.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Походження',
  'plugins.availableDetails.provenanceLine': 'з {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'з {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Встановити',
  'plugins.availableDetails.version': 'Версія',
  'plugins.availableDetails.pluginVersion': 'Версія плагіна',
  'plugins.availableDetails.copyInstallCommand': 'Копіювати команду встановлення',
  'plugins.availableDetails.copied': 'Скопійовано',
  'plugins.availableDetails.deprecatedPrefix': 'Застаріло: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Цю версію позначено як застарілу.',
  'plugins.availableDetails.yanked': 'Відкликано.',
  'plugins.availableDetails.yankedWithReason': 'Відкликано: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (застаріле)',
  'plugins.availableDetails.versionYankedSuffix': ' (відкликано)',
  'plugins.availableDetails.ref': 'Реф',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Дозволи',
  'plugins.availableDetails.capabilitySummary': 'Зведення можливостей',
  'plugins.actions.copyInstallCommand': 'Скопіювати команду встановлення',
  'plugins.actions.copyPluginId': 'Скопіювати ID плагіна',
  'plugins.actions.copyReadmeBadge': 'Скопіювати бейдж README',
  'plugins.actions.openSourceGithub': 'Відкрити код на GitHub',
  'plugins.actions.openSource': 'Відкрити код',
  'plugins.actions.openHomepage': 'Відкрити домашню сторінку',
  'plugins.actions.openMarketplace': 'Відкрити в маркетплейсі',
  'app.brand': 'Open Design',
  'app.brandPill': 'Попередній перегляд',
  'app.brandSubtitle': 'від Nexu Labs',
  'app.welcomeLoading': 'Завантаження робочого простору…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Ласкаво просимо до Open Design',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Почніть з опису завдання',
  'settings.onboardingCreateBody': 'Опишіть сайт, застосунок, презентацію, зображення чи відео, які ви хочете. Open Design створить проєкт і збереже роботу редагованою.',
  'settings.onboardingMemoryTitle': 'Зберегти робочий контекст',
  'settings.onboardingMemoryBody': 'Додайте налаштування, факти про проєкт і повторювані правила, щоб майбутні чати підхоплювали правильний контекст.',
  'settings.onboardingMemoryCalloutTitle': 'Збережено у вашу Пам\'ять',
  'settings.onboardingMemoryCalloutBody': 'Ці відповіді формують основу вашого профілю Пам\'яті. Open Design використовує його в кожному завданні й продовжує вчитися, поки ви працюєте.',
  'settings.onboardingMemoryBenefitIntent': 'Розуміє, що ви маєте на увазі, за коротким запитом',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Пропускає повторювані питання з налаштування',
  'settings.onboardingMemoryBenefitPersonalized': 'Адаптує результат під вашу роль, аудиторію та смак',
  'settings.onboardingSystemsTitle': 'Підключіть свою дизайн-систему',
  'settings.onboardingSystemsBody': 'Виберіть або створіть бренд-систему, щоб згенерована робота відповідала справжнім кольорам, типографіці та мові продукту.',
  'settings.onboardingExecutionTitle': 'Виберіть, як виконується генерація',
  'settings.onboardingExecutionBody': 'Офіційний CLI з налаштуванням в один клік і готовими до використання значеннями за замовчуванням. Використовуйте один ключ, щоб обирати з багатьох моделей за вигіднішою ціною.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Офіційно рекомендовано',
  'settings.onboardingAmrCloudBenefitReady': 'Без розгортання',
  'settings.onboardingAmrCloudBenefitModels': 'Підтримує Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Незабаром',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Зображення й відео',
  'settings.onboardingAmrCloudUpcomingSkills': 'Багато Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Розумна маршрутизація',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'Авторизувати Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Авторизовано',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Створити дизайн-систему',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Будьте в курсі',
  'settings.onboardingNewsletterTitle': 'Будьте в курсі',
  'settings.onboardingNewsletterBody': 'Отримуйте новини продукту, нові шаблони, дизайн-системи та роботу амбасадорів на пошту. Необов’язково — можна пропустити.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Увійти в Open Design',
  'settings.onboardingCloudBody': 'Увійдіть і одразу почніть створювати з хмарним ШІ — без складних налаштувань.',
  'settings.onboardingCloudSignIn': 'Увійти в Open Design',
  'settings.onboardingCloudContinue': 'Продовжити (ви увійшли)',
  'settings.onboardingCloudAlternative': 'Використати локальний CLI або власний ключ API',
  'settings.onboardingCloudRights': 'Усі права захищено.',
  'settings.onboardingCloudOr': 'або',
  'settings.onboardingGateTooltipNoRuntime': 'Наступні кроки виконуються на ШІ — виберіть спосіб запуску, щоб продовжити.',
  'settings.onboardingGateTooltipAmr': 'Наступні кроки виконуються на ШІ — увійдіть в Open Design Cloud, щоб продовжити.',
  'settings.onboardingGateTooltipLocal': 'Наступні кроки виконуються на ШІ — виберіть доступний локальний CLI, щоб продовжити.',
  'settings.onboardingGateTooltipByok': 'Наступні кроки виконуються на ШІ — додайте та протестуйте ключ моделі, щоб продовжити.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Офіційний',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Про вас',
  'settings.onboardingProfileBody': 'Необов\'язкові дані для кращих налаштувань за замовчуванням.',
  'settings.onboardingRoleLabel': 'Ваша роль',
  'settings.onboardingOrgSizeLabel': 'Розмір організації',
  'settings.onboardingUseCaseLabel': 'Сценарій використання',
  'settings.onboardingSourceLabel': 'Звідки ви про нас дізналися?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Пошук (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 ШІ-інструмент (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Друг або колега',
  'settings.onboardingSourceCommunity': '💬 Discord / спільнота',
  'settings.onboardingSourceEmail': '✉️ Email / розсилка',
  'settings.onboardingSourceBlog': '📝 Блог / стаття',
  'settings.onboardingSourceOther': '✨ Інше',
  'settings.onboardingSourceOtherPlaceholder': 'Вкажіть, звідки (необов\'язково)',
  'settings.onboardingSelectPlaceholder': 'Виберіть один варіант',
  'settings.onboardingSelectMultiplePlaceholder': 'Виберіть один або кілька',
  'settings.onboardingOrgSolo': 'Соло / особисте (1)',
  'settings.onboardingOrgTeam': 'Невелика команда (2-10)',
  'settings.onboardingOrgStartup': 'Стартап / МСБ (11-50)',
  'settings.onboardingOrgGrowth': 'Компанія, що зростає (51-200)',
  'settings.onboardingOrgMidMarket': 'Середній бізнес (201-1000)',
  'settings.onboardingOrgEnterprise': 'Велике підприємство (1000+)',
  'settings.onboardingRolePm': '📋 Продакт-менеджер',
  'settings.onboardingRoleDesigner': '🎨 Дизайнер',
  'settings.onboardingRoleEngineer': '💻 Інженер',
  'settings.onboardingRoleMarketing': '📣 Маркетинг',
  'settings.onboardingRoleAgency': '📣 Маркетингова агенція',
  'settings.onboardingRoleGrowth': '📈 Зростання',
  'settings.onboardingRoleOps': '⚙️ Операційна діяльність',
  'settings.onboardingRoleFounder': '🚀 Засновник / керівник',
  'settings.onboardingRoleStudent': '🎓 Студент / викладач',
  'settings.onboardingRoleOther': '✨ Інше',
  'settings.onboardingUseProduct': '🎨 Продуктовий дизайн',
  'settings.onboardingUseDesignSystem': '🧩 Дизайн-система',
  'settings.onboardingUsePrototype': '📱 Прототип / UI застосунку',
  'settings.onboardingUseLanding': '🌐 Лендінги',
  'settings.onboardingUseAds': '📣 Реклама / контент для соцмереж',
  'settings.onboardingUseDashboard': '📊 Дашборди / внутрішні інструменти',
  'settings.onboardingUseDeck': '🖥️ Презентація / слайди',
  'settings.onboardingUseMarketing': '📈 Маркетинг / зростання',
  'settings.onboardingUseEngineering': '🤝 Передача розробникам',
  'settings.onboardingUseAgency': '💼 Агенція / робота з клієнтами',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Налаштування',
  'settings.title': 'Режим виконання',
  'settings.subtitle': 'Виберіть локальний CLI або BYOK.',
  'settings.modeAria': 'Режим виконання',
  'settings.protocolAria': 'Протокол API',
  'settings.modeDaemon': 'Локальний CLI',
  'settings.modeDaemonHelp': 'Запуск через CLI кодового агента на вашому комп\'ютері',
  'settings.modeDaemonOffline': 'Фоновий процес не запущений',
  'settings.modeDaemonOfflineMeta': 'Фоновий процес офлайн',
  'settings.modeDaemonInstalledMeta': '{count} встановлено',
  'settings.modeApi': 'API-провайдер',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK не може читати, записувати чи редагувати файли проєкту. Використовуйте Local CLI, коли потрібні зміни в коді.',
  'settings.codeAgent': 'Кодовий агент',
  'settings.codeAgentHint': 'Виявляється за допомогою сканування вашого PATH. Виберіть CLI, через який мають проходити генерації.',
  'settings.rescan': '↻ Переканувати',
  'settings.rescanTitle': 'Повторно сканувати PATH',
  'settings.rescanRunning': 'Сканування...',
  'settings.rescanSuccess': 'Сканування завершено. Доступно: {count}.',
  'settings.designSystemRenameFailed': 'Не вдалося перейменувати. Перевірте фоновий процес і спробуйте ще раз.',
  'settings.rescanFailed': 'Сканування не вдалося. Перевірте фоновий процес і спробуйте ще раз.',
  'settings.test': 'Перевірити',
  'settings.testTitle': 'Надішліть крихітний тестовий запит для перевірки з’єднання',
  'settings.testRunning': 'Перевірка з’єднання…',
  'settings.byokReadyToTest': 'Готово до тесту',
  'settings.testCancel': 'Скасувати',
  'settings.testRetry': 'Повторити тест',
  'settings.required': 'обовʼязково',
  'settings.testMissingFields': 'Заповніть {fields}, щоб перевірити підключення.',
  'settings.testSuccessApi': 'З’єднано. Відповідь за {ms} мс — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} відповів за {ms} мс — \'{sample}\'',
  'settings.testAuthFailed': 'Помилка автентифікації. Перевірте ключ API.',
  'settings.testForbidden': 'Доступ заборонено. Перевірте обліковий запис, регіон або організацію.',
  'settings.testNotFoundModel': 'Модель \'{model}\' не знайдено на цій кінцевій точці.',
  'settings.testInvalidModelId': 'ID моделі \'{model}\' недійсний. Власний ID має починатися з літери або цифри й не містити пробілів.',
  'settings.testInvalidBaseUrl': 'Base URL недійсний або недоступний.',
  'settings.testRateLimited': 'Постачальник обмежив тест. Конфігурація виглядає правильною.',
  'settings.testUpstream': 'Постачальник повернув {status}. Спробуйте ще раз за мить.',
  'settings.testTimeout': 'Тест перервано за тайм-аутом після {ms} мс.',
  'settings.testAgentMissing': '{agentName} не встановлено або не знайдено в PATH.',
  'settings.testAgentSpawn': 'Не вдалося запустити {agentName}: {detail}.',
  'settings.testUnknown': 'Тест не виконано: {detail}',
  'settings.agentInstall.install': 'Встановити',
  'settings.agentInstall.docs': 'Документація',
  'settings.agentInstall.pathHint': 'Якщо ви встановили CLI через npm або Homebrew, але вона все ще відображається як не встановлена, переконайтеся, що bin-каталог інструмента є у PATH, який успадковує daemon Open Design (у macOS PATH у Terminal і GUI-застосунків може відрізнятися). Див. QUICKSTART.md (розділ "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Відкрийте Встановити або Документація для потрібного агента.',
  'settings.agentInstall.stepAuth': 'Пройдіть автентифікацію у CLI постачальника (увійдіть або додайте API-облікові дані), потім поверніться до Open Design.',
  'settings.agentInstall.stepRescan': 'Натисніть «Пересканувати» у цьому розділі.',
  'settings.agentInstall.stepSelect': 'Виберіть картку агента, коли він з\'явиться як встановлений.',
  'settings.noAgentsDetected': 'Агентів ще не виявлено. Встановіть один з: Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen або GitHub Copilot CLI, а потім натисніть Переканувати.',
  'settings.agentInstalledGroup': 'Ваші CLI ({count})',
  'settings.agentInstallGroup': 'Доступні для встановлення ({count})',
  'settings.agentAuthRequired': 'Потрібна автентифікація',
  'settings.agentAuthUnknown': 'Стан автентифікації невідомий',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'Авторизувати',
  'settings.amrBenefitOfficial': 'Офіційний',
  'settings.amrBenefitLowerPrice': 'Нижча вартість',
  'settings.amrBenefitManyModels': 'Багато моделей',
  'settings.amrPromoBonus': 'Обмежений бонус: +100%',
  'settings.amrSignInToContinue': 'Увійдіть, щоб продовжити',
  'settings.amrSignIn': 'Увійти',
  'settings.amrSignedIn': 'Виконано вхід',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': 'Вхід не виконано',
  'settings.amrSigningIn': 'Вхід…',
  'settings.amrActivationHint': 'Сторінка входу не відкрилася? Натисніть кнопку нижче, щоб відкрити її знову.',
  'settings.amrActivationBrowserFailed': 'Не вдалося відкрити браузер автоматично. Відкрийте сторінку входу нижче, щоб продовжити.',
  'settings.amrActivationOpen': 'Відкрити сторінку входу',
  'settings.amrCancelSignIn': 'Скасувати вхід',
  'settings.amrAccountStatus': 'Статус облікового запису Open Design Cloud',
  'settings.amrConsole': 'Керувати',
  'settings.amrBalance': 'Баланс',
  'settings.amrPlan': 'Тариф',
  'settings.amrUpgrade': 'Покращити',
  'settings.amrModelUpgradeHint': 'Оновіть, щоб використовувати',
  'settings.amrLoginErrorCompact': 'Не вдалося ввійти в Open Design Cloud.',
  'settings.advanced': 'Розширені',
  'settings.amrLogin': 'Увійти',
  'settings.amrLogout': 'Вийти',
  'settings.amrLoggingIn': 'Вхід…',
  'settings.amrLoggingOut': 'Вихід…',
  'settings.amrLoggedInAs': 'Виконано вхід як {email}',
  'settings.amrLoggedInWithPlan': 'Ви увійшли як {email} · {plan}',
  'settings.amrLoggedInPill': 'Виконано вхід',
  'settings.amrNotLoggedIn': 'Вхід не виконано',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Швидко заповнити провайдера',
  'settings.providerPreset': 'Пресет шлюзу',
  'settings.protocolGroupProtocols': 'Протоколи',
  'settings.protocolGroupGateways': 'Шлюзи',
  'settings.customProvider': 'Власний провайдер',
  'settings.apiKey': 'API-ключ',
  'settings.apiKeyGetLink': 'Отримати ключ ↗',
  'settings.showKey': 'Показати ключ',
  'settings.hideKey': 'Приховати ключ',
  'settings.show': 'Показати',
  'settings.hide': 'Приховати',
  'settings.model': 'Модель',
  'settings.apiKeyInvalid': 'Недійсний API key.',
  'settings.apiKeyCleaned': 'Зайві пробіли з API key видалено.',
  'settings.modelsLoadedFromAccount': '✓ Завантажено {count} моделей з вашого облікового запису.',
  'settings.modelsLoadedCount': '✓ Завантажено {count} моделей.',
  'settings.modelSourceAccount': 'З вашого облікового запису',
  'settings.modelSourceSuggested': 'Рекомендовано',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Низька вартість',
  'modelCost.halfToOne': 'Середня вартість',
  'modelCost.oneToFour': 'Висока вартість',
  'modelCost.overFour': 'Найвища вартість',
  'settings.fetchModels': 'Отримати моделі',
  'settings.fetchModelsTitle': 'Отримати доступні моделі від цього постачальника',
  'settings.fetchModelsRunning': 'Отримання моделей…',
  'settings.fetchModelsMissingFields': 'Заповніть {fields}, щоб отримати моделі.',
  'settings.fetchModelsInvalidBaseUrl': 'Введіть дійсний Base URL, щоб отримати моделі.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI використовує назви розгортань, тому виявлення моделей тут недоступне.',
  'settings.fetchModelsUnsupportedOllama': 'Виявлення моделей Ollama Cloud поки що недоступне. Виберіть або введіть модель.',
  'settings.fetchModelsSuccess': 'Отримано моделей: {count}.',
  'settings.fetchModelsEmpty': 'Сумісних текстових моделей не повернуто.',
  'settings.fetchModelsUnsupported': 'Виявлення моделей недоступне для цього протоколу.',
  'settings.fetchModelsFailed': 'Не вдалося отримати моделі: {detail}',
  'settings.suggestedModelsHint': 'Це рекомендовані моделі для цього протоколу. Ваш провайдер може підтримувати інші моделі.',
  'settings.baseUrl': 'Базовий URL',
  'settings.baseUrlInvalid': 'Використовуйте публічний URL з http:// або https://.',
  'settings.baseUrlCustomize': 'Налаштувати',
  'settings.baseUrlDefaultHint': 'Типовий кінцевий пункт. Зазвичай його не потрібно змінювати.',
  'settings.azureBaseUrlPlaceholder': 'Вставте URL кінцевої точки Azure',
  'settings.azureBaseUrlHint': 'Знайдіть це в порталі Azure → ваш ресурс → Endpoint.',
  'settings.azureDeploymentModel': 'Назва розгортання',
  'settings.azureCustomDeploymentName': 'Власна назва розгортання',
  'settings.azureDeploymentModelHint': 'Для Azure OpenAI це поле використовується як назва розгортання в /openai/deployments/<model>. Введіть назву розгортання, створену в Azure.',
  'settings.azureModelFetchHint': 'Введіть назву розгортання з вашого ресурсу Azure. Розгортання Azure не можна отримати автоматично.',
  'settings.apiVersion': 'Версія API',
  'settings.byokImageModel': 'Модель генерації зображень',
  'settings.byokVideoModel': 'Модель генерації відео',
  'settings.byokVideoI2vHint': 'Модель «зображення у відео»: потрібне референсне зображення (інакше використовується найновіше зображення проєкту)',
  'settings.byokSpeechModel': 'Модель синтезу мовлення',
  'settings.byokSpeechVoice': 'Голос',
  'settings.byokModelDefaultOption': 'За замовчуванням',
  'settings.maxTokens': 'Макс. токенів (необов\'язково)',
  'settings.maxTokensHint': 'Обмеження на довжину відповіді. Кожна модель має налаштовану за замовчуванням (показано в заповнювачі); залиште поле порожнім, щоб використовувати її, або введіть число, щоб переопрацювати.',
  'settings.apiHint': 'Запити надсилаються через локальний проксі daemon до вказаного Base URL. Ключ зберігається лише в цьому браузері й надсилається із запитами до провайдера.',
  'settings.skipForNow': 'Пропустити зараз',
  'settings.getStarted': 'Почати',
  'settings.envConfigure': 'Режим виконання',
  'settings.localCli': 'Локальний CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'агент не вибран',
  'settings.language': 'Мова',
  'settings.languageHint': 'Перемкніть мову інтерфейсу. Зберігається в цьому браузері.',
  'settings.appearance': 'Зовнішній вигляд',
  'settings.appearanceHint': 'Виберіть світлу, темну тему або дотримуйтеся системного параметра.',
  'settings.themeSystem': 'Системна',
  'settings.themeLight': 'Світла',
  'settings.themeDark': 'Темна',
  'settings.agentModelHead': 'Модель для:',
  'settings.modelPicker': 'Модель',
  'settings.modelSourceLive': 'Наживо з CLI',
  'settings.modelSourceFallback': 'Вбудований список',
  'settings.reasoningPicker': 'Інтенсивність міркувань',
  'settings.modelPickerHint': 'Отримується з CLI, коли він виявляє команду `models`. «За замовчуванням» залишає вибір конфігурації CLI; «Власна…» дозволяє ввести будь-яке ID моделі, яке приймає CLI.',
  'settings.modelPickerLiveHint': 'Моделі оновлено з установленого CLI. Типовий варіант і далі використовує конфігурацію CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Моделі оновлено з установленого CLI.',
  'settings.modelPickerFallbackHint': 'Показано вбудовані типові значення. Натисніть Переканувати, щоб отримати актуальні моделі з CLI.',
  'settings.cliEnvTitle': 'Додатково: проксі та власні шляхи',
  'settings.cliEnvHint': 'Використовуйте ці поля, щоб перевизначити середовище вибраної CLI: API key, proxy base URL, власні home-каталоги або нестандартні шляхи до бінарників. Без base URL CLI використовує свій endpoint за замовчуванням. Секрети залишаються в локальній конфігурації застосунку й передаються лише вибраній CLI.',
  'settings.cliEnvClaudeConfigDir': 'Каталог конфігурації Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL проксі Claude',
  'settings.cliEnvClaudeApiKey': 'API key Claude CLI',
  'settings.cliEnvCodexHome': 'Домашній каталог Codex',
  'settings.cliEnvCodexBin': 'Шлях до виконуваного файлу Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL проксі Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key Codex/OpenAI CLI',
  'settings.modelCustom': 'Власна (введіть нижче)…',
  'settings.modelCustomLabel': 'Власне ID моделі',
  'settings.modelCustomPlaceholder': 'напр. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Медіа-провайдери',
  'settings.mediaProvidersHint': 'API-ключі для генерації зображень, відео та аудіо. Зберігаються локально та синхронізуються з локальним фоновим процесом.',
  'settings.mcpServerTitle': 'MCP-сервер',
  'settings.mcpServerHint': 'Відкрийте Open Design як MCP-сервер для вашого кодинг-агента.',
  'settings.externalMcpTitle': 'Зовнішній MCP',
  'settings.externalMcpHint': 'Додайте MCP-інструменти із зовнішніх сервісів (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-ключ',
  'settings.mediaProviderBaseUrl': 'Базовий URL',
  'settings.mediaProviderConfigured': 'Налаштовано',
  'settings.mediaProviderUnset': 'Не встановлено',
  'settings.mediaProviderClear': 'Очистити',
  'settings.mediaProviderClearConfirm': 'Видалити збережені налаштування {name}? Вам доведеться ввести їх знову, щоб використовувати {name}.',
  'settings.mediaProviderPlaceholder': 'Вставте API-ключ',
  'settings.mediaProviderBaseUrlPlaceholder': 'Переопрацювати базовий URL за замовчуванням',
  'settings.mediaProviderReload': 'Перезавантажити з локального демона',
  'settings.mediaProviderReloadError': 'Не вдалося повторно завантажити налаштування медіапровайдерів із локального демона.',
  'settings.mediaProviderReloadSuccess': 'Налаштування медіапровайдерів повторно завантажено з локального демона.',
  'settings.mediaProviderLoadError': 'Не вдалося завантажити налаштування медіапровайдерів із локального демона. Наразі використовуються налаштування, збережені в браузері.',
  'settings.mediaProviderComingSoonHint': 'Ми відстежуємо їх у дорожній карті; демон ще не постачає клієнт, тому налаштовувати нічого.',
  'settings.privacy': 'Конфіденційність',
  'settings.privacyHint': 'Якими даними ми ділимося з командою Open Design',
  'settings.privacyConsentKicker': 'Допоможіть нам покращити Open Design',
  'settings.privacyConsentLead': 'Передавання даних про використання допомагає нам зрозуміти, як Open Design працює в реальних робочих процесах, щоб ми могли покращувати те, що найбільше впливає на ваш досвід.',
  'settings.privacyConsentFooter': 'Ви можете будь-коли змінити ці параметри в розділі Налаштування → Конфіденційність.',
  'settings.privacyConsentShare': 'Поділитися',
  'settings.privacyConsentDecline': 'Не ділитися',
  'settings.privacyConsentAccept': 'Зрозуміло',
  'settings.privacyConsentBannerFooter': 'Обмін даними ввімкнено за замовчуванням. Ви можете будь-коли вимкнути його в розділі Налаштування → Конфіденційність.',
  'settings.privacyConsentPolicyLink': 'Читати політику конфіденційності',
  'settings.privacyMetrics': 'Анонімні метрики',
  'settings.privacyMetricsHint': 'Кількість запусків, використання Token, частота помилок і тривалість як базові метрики використання.',
  'settings.privacyContent': 'Вміст розмови та інструментів',
  'settings.privacyContentHint': 'Після видалення секретів та іншої чутливої інформації ми використовуємо запити, відповіді асистента, вхідні/вихідні дані інструментів і контекст, потрібний для перевірки якості.',
  'settings.privacyInstallationId': 'Анонімний ID',
  'settings.privacyOptedOut': 'відмовлено',
  'settings.privacyDataDeletion': 'Видалити мої дані',
  'settings.privacyDataDeletionHint': 'Змінює ваш анонімний ID і припиняє надсилання. Наявні трасування застарівають згідно з нашою політикою зберігання.',
  'settings.about': 'Про програму',
  'settings.aboutHint': 'Деталі версії та виконання',
  'settings.appVersion': 'Версія',
  'settings.appChannel': 'Канал',
  'settings.appRuntime': 'Середовище виконання',
  'settings.appPlatform': 'Платформа',
  'settings.appArchitecture': 'Архітектура',
  'settings.runtimePackaged': 'Упакований додаток',
  'settings.runtimeDevelopment': 'Розробка',
  'settings.versionUnavailable': 'Деталі версії недоступні, поки фоновий процес перебуває в офлайні.',
  "settings.allowSilentUpdates": "Дозволити тихі оновлення",
  "settings.allowSilentUpdatesDesc": "Автоматично застосовувати завантажені payload-оновлення під час запуску. Оновлення через інсталятор і надалі потребують підтвердження.",
  'settings.installLatest': 'Встановити останню версію',
  'settings.alreadyLatest': 'У вас встановлена остання версія',
  'settings.updateCheck': 'Перевірити оновлення',
  'settings.updateNow': 'Оновити зараз',
  'settings.updateRecheck': 'Перевірити ще раз',
  'settings.updateRetry': 'Спробувати ще раз',
  'settings.updateViewReleases': 'Примітки до випуску',
  'settings.updateActionFailed': 'Не вдалося виконати дію оновлення.',
  'settings.updateQuitFailed': 'Інсталятор відкрито, але Open Design не зміг закритися автоматично.',
  'settings.updateStatusNotChecked': 'Ще не перевірено',
  'settings.updateStatusDevelopment': 'Розробницькі збірки не підтримують оновлення в застосунку.',
  'settings.updateStatusUnsupported': 'Це середовище не підтримує оновлення в застосунку.',
  'settings.updateStatusChecking': 'Перевірка оновлень...',
  'settings.updateStatusUpToDate': 'У вас уже остання версія.',
  'settings.updateStatusAvailable': 'Знайдено версію {version}. Підготовка завантаження.',
  'settings.updateStatusAvailableUnknown': 'Знайдено нову версію. Підготовка завантаження.',
  'settings.updateStatusDownloading': 'Завантаження оновлення...',
  'settings.updateStatusDownloadingPercent': 'Завантаження оновлення {percent}%.',
  'settings.updateStatusReady': 'Версія {version} готова до встановлення.',
  'settings.updateStatusReadyUnknown': 'Оновлення готове до встановлення.',
  'settings.updateStatusInstalling': 'Встановлення оновлення...',
  'settings.updateStatusFailed': 'Перевірка не вдалася. Спробуйте ще раз.',
  'settings.mcpTitle': 'Сервер MCP',
  'settings.mcpHint': 'Дозвольте кодовим агентам (Cursor, Claude Code, VS Code…) читати ваші проєкти Open Design безпосередньо.',
  'settings.mcpDaemonError': 'Не вдалося зв’язатися з локальним демоном, щоб визначити шляхи встановлення ({error}). Переконайтеся, що Open Design запущено, потім знову відкрийте цю панель.',
  'settings.mcpBuildDaemon': 'Спочатку зберіть демон.',
  'settings.mcpNodeMissing': 'Відсутній бінарний файл Node.',
  'settings.mcpBuildHint': 'Відсутній apps/daemon/dist/cli.js. Виконайте `pnpm --filter @open-design/daemon build` і оновіть.',
  'settings.mcpMethodCli': 'Команда CLI',
  'settings.mcpInstructionCli': 'Виконайте це у вашому терміналі.',
  'settings.mcpMethodToml': 'Конфігурація TOML',
  'settings.mcpInstructionCodex': 'Додайте цю таблицю до {path}. Та сама конфігурація використовується спільно для Codex CLI і розширення Codex IDE.',
  'settings.mcpMethodOneClick': 'Встановлення в один клік',
  'settings.mcpInstructionCursor': 'Натисніть «Install in Cursor», щоб встановити з діалогом підтвердження, або об’єднайте цей JSON у {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Встановити в Cursor',
  'settings.mcpMethodJson': 'Конфігурація JSON',
  'settings.mcpInstructionCopilot': 'Відкрийте палітру команд ({shortcut}), виконайте «MCP: Open User Configuration» і об’єднайте цей JSON. Copilot Chat має бути в режимі Agent, щоб інструменти з’явилися.',
  'settings.mcpInstructionAntigravity': 'В Antigravity: меню «...» панелі Agent → MCP Servers → Manage MCP Servers → View raw config. Об’єднайте цей JSON.',
  'settings.mcpInstructionZed': 'Відкрийте налаштування Zed ({shortcut}) і об’єднайте це з об’єктом верхнього рівня. Zed використовує «context_servers», а не «mcpServers».',
  'settings.mcpInstructionWindsurf': 'Відкрийте {path} (або скористайтеся піктограмою MCP у Cascade → Configure) і об’єднайте:',
  'settings.mcpCopyAria': 'Копіювати фрагмент конфігурації MCP',
  'settings.mcpResolvingFailed': '# не вдалося визначити шляхи, див. помилку вище',
  'settings.mcpLoadingPaths': '# завантаження шляхів встановлення з локального демона…',
  'settings.mcpCopied': 'Скопійовано',
  'settings.mcpCopy': 'Копіювати',
  'settings.mcpCursorApproval': 'Cursor показує діалог підтвердження перед записом конфігурації.',
  'settings.mcpCodexOneClickInstall': 'Встановити в Codex',
  'settings.mcpCodexOneClickUninstall': 'Видалити з Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI не знайдено в PATH — встановіть Codex або вставте фрагмент вручну.',
  'settings.mcpCodexInstallSuccess': 'Встановлено. Перезапустіть Codex, щоб завантажити новий сервер.',
  'settings.mcpCodexUninstallSuccess': 'Видалено з Codex.',
  'settings.mcpCodexBusy': 'Робота…',
  'settings.mcpCodexInstallError': 'Операція не вдалася: {error}',
  'settings.mcpRestartNote': 'Перезапустіть ваш клієнт, щоб підхопити новий сервер.',
  'settings.mcpRestartDetail': 'Більшість редакторів завантажують сервери MCP лише під час запуску. У Cursor / VS Code / Antigravity / Windsurf ви можете виконати `Developer: Reload Window` з палітри команд замість повного перезапуску. Zed і Claude Code потребують виходу та повторного відкриття.',
  'settings.mcpCapabilitiesTitle': 'Що вміє ваш agent',
  'settings.mcpCapabilityRead': 'Читати або шукати будь-який файл у проєкті (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Отримати дизайн-набір одним викликом: вхідний файл плюс кожну CSS-змінну, компонент і шрифт, на які він посилається.',
  'settings.mcpCapabilityDefault': 'За замовчуванням використовувати проєкт і файл, відкриті у вас в Open Design, тож ви можете сказати «build this in my app», не уточнюючи, який саме дизайн.',
  'settings.mcpRunningNote': 'Open Design має бути запущено, щоб виклики інструментів MCP були успішними. Якщо ви запустили свого agent з кодування до відкриття Open Design, перезапустіть agent, щоб він міг зв’язатися з активним демоном.',
  'entry.tabDesigns': 'Дизайни',
  'entry.tabTemplates': 'Шаблони',
  'entry.tabDesignSystems': 'Системи дизайну',
  'entry.tabConnectors': 'Конектори',
  'entry.openSettingsTitle': 'Налаштування',
  'entry.openSettingsAria': 'Відкрити налаштування',
  'entry.discordLabel': 'Приєднатися до Discord',
  'entry.discordAria': 'Приєднатися до Discord Open Design',
  'entry.discordAriaWithOnline': 'Приєднатися до Discord Open Design - {online}',
  'entry.discordOnlineLabel': '{count} онлайн',
  'entry.followXLabel': 'Стежити за @OpenDesignHQ в X',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'Стежити за @opendesign.ai в Instagram',
  'entry.followLinkedinLabel': 'Стежити за Open Design у LinkedIn',
  'entry.followXiaohongshuLabel': 'Стежити за Open Design у Xiaohongshu',
  'entry.resizeAria': 'Змінити розмір бічної панелі',
  'entry.loadingWorkspace': 'Завантаження робочого простору…',
  'entry.useEverywhereTitle': 'Використовувати скрізь',
  'entry.useEverywhereAria': 'Відкрити довідник «Використовувати скрізь» (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Workspace для команд — розкажіть, що потрібно вашій команді',
  'entry.workspaceTeamsAria': 'Відкрити сторінку Workspace для команд',
  'entry.navExpand': 'Розгорнути бічну панель',
  'entry.navCollapse': 'Згорнути бічну панель',
  'entry.navNewProject': 'Новий проєкт',
  'entry.navHome': 'Головна',
  'entry.navProjects': 'Проєкти',
  'entry.navTasks': 'Автоматизації',
  'entry.navPlugins': 'Плагіни',
  'entry.navDesignSystems': 'Дизайн-системи',
  'entry.navBrands': 'Бренд-кіт',
  'entry.navIntegrations': 'Інтеграції',
  'workspaceTabs.project': 'Проєкт',
  'workspaceTabs.pluginDetails': 'Деталі плагіна',
  'workspaceTabs.marketplace': 'Маркетплейс',
  'homeHero.title': 'Що ви спроєктуєте сьогодні?',
  'homeHero.startWithTemplate': 'Почати з шаблону…',
  'homeHero.startBlankProject': '…або створити порожній проєкт',
  'homeHero.templatePicker.label': 'Шаблон',
  'homeHero.templatePicker.searchPlaceholder': 'Пошук шаблонів',
  'homeHero.templatePicker.projectTypes': 'Типи проєктів',
  'homeHero.templatesScrollHint': 'Прокрутіть угору, щоб переглянути більше шаблонів',
  'homeHero.templatesCollapse': 'Згорнути шаблони',
  'homeHero.subtitlePrefix': 'Альтернатива Claude Design з відкритим кодом.',
  'homeHero.placeholder': 'Опишіть, що ви хочете згенерувати…',
  'homeHero.placeholderActive': 'Відредагуйте приклад запиту або напишіть власний…',
  'homeHero.carousel.hint': 'Прикріпіть файл, підключіть дизайн-систему або опишіть, що хочете створити',
  'homeHero.carousel.onePageBrief': 'Скласти односторінковий бриф проєкту',
  'homeHero.carousel.notesToDeck': 'Перетворити мої нотатки на презентацію',
  'homeHero.carousel.signupFlow': 'Зробити макет процесу реєстрації',
  'homeHero.carousel.improveBrief': 'Покращити наявний бриф проєкту',
  'homeHero.carousel.loadingAnimation': 'Створити анімацію завантаження',
  'homeHero.carousel.teamUpdateSlides': 'Оформити слайди для звіту команді',
  'homeHero.carousel.ordersDashboard': 'Зробити прототип дашборда для відстеження замовлень',
  'homeHero.carousel.productDetail': 'Зверстати сторінку товару',
  'homeHero.carousel.caseStudy': 'Накидати кейс-стаді',
  'homeHero.carousel.landingIntro': 'Розробити короткий вступ для лендингу',
  'homeHero.carousel.pitchDeck': 'Зробити пітч-дек для нового продукту',
  'homeHero.carousel.appIdea': 'Описати ідею застосунку',
  'homeHero.carousel.landingLayout': 'Накидати макет лендингу',
  'homeHero.skills': 'Навички',
  'homeHero.addMenu': 'Додати контекст',
  'homeHero.addPlugin': 'Додати плагін',
  'homeHero.addConnectors': 'Додати конектори',
  'homeHero.addMcp': 'Додати сервер MCP',
  'homeHero.noPlugins': 'Немає встановлених плагінів',
  'homeHero.noMcp': 'Немає серверів MCP',
  'homeHero.noConnectors': 'Немає підключених конекторів',
  'homeHero.applying': 'Застосування…',
  'homeHero.pluginTitle': 'Плагін: {title}',
  'homeHero.pluginPrefix': 'Плагін: {title}',
  'homeHero.skillPrefix': 'Навичка: {title}',
  'homeHero.removePlugin': 'Вилучити плагін',
  'homeHero.removePluginAria': 'Вилучити плагін {title}',
  'homeHero.clearActivePlugin': 'Очистити активний плагін',
  'homeHero.clearActiveSkill': 'Очистити активну навичку',
  'homeHero.contextItemsResolved': 'Вирішено елементів контексту: {n}',
  'homeHero.removeFile': 'Вилучити файл',
  'homeHero.contextSearchResults': 'Результати пошуку контексту',
  'homeHero.contextSurfaces': 'Поверхні контексту',
  'homeHero.loadingContext': 'Завантаження контексту…',
  'homeHero.noResults': 'Немає результатів для «{query}».',
  'homeHero.searchPrompt': 'Пошук файлів, плагінів, навичок, серверів MCP і конекторів.',
  'homeHero.parameters': 'Параметрів: {n}',
  'homeHero.details': 'Деталі',
  'homeHero.toRun': 'щоб запустити',
  'homeHero.forNewLine': 'для нового рядка',
  'homeHero.run': 'Запустити',
  'homeHero.typeSomethingToRun': 'Введіть щось, щоб запустити',
  'homeHero.promptExamples': 'Приклади',
  'homeHero.footer.designSystem': 'Стиль',
  'homeHero.footer.autoDesignSystem': 'Авто',
  'homeHero.footer.autoDesignSystemSummary': 'Автоматично добирає дизайн-систему й візуальний стиль для поточного промпта.',
  'homeHero.footer.ratio': 'Співвідношення',
  'homeHero.footer.duration': 'Тривалість',
  'homeHero.footer.resolution': 'Роздільність',
  'homeHero.footer.speakerNotes': 'Нотатки',
  'homeHero.footer.noSpeakerNotes': 'Без нотаток',
  'homeHero.footer.availableCount': 'Доступно: {n}',
  'homeHero.footer.noMatches': 'Немає збігів',
  'homeHero.moreShortcuts': 'Більше',
  'homeHero.railAria': 'Виберіть категорію проєкту або стартовий ярлик',
  'homeHero.subTypeAria': 'Виберіть підтип',
  'homeHero.subTypeMore': 'Ще',
  'homeHero.confirmReplaceTitle': 'Замінити поточний запит?',
  'homeHero.confirmReplaceBody': 'Використання {title} замінить текст, який зараз є у полі введення.',
  'homeHero.confirmReplace': 'Замінити',
  'homeHero.chip.prototype': 'Прототип',
  'homeHero.chip.webClone': 'Клон сайту',
  'homeHero.chip.liveArtifact': 'Живий артефакт',
  'homeHero.chip.deck': 'Презентація',
  'homeHero.chip.image': 'Зображення',
  'homeHero.chip.video': 'Відео',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL-досвід',
  'homeHero.chip.webglDesc': 'Шейдери, 3D і генеративна GPU-графіка',
  'homeHero.chip.worker': 'Worker-візуалізатор',
  'homeHero.chip.workerDesc': 'Симуляції поза потоком, частинки та візуалізація даних',
  'homeHero.chip.audio': 'Аудіо',
  'homeHero.chip.createBrandKit': 'Створити бренд-кіт',
  'homeHero.chip.createPlugin': 'Створити плагін',
  'homeHero.chip.figma': 'З Figma',
  'homeHero.chip.folder': 'З папки',
  'homeHero.chip.template': 'З шаблону',
  'homeHero.chip.liveArtifactHint': 'Створіть інтерактивний артефакт HTML/CSS/JS, який можна переглядати наживо.',
  'homeHero.chip.hyperframesHint': 'Створюйте анімацію на основі HTML: субтитри, візуалізації, що реагують на аудіо, переходи між сценами.',
  'homeHero.chip.createBrandKitHint': 'Видобудьте бренд-кіт із вебсайту й застосовуйте його в будь-якому чаті.',
  'homeHero.chip.createPluginHint': 'Створіть багаторазовий плагін Open Design і додайте його до «Мої плагіни».',
  'homeHero.chip.figmaHint': 'Перенесіть фрейм Figma в активну дизайн-систему.',
  'homeHero.chip.folderHint': 'Імпортуйте наявну локальну папку та продовжте редагування.',
  'homeHero.chip.templateHint': 'Почніть із вбудованого шаблону.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Папка',
  'workingDirPicker.homeTitle': 'Зберігається в локальному сховищі — натисніть, щоб вибрати папку',
  'workingDirPicker.processing': 'Обробка…',
  'workingDirPicker.select': 'Локальне сховище',
  'workingDirPicker.clearAria': 'Очистити робочий каталог',
  'workingDirPicker.replaceFailed': 'Не вдалося замінити робочий каталог',
  'workingDirPicker.unavailable': 'Вибір папки недоступний у цій збірці. Запустіть десктопний застосунок, щоб вибрати папку.',
  'workingDirPicker.openUnavailable': 'Відкрийте цей проєкт у десктопному застосунку, щоб показати папку.',
  'workingDirPicker.openFailed': 'Не вдалося показати цю папку',
  'workingDirPicker.showInFileManager': 'Показати у файловому менеджері',
  'workingDirPicker.replace': 'Вибрати папку…',
  'workingDirPicker.recent': 'Нещодавні каталоги',
  'workingDirPicker.defaultLabel': 'Локальне сховище',
  'handoff.toTarget': 'Передати в {target}',
  'handoff.openInTarget': 'Відкрити в {target}',
  'handoff.openAction': 'Відкрити',
  'handoff.menuTitle': 'У якому редакторі відкрити?',
  'handoff.action': 'Передати',
  'handoff.fallbackTitle': 'Редакторів у $PATH не знайдено — відкривається в {target}',
  'handoff.chooseTargetAria': 'Виберіть ціль передачі',
  'handoff.optionsAria': 'Параметри передачі',
  'handoff.editorSection': 'Відкрити в редакторі',
  'handoff.cliSection': 'Скопіювати для CLI',
  'handoff.clickOpen': 'Натисніть, щоб відкрити',
  'handoff.framework': 'Фреймворк коду',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'чистий JavaScript, HTML і CSS',
  'handoff.amrWebsite': 'Відкрити вебсайт Open Design Cloud',
  'handoff.copyPrompt': 'Скопіювати запит',
  'handoff.copyPromptForTarget': 'Скопіювати запит для {target}',
  'handoff.copied': 'Скопійовано',
  'handoff.projectPathUnavailable': 'Шлях до проєкту ще завантажується. Спробуйте за мить.',
  'handoff.copyFailed': 'Запис у буфер обміну заблоковано. Спробуйте за мить.',
  'handoff.promptIntro': 'Продовжити з цієї локальної папки проєкту Open Design:',
  'handoff.promptTarget': 'Ціль',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Ви перебираєте керування в {cli}. Будь ласка:',
  'handoff.promptReadFiles': 'Спершу увійдіть до цього каталогу або прочитайте його. Надайте пріоритет DESIGN.md, README, наявним HTML/CSS/JS, ресурсам і package.json, якщо вони є.',
  'handoff.promptKeepDesign': 'Збережіть поточний візуальний дизайн, макет, взаємодії та ресурси. Не зупиняйтеся на плані.',
  'handoff.promptProduceCode': 'Згенеруйте або змініть реальний робочий код {framework}. Якщо проєкт уже має чіткіший стек, зверніть увагу на конфлікт і збережіть результат робочим.',
  'handoff.promptVerify': 'Наприкінці повідомте мені команди для запуску, попереднього перегляду та перевірки.',
  'handoff.promptCommandHint': 'Щоб почати з каталогу проєкту, використовуйте:',
  'handoff.promptProject': 'Проєкт',
  'handoff.promptProjectId': 'ID проєкту',
  'handoff.notInstalled': 'Не встановлено',
  'handoff.notDetectedTitle': '{target} — не виявлено в $PATH',
  'designSystemPicker.select': 'Виберіть дизайн-систему',
  'designSystemPicker.loading': 'Завантаження дизайн-систем…',
  'designSystemPicker.searchPlaceholder': 'Пошук дизайн-систем (назва / категорія / опис)',
  'designSystemPicker.searchCompactPlaceholder': 'Пошук дизайн-систем',
  'designSystemPicker.noneTitle': 'Без дизайн-системи',
  'designSystemPicker.noneSummary': 'Дозволити моделі вибирати вільно',
  'designSystemPicker.empty': 'Немає відповідних дизайн-систем',
  'designSystemPicker.openPreview': 'Відкрити попередній перегляд',
  'designSystemPicker.loadingPreview': 'Завантаження попереднього перегляду…',
  'designSystemPicker.noPreview': 'Немає сторінки попереднього перегляду. Відкрийте «Дизайн-системи», щоб переглянути повну версію.',
  'designSystemPicker.previewHint': 'Наведіть курсор на дизайн-систему, щоб переглянути її',
  'designSystemPicker.fullscreenAria': 'Повноекранний попередній перегляд «{title}»',
  'designSystemPicker.closeFullscreen': 'Закрити повноекранний попередній перегляд',
  'designSystemPicker.closeEsc': 'Закрити (Esc)',
  'designSystemPicker.previewFrameTitle': 'Попередній перегляд «{title}»',
  'designSystemPicker.fullscreenFrameTitle': 'Повноекранний попередній перегляд «{title}»',
  'recentProjects.title': 'Нещодавні проєкти',
  'recentProjects.viewAll': 'Переглянути всі',
  'recentProjects.empty': 'Поки що немає проєктів — введіть запит, щоб створити перший.',
  'pluginsHome.title': 'Спільнота',
  'pluginsHome.subtitle': 'Готові до використання робочі процеси Open Design, що постачаються з цим середовищем виконання. Виберіть один, щоб завантажити початковий запит, або перегляньте реєстр для отримання інших.',
  'pluginsHome.browseRegistry': 'Огляд реєстру',
  'pluginsHome.count': '{filtered} з {total}',
  'pluginsHome.loadingCatalog': 'Завантаження каталогу…',
  'pluginsHome.emptyCatalog': 'Каталог порожній. Вбудовані плагіни постачаються разом з Open Design і мають з\'являтися тут автоматично — спробуйте перезапустити демон, якщо проблема не зникає.',
  'pluginsHome.emptyFiltered': 'Жоден плагін не відповідає поточним фільтрам.',
  'pluginsHome.clearFilters': 'Очистити фільтри',
  'pluginsHome.modeAria': 'Режим плагіна',
  'pluginsHome.featured': 'Збережено',
  'pluginsHome.totalInCatalog': '{n} у каталозі',
  'pluginsHome.categoryFilterAria': 'Фільтр за категорією',
  'pluginsHome.subcategoryFilterAria': 'Фільтр за підкатегорією {label}',
  'pluginsHome.allCategory': 'Усі {label}',
  'pluginsHome.searchPlaceholder': 'Пошук плагінів…',
  'pluginsHome.searchAria': 'Пошук плагінів',
  'pluginsHome.clearSearch': 'Очистити пошук',
  'pluginsHome.sortAria': 'Порядок сортування',
  'pluginsHome.sortHot': 'Популярні',
  'pluginsHome.sortNewest': 'Найновіші',
  'pluginsHome.facet.import': 'Імпортувати',
  'pluginsHome.facet.create': 'Створити',
  'pluginsHome.facet.export': 'Експортувати',
  'pluginsHome.facet.share': 'Поділитися',
  'pluginsHome.facet.deploy': 'Розгорнути',
  'pluginsHome.facet.refine': 'Уточнити',
  'pluginsHome.facet.extend': 'Розширити',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Код / папка',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Знімок екрана',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Слайди',
  'pluginsHome.facet.publicLink': 'Публічне посилання',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Дашборди',
  'pluginsHome.subfacet.app-prototypes': 'Застосунки',
  'pluginsHome.subfacet.landing-marketing': 'Лендінги / маркетинг',
  'pluginsHome.subfacet.developer-tools': 'Інструменти розробника',
  'pluginsHome.subfacet.docs-reports': 'Документи / звіти',
  'pluginsHome.subfacet.brand-design': 'Бренд / дизайн',
  'pluginsHome.subfacet.pitch-business': 'Пітч / бізнес',
  'pluginsHome.subfacet.course-training': 'Курси / навчання',
  'pluginsHome.subfacet.reports-briefings': 'Звіти / брифінги',
  'pluginsHome.subfacet.product-sales': 'Продукт / продажі',
  'pluginsHome.subfacet.engineering-talks': 'Технічні доповіді',
  'pluginsHome.subfacet.creative-decks': 'Креативні презентації',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / мокапи',
  'pluginsHome.subfacet.brand-visuals': 'Бренд / логотип',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Розкадровки',
  'pluginsHome.subfacet.social-content': 'Соцмережі / контент',
  'pluginsHome.subfacet.avatar-portrait': 'Аватар / портрет',
  'pluginsHome.subfacet.illustration-style': 'Ілюстрація / стиль',
  'pluginsHome.subfacet.motion-effects': 'Моушн / ефекти',
  'pluginsHome.subfacet.social-short-form': 'Соцмережі / короткі відео',
  'pluginsHome.subfacet.marketing-product': 'Маркетинг / продукт',
  'pluginsHome.subfacet.data-explainers': 'Дані / пояснення',
  'pluginsHome.subfacet.cinematic-story': 'Кіно / історії',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Переглядайте встановлені робочі процеси, знаходьте записи в реєстрі, керуйте джерелами та готуйте плагіни до розповсюдження в команді.',
  'pluginsView.importPlugin': 'Імпортувати плагін',
  'pluginsView.agentContext': 'Контекст Agent',
  'pluginsView.summaryAria': 'Зведення плагіна',
  'pluginsView.areasAria': 'Області плагіна',
  'pluginsView.loading': 'Завантаження плагінів…',
  'pluginsView.tab.installed': 'Встановлені',
  'pluginsView.tab.available': 'Доступні',
  'pluginsView.tab.sources': 'Джерела',
  'pluginsView.tab.team': 'Команда',
  'pluginsView.tabHint.installed': 'Ваші плагіни',
  'pluginsView.tabHint.available': 'З джерел',
  'pluginsView.tabHint.sources': 'Каталоги',
  'pluginsView.tabHint.team': 'Підприємство',
  'pluginsView.installedTitle': 'Встановлені плагіни',
  'pluginsView.installedSubtitle': 'Плагіни, які ви імпортували або встановили з джерел маркетплейсу.',
  'pluginsView.installedEmpty': 'Ще немає встановлених користувацьких плагінів. Скористайтеся «Створити / Імпортувати» або встановіть запис із розділу «Доступні».',
  'pluginsView.availableTitle': 'Доступні з джерел',
  'pluginsView.availableSubtitle': 'Записи каталогу, знайдені в налаштованих маркетплейсах.',
  'pluginsView.availableFiltersAria': 'Фільтри доступних плагінів',
  'pluginsView.searchAvailableAria': 'Пошук доступних плагінів',
  'pluginsView.searchAvailablePlaceholder': 'Пошук доступних плагінів',
  'pluginsView.clearAvailableSearch': 'Очистити пошук доступних плагінів',
  'pluginsView.source': 'Джерело',
  'pluginsView.availableEmptyInstalled': 'Доступних записів поки немає. Встановлені записи каталогу вилучаються з розділу «Доступні»; видаліть один, щоб він знову став доступним.',
  'pluginsView.availableEmptyFiltered': 'Жоден доступний запис не відповідає вашим фільтрам.',
  'pluginsView.availableEmptyNoSources': 'Доступних записів поки немає. Додайте джерело на вкладці «Джерела».',
  'pluginsView.installing': 'Встановлення…',
  'pluginsView.install': 'Встановити',
  'pluginsView.sourcesTitle': 'Джерела реєстру',
  'pluginsView.sourcesSubtitle': 'Каталоги маркетплейсу, що наповнюють розділ доступних плагінів.',
  'pluginsView.sourceUrl': 'URL джерела',
  'pluginsView.defaultTrust': 'Довіра за замовчуванням',
  'pluginsView.trust.restricted': 'Обмежено',
  'pluginsView.trust.trusted': 'Довірене',
  'pluginsView.trust.official': 'Офіційне',
  'pluginsView.adding': 'Додавання…',
  'pluginsView.addSource': 'Додати джерело',
  'pluginsView.sourcesEmpty': 'Джерела реєстру ще не налаштовано.',
  'pluginsView.pluginsCount': 'Плагінів: {n}',
  'pluginsView.catalogVersion': 'каталог v{version}',
  'pluginsView.trustFor': 'Довіра для {name}',
  'pluginsView.refreshing': 'Оновлення…',
  'pluginsView.removing': 'Видалення…',
  'pluginsView.teamTitle': 'Приватні командні маркетплейси',
  'pluginsView.teamBody': 'Ця область зарезервована для корпоративних і командних каталогів, приватних політик довіри та спільного керування життєвим циклом плагінів.',
  'pluginCard.details': 'Деталі',
  'pluginCard.use': 'Використати',
  'pluginCard.useWithQuery': 'Використати із запитом',
  'pluginCard.applying': 'Застосування…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Створення remix…',
  'pluginCard.duplicateFailed': 'Не вдалося зробити remix цього шаблону.',
  'pluginCard.saved': 'Збережено',
  'pluginCard.publish': 'Опублікувати',
  'pluginCard.contribute': 'Зробити внесок',
  'pluginCard.starting': 'Запуск…',
  'pluginCard.detailsAria': 'Переглянути деталі для {title}',
  'pluginCard.chooseUseAria': 'Виберіть, як використовувати {title}',
  'pluginCard.useOptionsAria': 'Параметри використання для {title}',
  'pluginCard.duplicateAria': 'Зробити remix {title} як новий проєкт',
  'pluginCard.saveAria': 'Зберегти {title}',
  'pluginCard.savedAria': '{title} збережено',
  'pluginCard.shareAria': 'Поділитися {title}',
  'pluginCard.publishAria': 'Опублікувати {title} як репозиторій GitHub',
  'pluginCard.publishTitle': 'Опублікувати плагін як репозиторій GitHub',
  'pluginCard.contributeAria': 'Зробити внесок {title} у Open Design',
  'pluginCard.contributeTitle': 'Зробити внесок плагіна у Open Design через pull request',
  'skillPluginCandidate.createForMe': 'Створити плагін/шаблон',
  'skillPluginCandidate.contributeToMain': 'Зробити внесок в open-design',
  'skillPluginCandidate.repoDescription': 'Схоже, цей репозиторій може працювати як плагін.',
  'integrations.kicker': 'Інтеграція',
  'integrations.lede': 'Підключайте зовнішні системи, додавайте інструменти MCP до циклу роботи агента та використовуйте Open Design з інших IDE, скриптів та автоматизацій.',
  'integrations.agentReady': 'Готово для агента',
  'integrations.areasAria': 'Області інтеграції',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Навички',
  'integrations.tabHint.mcp': 'Зовнішні інструменти',
  'integrations.tabHint.connectors': 'Облікові записи та API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Інтеграції навичок',
  'integrations.skillsBody': 'Керування інтеграцією на рівні навичок переноситься з іншої гілки. Ця вкладка зарезервована, щоб налаштування MCP, конекторів і майбутніх навичок знаходилися в одному маршруті Integration.',
  'mcpClient.title': 'Зовнішні сервери MCP',
  'mcpClient.subtitle': 'Сторонні інструменти для вашого агента кодування.',
  'mcpClient.addServer': 'Додати сервер',
  'mcpClient.emptyTitle': 'Серверів MCP не налаштовано.',
  'mcpClient.emptyBody': 'Натисніть «Додати сервер», щоб почати — виберіть шаблон (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) або налаштуйте власний stdio / HTTP сервер.',
  'mcpClient.saveChanges': 'Зберегти зміни',
  'mcpClient.storedAt': 'Зберігається в',
  'mcpClient.daemonError': 'Не вдалося звʼязатися з локальним демоном. Переконайтеся, що Open Design запущено, потім знову відкрийте цю панель.',
  'mcpClient.saveFailed': 'Не вдалося зберегти. Перевірте, чи запущено демон, і спробуйте ще раз.',
  'useEverywhere.modalAria': 'Використовуйте Open Design всюди',
  'useEverywhere.modalTitle': 'Використовуйте Open Design всюди',
  'useEverywhere.modalSubtitle': 'Інтегруйте Open Design у будь-яке IDE, Agent або скрипт — CLI, HTTP, MCP та Skills. Скористайтеся «Скопіювати посібник для Agent» і вставте у Claude Code, Codex, Cursor, openclaw або hermes, щоб налаштувати все.',
  'useEverywhere.closeAria': 'Закрити «використовувати всюди»',
  'useEverywhere.closeTitle': 'Закрити (Esc)',
  'useEverywhere.tabsAria': 'Поверхні інтеграції',
  'useEverywhere.footStrong': 'Передача в один клік.',
  'useEverywhere.footBody': 'Копіює структурований markdown-посібник, з яким ваш Agent може одразу працювати — встановити, перевірити та використати.',
  'useEverywhere.configureMcp': 'Налаштувати сервер MCP',
  'useEverywhere.copyGuide': 'Копіювати посібник для агента',
  'useEverywhere.copy': 'Копіювати',
  'useEverywhere.copied': 'Скопійовано',
  'useEverywhere.copyFailed': 'Не вдалося скопіювати',
  'useEverywhere.copySnippetAria': 'Скопіювати фрагмент: {label}',
  'useEverywhere.section.overview.tab': 'Огляд',
  'useEverywhere.section.overview.heading': 'Open Design працює всюди, де працює ваш agent',
  'useEverywhere.section.overview.intro': 'Open Design — це більше, ніж просто вікно: це локальний привілейований демон (`od`) плюс реєстр Skills + Design-Systems + Atoms. Щойно він запущений на вашій машині, будь-який кодовий Agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, ваш власний скрипт) може керувати генераціями, перевіряти проєкти та створювати дизайн-артефакти через чотири взаємозамінні інтерфейси.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` для безголових скриптів, CI та автоматизації в оболонці.',
  'useEverywhere.section.overview.bullet2': 'MCP сервер — підключає Open Design як сервер Model Context Protocol, щоб будь-який Agent з підтримкою MCP міг переглядати навички, запускати сценарії та читати артефакти.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE кінцеві точки; той самий інтерфейс, який використовує вебінтерфейс.',
  'useEverywhere.section.overview.bullet4': 'Skills — готові до використання пакети `SKILL.md` (сумісні з Claude), які будь-який Agent уже у вашому PATH може викликати взагалі без Open Design.',
  'useEverywhere.section.overview.bullet5': 'Стандартні артефакти — створюйте реальні HTML-проєкти з Skills, вбудованих типових плагінів та прикладів плагінів спільноти ще до запуску демона.',
  'useEverywhere.section.overview.snippet1': 'Запустіть daemon (і веб-інтерфейс) локально',
  'useEverywhere.section.overview.snippet2': 'Переконайтеся, що він доступний',
  'useEverywhere.section.overview.snippet3': 'Завантажте стандартні артефакти перед запуском',
  'useEverywhere.section.overview.footer': 'За замовчуванням daemon записує дані в `./.od/` (локально в проєкті). Встановіть `OD_DATA_DIR=~/.open-design`, щоб спільно використовувати дані між проєктами.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Керуйте Open Design з будь-якої оболонки',
  'useEverywhere.section.cli.intro': 'Бінарний файл `od` постачається разом із daemon і є тим самим бінарним файлом, який використовують Claude Code / Codex під час генерації. Більшість підкоманд — це тонкі клієнти, що надсилають POST до локального daemon, тому вони працюють однаково незалежно від того, чи запустили ви його через `pnpm tools-dev`, чи як зібраний застосунок.',
  'useEverywhere.section.cli.bullet1': '`od` (без аргументів) — запускає демон і відкриває вебінтерфейс.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — створює байти зображення / відео / аудіо через уніфікований медіапротокол.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — запускає виконання проєкту з підказки + навички.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — встановлює та застосовує плагіни спільноти.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — перегляд того, що доступно локально.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — перевіряє стан демона та виявляє CLI агентів у вашому PATH.',
  'useEverywhere.section.cli.snippet1': 'Згенерувати зображення (делегує налаштованому провайдеру медіа)',
  'useEverywhere.section.cli.snippet2': 'Запустити плагін сценарію в безголовому режимі та транслювати події як рядки JSON',
  'useEverywhere.section.cli.snippet3': 'Перелічити локально доступні навички та дизайн-системи',
  'useEverywhere.section.cli.snippet4': 'Перевірити завантажені артефакти через CLI',
  'useEverywhere.section.cli.snippet5': 'Перевірити середовище + виявлені агенти (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Усі підкоманди приймають `--daemon-url http://127.0.0.1:<port>`, щоб звернутися до конкретного запущеного демона — корисно під час запуску ізольованого другого екземпляра для тестів.',
  'useEverywhere.section.mcp.tab': 'Сервер MCP',
  'useEverywhere.section.mcp.heading': 'Надайте Open Design як сервер MCP будь-якому agent для кодування',
  'useEverywhere.section.mcp.intro': 'Open Design постачається із сервером Model Context Protocol (`od mcp`), який дозволяє будь-якому клієнту з підтримкою MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — виявляти інструменти Open Design (перегляд навичок, рендеринг попередніх переглядів, генерація медіа, запуск плагінів) без ручного виклику через оболонку. Демон публікує готовий до вставлення фрагмент для встановлення через `GET /api/mcp/install-info` для кожного основного клієнта.',
  'useEverywhere.section.mcp.bullet1': 'Транспорт stdio — без додаткового порту, клієнт безпосередньо запускає `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Автоматично виявляє URL активного daemon через локальний сокет статусу IPC, коли запущено як sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Повертається до `--daemon-url http://127.0.0.1:<port>` для звичайних інсталяцій, щоб процес MCP завжди знаходив запущений daemon.',
  'useEverywhere.section.mcp.bullet4': 'Закріплює `OD_DATA_DIR`, щоб породжений процес MCP записував у те саме місце, яке вже використовує daemon (уникає EPERM у зібраних пакетах застосунків macOS).',
  'useEverywhere.section.mcp.snippet1': 'Загальна конфігурація клієнта MCP (працює в Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Або: запитайте у daemon фрагмент, адаптований до вашої інсталяції',
  'useEverywhere.section.mcp.snippet3': 'Варіант MCP для живих артефактів (читання та оновлення дашбордів)',
  'useEverywhere.section.mcp.footer': 'У застосунку Open Design відкрийте Налаштування → Інтеграції, щоб скопіювати команду встановлення для конкретного клієнта (Cursor, Claude Code, Antigravity, VS Code) замість ручного редагування JSON.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Той самий інтерфейс REST + SSE, який використовує веб-інтерфейс',
  'useEverywhere.section.http.intro': 'Локальний daemon надає HTTP API за адресою `http://127.0.0.1:7456` (порт можна налаштувати). Кожна кінцева точка, яку викликає веб-інтерфейс, також доступна для ваших скриптів. Потокові кінцеві точки (повідомлення чату, запуски проєктів) надсилають Server-Sent Events із типами контракту з `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — активність демона.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` та `GET /api/design-systems` — доступні реєстри.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` та `POST /api/projects` — перегляд і створення проєктів (POST повертає проєкт + першу розмову).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — SSE-потік подій Agent для розмови.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — прив\'язує встановлений плагін і отримує його відрендерений приклад запиту + вхідні дані.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — виявлені CLI кодових агентів у вашому PATH.',
  'useEverywhere.section.http.snippet1': 'Перелічити встановлені навички (agent використовуватиме їх як шаблони)',
  'useEverywhere.section.http.snippet2': 'Створити проєкт із запиту (повний серверний процес)',
  'useEverywhere.section.http.snippet3': 'Передавати потоком хід розмови (SSE — кожен рядок сумісний з JSON-Lines)',
  'useEverywhere.section.http.footer': 'Чисті типи TypeScript для кожного запиту/відповіді розміщені в `@open-design/contracts` — імпортуйте їх у свій скрипт для повного автодоповнення без налаштування генератора.',
  'useEverywhere.section.skills.tab': 'Навички та безголовий режим',
  'useEverywhere.section.skills.heading': 'Готові до використання Skills для будь-якого Agent — навіть без запущеного Open Design',
  'useEverywhere.section.skills.intro': 'Skill — це каталог із сумісним з Claude файлом `SKILL.md` (YAML front-matter + тіло). Open Design розширює формат простором імен `od:` (`mode`, `preview`, `design_system`, `inputs`, …), тож той самий артефакт можна використовувати як усередині Open Design, так і звичайним Agent на кшталт Claude Code, Codex, openclaw або hermes. Виявлення відбувається за ланцюжком пріоритетів, тож проєкти можуть перевизначати власні навички.',
  'useEverywhere.section.skills.bullet1': 'Виявлення: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (проєкт має перевагу).',
  'useEverywhere.section.skills.bullet2': 'Створіть символічне посилання на одну навичку в кількох проєктах, щоб спільно використовувати її без копіювання.',
  'useEverywhere.section.skills.bullet3': 'Кожна навичка може оголошувати конектори, атоми, вимоги до дизайн-системи та приклад вихідних даних `preview` для галереї.',
  'useEverywhere.section.skills.bullet4': 'Безголовий режим: agent із `od` у своєму PATH може викликати `od skills list`, а потім запустити будь-яку навичку; daemon необов\'язковий для процесів лише для читання.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` опрацьовує ту саму форму артефакту з прикладами плагінів за замовчуванням та прикладами плагінів спільноти, а потім зберігає отримані проєкти `index.html` як багаторазові тестові дані.',
  'useEverywhere.section.skills.snippet1': 'Мінімальний SKILL.md (front matter, сумісний із Claude + додатки Open Design)',
  'useEverywhere.section.skills.snippet2': 'Створити символічне посилання на спільну навичку в проєкті (у стилі cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Безголовий режим: перелічити навички, які daemon бачить зараз',
  'useEverywhere.section.skills.snippet4': 'Пакет фікстур артефактів для безголового режиму',
  'useEverywhere.section.skills.footer': 'Специфікація: `docs/skills-protocol.md` і `docs/agent-adapters.md` охоплюють повний інтерфейс адаптерів (Claude Code, Codex, Cursor, agent із підтримкою MCP, резервний варіант BYOK API) та стратегії впровадження навичок для кожного адаптера.',
  'tasks.kicker': 'Робочий простір автоматизації',
  'tasks.comingSoon': 'Незабаром',
  'tasks.lede': 'Автоматизації перетворюють запити на стійку роботу: Orbit запускає їх, routines зберігають їх, schedules вирішують, коли вони спрацьовують, а живі артефакти показують, що змінилося.',
  'tasks.newAutomation': 'Нова автоматизація',
  'tasks.previewNote': 'Лише попередній інтерфейс. Налаштування Orbit доступні вже сьогодні; routines, schedules та підключення живих артефактів з\'являться в міру злиття серверних гілок.',
  'tasks.primitivesAria': 'Примітиви автоматизації',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Постійне середовище виконання для тривалої або повторюваної роботи agent.',
  'tasks.primitive.orbit.enabled': 'Щоденне зведення увімкнено',
  'tasks.primitive.orbit.manualOnly': 'Лише вручну',
  'tasks.primitive.routines.title': 'Рутини',
  'tasks.primitive.routines.body': 'Стійкі визначення завдань, що зберігаються після завершення окремого чату.',
  'tasks.primitive.routines.meta': 'Оболонка продукту готова',
  'tasks.primitive.schedules.title': 'Розклади',
  'tasks.primitive.schedules.body': 'Тригери за часом або подіями, що вирішують, коли має запускатися routine.',
  'tasks.primitive.schedules.meta': 'Гілка в очікуванні',
  'tasks.primitive.liveArtifacts.title': 'Живі артефакти',
  'tasks.primitive.liveArtifacts.body': 'Звіти та нотатки, що продовжують оновлюватися, поки agent працює.',
  'tasks.primitive.liveArtifacts.meta': 'Модель попереднього перегляду',
  'tasks.listAria': 'Список автоматизацій',
  'tasks.routinesAndRuns': '{n} routines та запусків',
  'tasks.filtersAria': 'Фільтри автоматизацій',
  'tasks.filter.scheduled': 'Заплановано',
  'tasks.filter.running': 'Виконується',
  'tasks.filter.done': 'Готово',
  'tasks.configurationAria': 'Налаштування автоматизації',
  'tasks.slot.trigger': 'Тригер',
  'tasks.slot.pattern': 'Шаблон',
  'tasks.slot.runtime': 'Середовище виконання',
  'tasks.slot.output': 'Вивід',
  'tasks.liveArtifact': 'Живий артефакт',
  'tasks.viewProgress': 'Переглянути прогрес',
  'tasks.pause': 'Призупинити',
  'tasks.runNow': 'Запустити зараз',
  'tasks.openArtifact': 'Відкрити артефакт',
  'tasks.status.dailyAt': 'Щодня · {time}',
  'tasks.status.pausedManual': 'Призупинено · лише вручну',
  'tasks.sample.orbit.title': 'Щоденне зведення конекторів Orbit',
  'tasks.sample.orbit.metaEnabled': 'Дайджест конекторів заплановано',
  'tasks.sample.orbit.metaDisabled': 'Відкрийте налаштування Orbit, щоб увімкнути',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · живий артефакт',
  'tasks.sample.orbit.previewDisabled': 'Запусків не заплановано',
  'tasks.sample.orbit.triggerEnabled': 'Розклад · щодня о {time}',
  'tasks.sample.orbit.triggerDisabled': 'Вручну · запуск за потреби',
  'tasks.sample.orbit.pattern': 'Рутина · дайджест конекторів',
  'tasks.sample.orbit.runtime': 'Orbit · за розкладом демона',
  'tasks.sample.orbit.output': 'Живий артефакт · оновлюваний звіт',
  'tasks.sample.orbit.artifactMetaEnabled': 'Оновлюється після кожного запуску',
  'tasks.sample.orbit.artifactMetaDisabled': 'Очікування розкладу',
  'tasks.sample.orbit.body1': '# Щоденне зведення активності Orbit',
  'tasks.sample.orbit.body2': 'Конектори перевірено · успіхи, пропуски та збої',
  'tasks.sample.orbit.body3': 'Ключові моменти стають живим артефактом, що оновлюється.',
  'tasks.sample.mcp.title': 'Дослідження альтернатив MCP',
  'tasks.sample.mcp.status': 'Виконується в orbit · 2 год 14 хв',
  'tasks.sample.mcp.meta': 'Оброблено 14 / 30 джерел',
  'tasks.sample.mcp.preview': 'research_notes.md · наживо',
  'tasks.sample.mcp.trigger': 'Вручну · одноразово',
  'tasks.sample.mcp.pattern': 'Запит для глибокого дослідження',
  'tasks.sample.mcp.runtime': 'Віддалено · постійно',
  'tasks.sample.mcp.output': 'Живий звіт · автооновлення',
  'tasks.sample.mcp.artifactMeta': 'Оновлено 12 с тому',
  'tasks.sample.mcp.body1': '# Альтернативи MCP — проміжні висновки',
  'tasks.sample.mcp.body2': 'Переглянуто 14 джерел · 3 претенденти у короткому списку',
  'tasks.sample.mcp.body3': '## Короткий список',
  'tasks.sample.mcp.body4': '- Схеми викликів інструментів через JSON-RPC...',
  'tasks.sample.mcp.body5': '- Протоколи Agent на основі gRPC...',
  'tasks.sample.weekly.title': 'Щотижневий дайджест команди',
  'tasks.sample.weekly.status': 'Далі: пн 9:00',
  'tasks.sample.weekly.meta': 'Оновлює щотижневий документ команди',
  'tasks.sample.weekly.preview': 'team_weekly.md · наступний артефакт',
  'tasks.sample.weekly.trigger': 'Розклад · щотижня',
  'tasks.sample.weekly.pattern': 'Рутина · дайджест команди',
  'tasks.sample.weekly.runtime': 'Віддалено · повторюваний',
  'tasks.sample.weekly.output': 'Живий артефакт · markdown',
  'tasks.sample.weekly.artifactMeta': 'Востаннє оновлено 4 дн тому',
  'tasks.sample.weekly.body1': '# Команда за тиждень',
  'tasks.sample.weekly.body2': '## У роботі',
  'tasks.sample.weekly.body3': '- Прохід інтеграції дизайн-системи',
  'tasks.sample.weekly.body4': '- Перевірка якості конекторів',
  'tasks.sample.weekly.body5': '## Ризики',
  'tasks.sample.pr.title': 'Нагадування про рецензування PR',
  'tasks.sample.pr.status': 'При новому PR · спрацював 23 хв тому',
  'tasks.sample.pr.meta': 'Надсилає особисте повідомлення в Slack',
  'tasks.sample.pr.preview': 'Остання доставка успішна',
  'tasks.sample.pr.trigger': 'Подія · новий PR',
  'tasks.sample.pr.pattern': 'Рутина · сповіщення',
  'tasks.sample.pr.runtime': 'Локально · швидкий запуск',
  'tasks.sample.pr.output': 'Повідомлення · особисте в Slack',
  'tasks.sample.pr.artifactMeta': 'Востаннє спрацював 23 хв тому',
  'tasks.sample.pr.body1': 'Відкрито PR #184 для рецензування',
  'tasks.sample.pr.body2': 'Підібрані рецензенти: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Доставка: особисте повідомлення в Slack надіслано',
  'tasks.sample.meeting.title': 'Підготовка до зустрічі',
  'tasks.sample.meeting.status': 'Завтра · 10:00',
  'tasks.sample.meeting.meta': 'Одноразово · надсилає підсумок',
  'tasks.sample.meeting.preview': 'meeting_brief.md · у черзі',
  'tasks.sample.meeting.trigger': 'Розклад · одноразовий',
  'tasks.sample.meeting.pattern': 'Запит для брифінгу',
  'tasks.sample.meeting.runtime': 'Віддалено · обмежений',
  'tasks.sample.meeting.output': 'Артефакт + повідомлення',
  'tasks.sample.meeting.artifactMeta': 'У черзі на генерацію',
  'tasks.sample.meeting.body1': '# Бриф зустрічі',
  'tasks.sample.meeting.body2': 'Джерело порядку денного: подія календаря + пов’язані документи',
  'tasks.sample.meeting.body3': 'Вивід міститиме рішення, перешкоди та запитання.',
  'tasks.sample.candidate.title': 'Відстеження кандидатів',
  'tasks.sample.candidate.status': 'Помилка · потребує уваги',
  'tasks.sample.candidate.meta': 'Термін авторизації минув',
  'tasks.sample.candidate.preview': 'Повторно підключіть Greenhouse, щоб відновити',
  'tasks.sample.candidate.trigger': 'Розклад · щодня',
  'tasks.sample.candidate.pattern': 'Рутина · синхронізація кандидатів',
  'tasks.sample.candidate.runtime': 'Віддалено · повторюваний',
  'tasks.sample.candidate.output': 'Живий артефакт · таблиця',
  'tasks.sample.candidate.artifactMeta': 'Призупинено до відновлення авторизації',
  'tasks.sample.candidate.body1': '# Конвеєр кандидатів',
  'tasks.sample.candidate.body2': 'Остання успішна синхронізація: 2 дн тому',
  'tasks.sample.candidate.body3': 'Потрібна дія: повторно підключіть обліковий запис джерела.',
  'routines.title': 'Автоматизації',
  'routines.subtitle': 'Заплановані автоматизації, що виконуються без нагляду.',
  'routines.newAutomation': 'Нова автоматизація',
  'routines.loading': 'Завантаження…',
  'routines.empty': 'Автоматизацій ще немає.',
  'routines.emptyHint': 'Натисніть «Нова автоматизація», щоб запланувати автономний запуск агента.',
  'routines.runHistoryLoading': 'Завантаження запусків…',
  'routines.runHistoryEmpty': 'Запусків ще немає.',
  'routines.fieldName': 'Назва',
  'routines.fieldNamePlaceholder': 'Ранкове зведення',
  'routines.fieldPrompt': 'Запит',
  'routines.fieldPromptPlaceholder': 'Отримати вчорашню активність у GitHub + Linear і підсумувати, що змінилося.',
  'routines.fieldSchedule': 'Розклад',
  'routines.fieldMinute': 'Хвилина кожної години',
  'routines.fieldTime': 'Час',
  'routines.fieldTimezone': 'Часовий пояс',
  'routines.fieldsetProject': 'Проєкт',
  'routines.kind.hourly': 'Щогодини',
  'routines.kind.daily': 'Щодня',
  'routines.kind.weekdays': 'Будні',
  'routines.kind.weekly': 'Щотижня',
  'routines.weekday.short.0': 'Нд',
  'routines.weekday.short.1': 'Пн',
  'routines.weekday.short.2': 'Вт',
  'routines.weekday.short.3': 'Ср',
  'routines.weekday.short.4': 'Чт',
  'routines.weekday.short.5': 'Пт',
  'routines.weekday.short.6': 'Сб',
  'routines.weekday.long.0': 'Неділя',
  'routines.weekday.long.1': 'Понеділок',
  'routines.weekday.long.2': 'Вівторок',
  'routines.weekday.long.3': 'Середа',
  'routines.weekday.long.4': 'Четвер',
  'routines.weekday.long.5': 'П’ятниця',
  'routines.weekday.long.6': 'Субота',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Запускається щогодини о :{minute}',
  'routines.describe.daily': 'Запускається щодня о {time} {tz}',
  'routines.describe.weekdays': 'Запускається пн–пт о {time} {tz}',
  'routines.describe.weekly': 'Запускається що{day} о {time} {tz}',
  'routines.modeCreate': 'Створювати новий проєкт при кожному запуску',
  'routines.modeCreateHint': 'Новий ізольований робочий простір при кожному спрацюванні.',
  'routines.modeReuse': 'Використовувати наявний проєкт',
  'routines.modeReuseHint': 'Кожен запуск існує як нова розмова всередині проєкту.',
  'routines.pickProject': '— Виберіть проєкт —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ новий проєкт за кожного запуску',
  'routines.tagPaused': 'призупинено',
  'routines.metaNext': 'наступний: {when}',
  'routines.metaLast': 'останній:',
  'routines.triggerManual': 'вручну',
  'routines.triggerScheduled': 'за розкладом',
  'routines.openProject': 'Відкрити проєкт',
  'routines.openProjectTitle': 'Відкрити проєкт, до якого записав цей запуск',
  'routines.runNow': 'Запустити зараз',
  'routines.edit': 'Редагувати',
  'routines.pause': 'Призупинити',
  'routines.resume': 'Відновити',
  'routines.history': 'Історія',
  'routines.hideHistory': 'Сховати історію',
  'routines.delete': 'Видалити',
  'routines.deleteTitle': 'Видалити цю автоматизацію',
  'routines.cancel': 'Скасувати',
  'routines.save': 'Зберегти',
  'routines.saving': 'Збереження…',
  'routines.create': 'Створити',
  'routines.creating': 'Створення…',
  'routines.status.queued': 'у черзі',
  'routines.status.running': 'виконується',
  'routines.status.succeeded': 'успішно',
  'routines.status.failed': 'невдало',
  'routines.status.canceled': 'скасовано',
  'routines.confirmDelete': 'Видалити цю автоматизацію? Минулі запуски та їхні проєкти буде збережено.',
  'routines.errorPickProject': 'Виберіть проєкт для повторного використання або перемкніться на «Створювати новий за кожного запуску»',
  'routines.errorAgentEmptyOutput': 'Agent завершив роботу, не створивши жодного результату. Модель або провайдер міг повернути порожню відповідь — перевірте журнали agent на наявність помилок із боку джерела.',
  'entry.helpAria': 'Довідка',
  'entry.helpMenuAria': 'Меню довідки',
  'entry.helpGetHelp': 'Отримати допомогу на GitHub',
  'entry.helpSubmitFeature': 'Запропонувати функцію',
  'entry.helpWhatsNew': 'Що нового',
  'entry.helpDownloadDesktop': 'Завантажити настільний застосунок',
  'entry.githubStarLabel': 'Зірка',
  'entry.githubStarTitle': 'Поставте нам зірку на GitHub',
  'entry.githubStarAria': 'Поставити Open Design зірку на GitHub',
  'entry.tabImageTemplates': 'Шаблони зображень',
  'entry.tabVideoTemplates': 'Шаблони відеороликів',
  'promptTemplates.searchPlaceholder': 'Пошук шаблонів…',
  'promptTemplates.countLabel': '{n} результатів',
  'promptTemplates.emptyImage': 'Шаблонів підказок для зображень ще не встановлено.',
  'promptTemplates.emptyVideo': 'Шаблонів підказок для відео ще не встановлено.',
  'promptTemplates.emptyNoMatch': 'Немає шаблонів, що відповідають вашому пошуку.',
  'promptTemplates.attributionFooter': 'Адаптовано з публічних бібліотек підказок. Кожна картка посилається на автора.',
  'promptTemplates.openPreviewTitle': 'Відкрити підказку та попередній перегляд',
  'promptTemplates.sourcePrefix': 'Джерело:',
  'promptTemplates.fetchError': 'Не вдалося завантажити текст цього шаблону.',
  'promptTemplates.promptLabel': 'Текст підказки',
  'promptTemplates.copyPrompt': 'Копіювати підказку',
  'promptTemplates.copyDone': 'Скопійовано!',
  'promptTemplates.modelHint': 'Рекомендована модель: {model}',
  'promptTemplates.openSource': 'Переглянути оригінал',
  'promptTemplates.openFullscreen': 'Відкрити попередній перегляд у повноекранному режимі',
  'promptTemplates.closeFullscreen': 'Закрити попередній перегляд у повноекранному режимі',
  'promptTemplates.allSources': 'Усі джерела',
  'promptTemplates.sourceFilterAria': 'Фільтрувати за джерелом',
  'promptTemplates.retry': 'Повторити',
  'connectors.title': 'Конектори',
  'connectors.subtitle': 'Локальні та майбутні джерела даних, які можуть живити live-артефакти.',
  'connectors.account': 'Обліковий запис',
  'connectors.noAccount': 'Не підключено',
  'connectors.tools': 'Інструменти',
  'connectors.connect': 'Підключити',
  'connectors.disconnect': 'Відключити',
  'connectors.authorizationPending': 'Очікування авторизації...',
  'connectors.authorizationPendingHint': 'Завершіть авторизацію у відкритому вікні.',
  'connectors.cancelAuthorization': 'Скасувати',
  'connectors.configure': 'Налаштувати',
  'connectors.unavailable': 'Недоступно',
  'connectors.phaseStubTitle': 'API конекторів зʼявляться у фазі 3; це поверхня попереднього перегляду.',
  'connectors.statusAvailable': 'Доступно',
  'connectors.statusConnected': 'Підключено',
  'connectors.statusError': 'Помилка',
  'connectors.statusDisabled': 'Вимкнено',
  'connectors.gateTitle': 'Додайте ключ Composio API, щоб продовжити',
  'connectors.gateBody': 'Вставте ключ вище й натисніть «Зберегти ключ», щоб завантажити доступні інтеграції.',
  'connectors.aboutLabel': 'Про',
  'connectors.detailsLabel': 'Деталі',
  'connectors.statusLabel': 'Статус',
  'connectors.category.aiAgents': 'AI-агенти',
  'connectors.category.aiInfrastructure': 'AI-інфраструктура',
  'connectors.category.accounting': 'Бухгалтерія',
  'connectors.category.admin': 'Адміністрування',
  'connectors.category.advertising': 'Реклама',
  'connectors.category.analytics': 'Аналітика',
  'connectors.category.automation': 'Автоматизація',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Календар',
  'connectors.category.commerce': 'Комерція',
  'connectors.category.communication': 'Комунікації',
  'connectors.category.contacts': 'Контакти',
  'connectors.category.dataPlatform': 'Платформа даних',
  'connectors.category.database': 'База даних',
  'connectors.category.design': 'Дизайн',
  'connectors.category.developer': 'Інструменти розробника',
  'connectors.category.documentation': 'Документація',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Освіта',
  'connectors.category.email': 'Пошта',
  'connectors.category.events': 'Події',
  'connectors.category.fieldService': 'Виїзне обслуговування',
  'connectors.category.finance': 'Фінанси',
  'connectors.category.fitness': 'Фітнес',
  'connectors.category.forms': 'Форми',
  'connectors.category.gaming': 'Ігри',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Гостинність',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Інтеграція',
  'connectors.category.localization': 'Локалізація',
  'connectors.category.logistics': 'Логістика',
  'connectors.category.maps': 'Карти',
  'connectors.category.marketing': 'Маркетинг',
  'connectors.category.media': 'Медіа',
  'connectors.category.meetings': 'Зустрічі',
  'connectors.category.nonprofit': 'Неприбуткові',
  'connectors.category.observability': 'Спостережуваність',
  'connectors.category.payments': 'Платежі',
  'connectors.category.personal': 'Особисте',
  'connectors.category.presentations': 'Презентації',
  'connectors.category.procurement': 'Закупівлі',
  'connectors.category.product': 'Продукт',
  'connectors.category.productivity': 'Продуктивність',
  'connectors.category.projectManagement': 'Керування проєктами',
  'connectors.category.recruiting': 'Рекрутинг',
  'connectors.category.research': 'Дослідження',
  'connectors.category.salesIntelligence': 'Аналітика продажів',
  'connectors.category.scheduling': 'Планування',
  'connectors.category.search': 'Пошук',
  'connectors.category.security': 'Безпека',
  'connectors.category.signing': 'Підписання',
  'connectors.category.social': 'Соціальні мережі',
  'connectors.category.spreadsheets': 'Таблиці',
  'connectors.category.storage': 'Сховище',
  'connectors.category.support': 'Підтримка',
  'connectors.category.surveys': 'Опитування',
  'connectors.category.tasks': 'Завдання',
  'connectors.category.timeTracking': 'Облік часу',
  'connectors.category.video': 'Відео',
  'connectors.category.whiteboard': 'Дошка',
  'connectors.categoryLabel': 'Категорія',
  'connectors.providerLabel': 'Провайдер',
  'connectors.toolsSection': 'Інструменти',
  'connectors.toolsLoading': 'Завантаження інструментів…',
  'connectors.noToolsAvailable': 'Інструментів ще немає. Підключіться, щоб дізнатися, що надає ця інтеграція.',
  'connectors.toolDetailsUnavailable': 'Деталі інструментів недоступні, але цей конектор повідомляє про {n} інструментів.',
  'connectors.loadMoreTools': 'Завантажити більше інструментів',
  'connectors.openDetailsAria': 'Відкрити деталі {name}',
  'connectors.toolsBadgeNone': 'Немає інструментів',
  'connectors.toolsBadgeOne': '{n} інструмент',
  'connectors.toolsBadgeMany': '{n} інструментів',
  'connectors.searchPlaceholder': 'Пошук конекторів…',
  'connectors.searchAriaLabel': 'Пошук конекторів за назвою, провайдером або інструментом',
  'connectors.searchClear': 'Очистити пошук',
  'connectors.emptyNoMatchTitle': 'Немає конекторів для “{query}”',
  'connectors.emptyNoMatchBody': 'Спробуйте інше ключове слово або очистіть пошук, щоб переглянути весь каталог.',
  'connectors.emptyNoMatchAction': 'Очистити пошук',
  'newproj.tabPrototype': 'Прототип',
  'newproj.tabLiveArtifact': 'Live-артефакт',
  'newproj.tabDeck': 'Презентація',
  'newproj.tabTemplate': 'З шаблону',
  'newproj.tabMedia': 'Медіа',
  'newproj.tabOther': 'Інше',
  'newproj.titlePrototype': 'Новий прототип',
  'newproj.titleLiveArtifact': 'Новий live-артефакт',
  'newproj.titleDeck': 'Нова презентація',
  'newproj.titleTemplate': 'Почати з шаблону',
  'newproj.titleImage': 'Нове зображення',
  'newproj.titleVideo': 'Новий відеоролик',
  'newproj.titleAudio': 'Новий звуковий файл',
  'newproj.titleMedia': 'Новий медіафайл',
  'newproj.titleOther': 'Новий проект',
  'newproj.namePlaceholder': 'Назва проекту',
  'newproj.fidelityLabel': 'Деталізація',
  'newproj.fidelityWireframe': 'Каркас інтерфейсу',
  'newproj.fidelityHigh': 'Висока деталізація',
  'newproj.toggleSpeakerNotes': 'Використовувати нотатки доповідача',
  'newproj.toggleSpeakerNotesHint': 'Менше тексту на слайдах — основні моменти зберігаються в нотатках.',
  'newproj.toggleAnimations': 'Включити анімації',
  'newproj.toggleAnimationsHint': 'Додати рух (вхід, наведення, переходи) поверх шаблону.',
  'newproj.targetPlatformsLabel': 'Цільові платформи',
  'newproj.targetPlatformsHint': 'Виберіть одну або кілька. Адаптивний веб охоплює лише точки зупину браузера; додайте iOS, Android, планшетний застосунок або десктопний застосунок для нативних кросплатформних варіантів.',
  'newproj.platform.responsive.label': 'Адаптивний веб',
  'newproj.platform.responsive.hint': 'Один веб-досвід, адаптований для десктопних, планшетних і мобільних браузерів',
  'newproj.platform.webDesktop.label': 'Десктопний веб',
  'newproj.platform.webDesktop.hint': 'Продукт або цільова сторінка, орієнтовані на браузер',
  'newproj.platform.mobileIos.label': 'Застосунок для iOS',
  'newproj.platform.mobileIos.hint': 'Фрейми iPhone і правила взаємодії iOS',
  'newproj.platform.mobileAndroid.label': 'Застосунок для Android',
  'newproj.platform.mobileAndroid.hint': 'Фрейми Pixel і правила взаємодії Material',
  'newproj.platform.tablet.label': 'Планшетний застосунок',
  'newproj.platform.tablet.hint': 'Планшетний досвід у нативному стилі з розділеними поданнями',
  'newproj.platform.desktopApp.label': 'Десктопний застосунок',
  'newproj.platform.desktopApp.hint': 'Оформлення застосунку macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Супутні поверхні',
  'newproj.includeLandingPage': 'Додати цільову сторінку',
  'newproj.includeLandingPageHint': 'Додайте адаптивну маркетингову сторінку для реклами, списків очікування, кампаній запуску, завантажень застосунку або опису продукту.',
  'newproj.includeOsWidgets': 'Додати віджети ОС',
  'newproj.includeOsWidgetsHint': 'Додайте нативні для платформи віджети головного екрана, екрана блокування або швидкого доступу для мобільних/планшетних застосунків.',
  'newproj.includeOsWidgetsDisabledHint': 'Доступно, коли як цільову платформу вибрано застосунок для iOS, Android або планшета.',
  'newproj.templateLabel': 'Шаблон',
  'newproj.noTemplatesTitle': 'Шаблони ще не створені',
  'newproj.noTemplatesBody': 'Відкрийте будь-який проект, а потім за допомогою меню Поділитися всередині переглядача файлів перетворіть його на шаблон. Шаблони з\'являтимуться тут.',
  'newproj.savedTemplate': 'Збережений шаблон',
  'newproj.fileSingular': 'файл',
  'newproj.filePlural': 'файли',
  'newproj.create': 'Створити',
  'newproj.locationLabel': 'Зберегти в',
  'newproj.locationDefault': 'Проєкти Open Design',
  'newproj.locationExternalBase': 'Зовнішня база',
  'newproj.createLiveArtifact': 'Створити live-артефакт',
  'newproj.createFromTemplate': 'Створити з шаблону',
  'newproj.createDisabledTitle': 'Спочатку збережіть проект як шаблон (меню Поділитися всередині будь-якого проекту).',
  'newproj.importClaudeZip': 'Імпортувати Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Імпортувати експорт Claude Design .zip',
  'newproj.importingClaudeZip': 'Імпортування…',
  'newproj.privacyFooter': 'За замовчуванням лише ви можете переглянути свій проект.',
  'newproj.designSystem': 'Система дизайну',
  'newproj.dsNoneFreeform': 'Без — власний варіант',
  'newproj.dsNoneSubtitleEmpty': 'Без системних токенів, виберіть свою палітру',
  'newproj.dsNoneSubtitleSelected': 'Пропустити системні токени. Агент вибирає свою палітру.',
  'newproj.dsCategoryFallback': 'Система дизайну',
  'newproj.dsSearch': 'Пошук систем дизайну…',
  'newproj.dsModeAria': 'Режим вибору',
  'newproj.dsModeSingle': 'Одна',
  'newproj.dsModeMulti': 'Кілька',
  'newproj.dsNoneTitle': 'Без — власний варіант',
  'newproj.dsNoneSub': 'Пропустити системні токени. Агент вибирає свою палітру.',
  'newproj.dsEmpty': 'Системи дизайну, що відповідають "{query}", не знайдені.',
  'newproj.dsFootSingular': 'є лише натхненням.',
  'newproj.dsFootPlural': 'є лише натхненням.',
  'newproj.dsFootClear': 'Очистити',
  'newproj.dsBadgeDefault': 'ТИПОВА',
  'newproj.dsPrimaryFallback': 'Основна',
  'newproj.surfaceImage': 'Зображення',
  'newproj.surfaceVideo': 'Відеоролик',
  'newproj.surfaceAudio': 'Аудіо',
  'newproj.modelLabel': 'Модель',
  'newproj.modelSearch': 'Пошук моделей…',
  'newproj.modelEmpty': 'Жодних збігів.',
  'newproj.modelRecommended': 'Рекомендовано',
  'newproj.modelMissingTitle': 'Виберіть модель',
  'newproj.modelMissingSub': 'Виберіть модель для цієї поверхні.',
  'newproj.aspectLabel': 'Пропорція',
  'newproj.videoLengthLabel': 'Тривалість',
  'newproj.videoLengthSeconds': '{n}с',
  'newproj.audioKindLabel': 'Тип аудіо',
  'newproj.audioKindMusic': 'Музика',
  'newproj.audioKindSpeech': 'Мовлення / TTS',
  'newproj.audioKindSfx': 'Звукові ефекти',
  'newproj.audioDurationLabel': 'Тривалість',
  'newproj.audioDurationSeconds': '{n}с',
  'newproj.voiceLabel': 'Голос',
  'newproj.voicePlaceholder': 'ID голосу провайдера, необов\'язково',
  'newproj.connectorsLabel': 'Конектори',
  'newproj.connectorsHint': 'Надайте агенту доступ до підключених джерел даних для цього live-артефакту.',
  'newproj.connectorsEmptyTitle': 'Поки що немає підключених конекторів',
  'newproj.connectorsEmptyBody': 'Підключіть джерело даних у вкладці Конектори, а потім поверніться, щоб додати його до цього артефакту.',
  'newproj.connectorsEmptyCta': 'Перейти до Конекторів',
  'newproj.connectorsLoading': 'Завантаження конекторів…',
  'newproj.connectorsCountOne': '{n} конектор',
  'newproj.connectorsCountMany': '{n} конекторів',
  'newproj.connectorsManage': 'Керувати конекторами',
  'newproj.promptTemplateLabel': 'Шаблон для посилання',
  'newproj.promptTemplateNoneTitle': 'Жоден — напишіть власний',
  'newproj.promptTemplateNoneSub': 'Пропустити галерею, описати власний брифінг',
  'newproj.promptTemplateRefSub': 'Шаблон для посилання',
  'newproj.promptTemplateSearch': 'Пошук шаблонів…',
  'newproj.promptTemplateEmpty': 'Для цієї поверхні ще не встановлено жодних шаблонів.',
  'newproj.promptTemplateBodyLabel': 'Підказка (ви можете налаштувати)',
  'newproj.promptTemplateOptimizeHint': 'Редагуйте що завгодно — ваші зміни переносяться в брифінг агента.',
  'newproj.promptTemplateBodyEmpty': 'Порожній текст — агент не отримає посилання на шаблон.',
  'newproj.deleteTemplateTitle': 'Видалити шаблон',
  'newproj.deleteTemplateConfirm': 'Видалити «{name}»? Цю дію не можна скасувати.',
  'newproj.deleteTemplateConfirmCta': 'Видалити шаблон',
  'newproj.deleteTemplateError': 'Не вдалося видалити цей шаблон. Спробуйте ще раз.',
  'designs.subRecent': 'Нещодавні',
  'designs.subYours': 'Ваші дизайни',
  'designs.filterAria': 'Фільтрувати проекти',
  'designs.searchPlaceholder': 'Пошук…',
  'designs.emptyNoProjects': 'Проектів ще немає.',
  'designs.emptyNoMatch': 'Проектів, що відповідають пошуку, не знайдено.',
  'designs.deleteTitle': 'Видалити проект',
  'designs.deleteConfirm': 'Видалити "{name}"?',
  'designs.cardFreeform': 'власний варіант',
  'designs.badgeLive': 'Наживо',
  'designs.liveArtifactBadgesAria': 'Мітки live-артефакту',
  'designs.liveCount': '{n} live-артефактів',
  'designs.statusLive': 'Живий артефакт',
  'designs.statusArchived': 'Архівовано',
  'designs.statusError': 'Помилка',
  'designs.statusRefreshing': 'Оновлення',
  'designs.statusRefreshFailed': 'Оновлення не вдалося',
  'designs.statusRefreshed': 'Оновлено',
  'designs.status.notStarted': 'Не розпочато',
  'designs.status.queued': 'У черзі',
  'designs.status.running': 'Виконується',
  'designs.status.awaitingInput': 'Чекає підтвердження',
  'designs.status.succeeded': 'Завершено',
  'designs.status.published': 'Опубліковано',
  'designs.status.failed': 'Помилка',
  'designs.status.canceled': 'Скасовано',
  'designs.viewToggleAria': 'Режим перегляду',
  'designs.viewGrid': 'Вигляд сітки',
  'designs.viewKanban': 'Вигляд дошки',
  'designs.kanbanEmptyColumn': 'Немає дизайнів',
  'designs.deleteAria': 'Видалити проект {name}',
  'designs.menuMore': 'Більше дій',
  'designs.menuRename': 'Перейменувати',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Видалити',
  'designs.renamePrompt': 'Нова назва для «{name}»',
  'designs.selectMode': 'Вибрати',
  'designs.cancelSelect': 'Скасувати',
  'designs.deleteSelected': 'Видалити вибране',
  'designs.selectedCount': 'Вибрано: {n}',
  'designs.deleteSelectedConfirm': 'Видалити проєкти ({n})?',
  'designs.deleteSelectedSuccess': 'Проєкти ({n}) успішно видалено.',
  'designs.deleteSelectedPartial': 'Видалено проєктів: {deleted}; не вдалося: {failed}.',
  'designs.tagPrototype': 'Прототип',
  'designs.tagLiveArtifact': 'Живий артефакт',
  'designs.tagSlide': 'Слайд',
  'designs.tagMedia': 'Медіа',
  'designs.renameTitle': 'Перейменувати проєкт',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Скасувати',
  'examples.typeLabel': 'Тип',
  'examples.surfaceLabel': 'Приклади',
  'examples.surfaceWeb': 'Веб',
  'examples.surfaceImage': 'Зображення',
  'examples.surfaceVideo': 'Відеоролик',
  'examples.surfaceAudio': 'Аудіо',
  'examples.scenarioLabel': 'Кейс використання',
  'examples.modeAll': 'Все',
  'examples.modePrototypeDesktop': 'Прототипи · Комп\'ютер',
  'examples.modePrototypeMobile': 'Прототипи · Мобільний',
  'examples.modeDeck': 'Слайди',
  'examples.modeDocument': 'Документи та шаблони',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Наживо',
  'examples.scenarioGeneral': 'Загальне',
  'examples.scenarioEngineering': 'Інженерія',
  'examples.scenarioProduct': 'Продукт',
  'examples.scenarioDesign': 'Дизайн',
  'examples.scenarioMarketing': 'Маркетинг',
  'examples.scenarioSales': 'Продажі',
  'examples.scenarioFinance': 'Фінанси',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Операції',
  'examples.scenarioSupport': 'Підтримка',
  'examples.scenarioLegal': 'Юридичні послуги',
  'examples.scenarioEducation': 'Освіта',
  'examples.scenarioPersonal': 'Особисте',
  'examples.searchPlaceholder': 'Пошук прикладів…',
  'examples.searchAria': 'Пошук прикладів за назвою',
  'examples.emptyNoSkills': 'Навички недоступні. Чи запущений фоновий процес?',
  'examples.emptyNoMatch': 'Приклади, що відповідають цим фільтрам, не знайдені.',
  'examples.openPreview': '⤢ Відкрити попередній перегляд',
  'examples.loadingPreview': 'Завантаження попереднього перегляду…',
  'examples.hoverPreview': 'Наведіть мишею для попереднього перегляду',
  'examples.usePrompt': 'Використовувати цю підказку',
  'examples.previewModalTitle': 'Відкрити повний попередній перегляд (модальне вікно)',
  'examples.shareTitle': 'Поділитися цим прикладом',
  'examples.shareLoadFirst': 'Спочатку наведіть мишею, щоб завантажити попередній перегляд',
  'examples.unavailablePlaceholder': 'Немає вбудованого попереднього перегляду {kind} — відкрийте, щоб дізнатися більше',
  'examples.shareUnavailable': 'Немає вбудованого попереднього перегляду {kind} для надсилання',
  'examples.shareMenu': 'Поділитися ▾',
  'examples.exportPdfAllSlides': 'Експортувати як PDF (усі слайди)',
  'examples.exportPptxLocked': 'Експортувати як PPTX… (спочатку відкрийте шаблон)',
  'examples.tagSlideDeck': 'Презентація',
  'examples.tagTemplate': 'Шаблон',
  'examples.tagDesignSystem': 'Система дизайну',
  'examples.tagMobilePrototype': 'Мобільний прототип',
  'examples.tagDesktopPrototype': 'Прототип комп\'ютера',
  'examples.tagImage': 'Зображення',
  'examples.tagVideo': 'Відеоролик',
  'examples.tagAudio': 'Аудіо',
  'examples.previewLabel': 'Попередній перегляд',
  'ds.surfaceLabel': 'Приклади',
  'ds.surfaceWeb': 'Веб',
  'ds.surfaceImage': 'Зображення',
  'ds.surfaceVideo': 'Відеоролик',
  'ds.surfaceAudio': 'Аудіо',
  'ds.searchPlaceholder': 'Пошук систем дизайну…',
  'ds.emptyNoMatch': 'Системи дизайну, що відповідають пошуку, не знайдені.',
  'ds.badgeDefault': 'ТИПОВА',
  'ds.preview': 'Попередній перегляд',
  'ds.previewTitle': 'Попередній перегляд системи дизайну',
  'ds.categoryAll': 'Все',
  'ds.categoryUncategorized': 'Без категорії',
  'ds.showcase': 'Витрина',
  'ds.tokens': 'Токени',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Завантаження DESIGN.md…',
  'avatar.title': 'Обліковий запис та налаштування',
  'avatar.localCli': 'Локальний CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Використовувати локальний CLI',
  'avatar.useApi': 'Використовувати API · BYOK',
  'avatar.codeAgent': 'Кодовий агент',
  'avatar.rescan': 'Переканувати PATH',
  'avatar.amrConsole': 'Обліковий запис Open Design Cloud',
  'avatar.amrConsoleMeta': 'Баланс і поповнення',
  'avatar.settings': 'Налаштування',
  'avatar.backToProjects': 'Назад до проектів',
  'avatar.metaActive': 'активно',
  'avatar.metaOffline': 'вимкнено',
  'avatar.metaSelected': 'вибрано',
  'avatar.noAgentSelected': 'агент не вибран',
  'avatar.modelSection': 'Модель',
  'avatar.modelLabel': 'Модель',
  'avatar.reasoningLabel': 'Міркування',
  'avatar.customSuffix': '(власна)',
  'socialShare.openDesignSection': 'Поділитися Open Design',
  'socialShare.openDesignTitle': 'Open Design на GitHub',
  'socialShare.openDesignText': 'Open Design — це робочий простір з відкритим кодом для створення, редагування, розгортання та передавання дизайн-артефактів.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'ПОДІЛИТИСЯ В СОЦМЕРЕЖАХ',
  'socialShare.publishPageTitle': 'Опублікувати сторінку для поширення',
  'socialShare.publishPageSubtitle': 'Опублікуйте цей перегляд, щоб ним можна було поділитися в соцмережах.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Створено за допомогою Open Design: {title}. Перегляньте розгорнутий артефакт і поставте зірку репозиторію: {repo}',
  'socialShare.projectCopyText': 'Створено за допомогою Open Design: {title}\n{url}\nРепозиторій Open Design: {repo}',
  'socialShare.deployFirst': 'Розгорнути, а потім поділитися…',
  'socialShare.copied': 'Скопійовано',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Перемкнути CLI / модель',
  'inlineSwitcher.chipCli': 'Локальна CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'за замовчуванням',
  'inlineSwitcher.noAgent': 'агент не вибрано',
  'inlineSwitcher.modeLabel': 'Режим',
  'inlineSwitcher.agentLabel': 'Агент',
  'inlineSwitcher.providerLabel': 'Провайдер',
  'inlineSwitcher.modelLabel': 'Модель',
  'inlineSwitcher.useCli': 'Використовувати локальну CLI',
  'inlineSwitcher.useByok': 'Використовувати власний API-ключ',
  'inlineSwitcher.daemonOffline': 'Демон офлайн — відкрийте налаштування',
  'inlineSwitcher.noAgentsDetected': 'CLI не знайдено в PATH',
  'inlineSwitcher.openSettingsForModel': 'Налаштуйте провайдера в Налаштуваннях',
  'inlineSwitcher.missingApiKey': 'Не задано API-ключ — відкрийте Налаштування.',
  'inlineSwitcher.openFullSettings': 'Відкрити налаштування виконання',
  'inlineSwitcher.customSuffix': '(власна)',
  'project.backToProjects': 'Назад до проектів',
  'project.brandReadyTitle': 'Дизайн-система {name} готова',
  'project.brandReadyTitleGeneric': 'Ваша дизайн-система готова',
  'project.brandReadyCta': 'Переглянути в Дизайн-системах',
  'project.brandReadyDismiss': 'Закрити',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Попередній перегляд дизайн-системи відкрито.',
  'project.metaFreeform': 'вільна форма',
  'project.typePrototype': 'Прототип',
  'project.typeDeck': 'Слайди',
  'project.typeTemplate': 'Шаблон',
  'project.typeImage': 'Зображення',
  'project.typeVideo': 'Відео',
  'project.typeAudio': 'Аудіо',
  'project.customInstructions': 'Інструкції проєкту',
  'project.customInstructionsPlaceholder': 'Інструкції для цього проєкту (додаються до кожного повідомлення)…',
  'project.resizeChatPanel': 'Змінити розмір панелі чату',
  'project.instructionsActive': 'Активно — додається до кожного повідомлення',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Чат',
  'chat.tabComments': 'Коментарі',
  'chat.commentsSoon': 'Коментарі — скоро',
  'chat.comments.attached': 'Прикріплено до чату',
  'chat.comments.emptyAttached': 'Коментарів не прикріплено.',
  'chat.comments.saved': 'Збережені коментарі',
  'chat.comments.emptySaved': 'Немає збережених коментарів.',
  'chat.comments.add': 'Додати',
  'chat.comments.addAll': 'Додати все',
  'chat.comments.remove': 'Видалити',
  'chat.comments.placeholder': 'Коментар до цього елемента…',
  'chat.comments.addSend': 'Додати та надіслати',
  'chat.comments.updateSend': 'Оновити та надіслати',
  'chat.comments.removeAttachment': 'Видалити прикріплений коментар',
  'chat.comments.removeAttachmentAria': 'Видалити прикріплений коментар для {name}',
  'chat.comments.comment': 'Коментар',
  'chat.comments.sendToChat': 'Надіслати в чат',
  'chat.comments.sending': 'Надсилання…',
  'chat.comments.edit': 'Редагувати',
  'chat.comments.select': 'Вибрати',
  'chat.comments.selectAll': 'Вибрати все',
  'chat.comments.deselect': 'Скасувати вибір',
  'chat.comments.nSelected': 'Вибрано: {n}',
  'chat.comments.pin': 'Закріпити',
  'chat.comments.addNote': 'Додати нотатку',
  'chat.comments.savedToast': 'Коментар збережено',
  'chat.comments.pinSavedToast': 'Закріплення збережено',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': 'Захоплених елементів: {n}',
  'chat.comments.clear': 'Очистити',
  'chat.comments.targetImage': 'Зображення',
  'chat.comments.targetControl': 'Елемент керування',
  'chat.comments.targetLink': 'Посилання',
  'chat.comments.targetText': 'Текст',
  'chat.comments.targetSection': 'Розділ',
  'chat.comments.targetPage': 'Сторінка',
  'chat.comments.targetArea': 'Область',
  'chat.annotationNotePlaceholder': 'Додати нотатку до цієї позначки',
  'chat.annotationAttachImage': 'Додати зображення',
  'chat.annotationAttachedImages': 'Додані зображення',
  'chat.annotationAttachedRemove': 'Видалити останнє зображення',
  'chat.annotationAddToInput': 'Додати до поля введення',
  'chat.annotationAddingToInput': 'Додавання...',
  'chat.annotationQueue': 'Черга',
  'chat.annotationQueueing': 'Додавання в чергу...',
  'chat.annotationSubmitOptions': 'Параметри надсилання',
  'chat.annotationSending': 'Надсилання...',
  'chat.annotationSendDisabledReason': 'Наразі виконується завдання',
  'chat.annotationPreviewMissing': 'Не вдалося захопити попередній перегляд. Спробуйте ще раз.',
  'chat.annotationPreviewMissingInk': 'Не вдалося захопити попередній перегляд. Спробуйте ще раз, щоб не надіслати лише рукописні позначки.',
  'chat.annotationSentWithoutScreenshot': 'Не вдалося захопити попередній перегляд. Анотацію надіслано без знімка екрана.',
  'chat.annotationTimeout': 'Час очікування надсилання анотації вичерпано. Спробуйте ще раз.',
  'chat.annotationFailed': 'Не вдалося надіслати анотацію. Спробуйте ще раз.',
  'chat.annotationProjectCreateFailed': 'Не вдалося створити проєкт, тому анотацію не надіслано.',
  'chat.annotationUploadFailed': 'Не вдалося завантажити вкладення. Спробуйте ще раз.',
  'chat.conversationsTitle': 'Розмови',
  'chat.conversationsAria': 'Історія розмов',
  'chat.newConversation': 'Нова розмова',
  'chat.newConversationsTitle': 'Нова розмова',
  'chat.conversationsHeading': 'Розмови',
  'chat.new': 'Нова',
  'chat.emptyConversations': 'Розмов ще немає.',
  'chat.deleteConversation': 'Видалити розмову',
  'chat.renameConversationLabel': 'Перейменувати "{title}"',
  'chat.deleteConversationConfirm': 'Видалити "{title}"? Це видалить усі її повідомлення.',
  'chat.untitledConversation': 'Розмова без назви',
  'chat.forkedConversationTitle': 'Форк {title}',
  'chat.forkConversationFailed': 'Не вдалося створити форк цієї розмови.',
  'chat.startTitle': 'Почніть розмову',
  'chat.startHint': 'Опишіть, що хочете згенерувати, або почніть з одного з цих прикладів:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI-оптимізація",
  'brandEnrichment.body': "Open Design запустить глибше витягування у фоні, автоматично застосує потрібні skills дизайн-системи й оновить цю систему на місці. Це може зайняти 10-20 хвилин; ви можете продовжувати роботу.",
  'brandEnrichment.cta': "AI-оптимізація",
  'brandEnrichment.busy': "Запускаємо AI-оптимізацію...",
  'brandExtractionTranscript.sourceDesignMd': 'вставлений DESIGN.md',
  'brandExtractionTranscript.user': 'Витягнути дизайн-систему з {source}.',
  'brandExtractionTranscript.doneTitle': 'Програмне витягування для {name} завершено.',
  'brandExtractionTranscript.doneBody': 'Я створив і зареєстрував дизайн-систему {designSystemId} з {source}. Вона готова до перегляду й може використовуватися в нових дизайнах.',
  'brandExtractionTranscript.next': 'Далі можна запустити AI Optimize для глибшого витягування або створити новий дизайн із цією системою.',
  'chat.fillInputTitle': 'Натисніть, щоб заповнити введення',
  'chat.jumpToLatest': 'Перейти до останнього',
  'chat.scrollToLatest': 'Прокрутити до останнього',
  'chat.you': 'Ви',
  'chat.openFile': 'Відкрити {name}',
  'chat.copyPrompt': 'Копіювати запит',
  'chat.copyErrorDiagnostic': 'Скопіювати діагностику помилки',
  'chat.copyDone': 'Скопійовано!',
  'chat.inspect.noEditableTargets': 'Не знайдено редагованого тексту чи цілей стилю.',
  'chat.inspect.noCommentTargets': 'Не знайдено тексту чи візуальних цілей для коментування.',
  'chat.inspect.editHint': 'Виберіть текст або ціль стилю в попередньому перегляді, щоб редагувати її.',
  'chat.inspect.commentHint': 'Виберіть текст або область у попередньому перегляді, щоб залишити коментар.',
  'chat.composerPlaceholder': 'Опишіть, що хочете згенерувати…',
  'chat.activeFileEditingLabel': 'Редагування',
  'chat.activeFilePlaceholder': 'Попросіть Open Design змінити {file}...',
  'chat.designArtifactsShowMore': 'Показати ще {count} дизайн-файлів',
  'chat.mode.chat.label': 'Запитати',
  'chat.mode.chat.title': 'Режим запитання',
  'chat.mode.chat.summary': 'Для швидких відповідей, правок, планування й обговорення без припущення, що треба створювати дизайн-артефакт.',
  'chat.mode.chat.solves': 'Використовуйте для уточнення ідей, покращення промптів, порівняння варіантів або питань про наявну роботу.',
  'chat.mode.chat.query1': 'Підсумуй цей чернетковий текст і покажи прогалини.',
  'chat.mode.chat.query2': 'Допоможи вибрати найкращу структуру для цієї landing page.',
  'chat.mode.chat.query3': 'Переглянь цей дизайн і запропонуй конкретні покращення.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Дизайн',
  'chat.mode.design.title': 'Режим дизайну',
  'chat.mode.design.summary': 'Для створення або зміни конкретних результатів: сторінок, прототипів, live-артефактів, слайдів, зображень, відео, HyperFrames, аудіо, dashboard і файлів проєкту.',
  'chat.mode.design.solves': 'Використовуйте, коли Open Design має згенерувати файли, оновити workspace або перетворити brief на мультимодальні deliverables.',
  'chat.mode.design.query1': 'Створи landing page запуску продукту і прототип HyperFrames з цього brief.',
  'chat.mode.design.query2': 'Зроби інвесторський deck на 10 слайдів із нотатками спікера.',
  'chat.mode.design.query3': 'Згенеруй концепти зображень, відео й аудіо для цієї кампанії.',
  'chat.mode.cardBestFor': 'Найкраще для',
  'chat.mode.cardTry': 'Приклади запитів',
  'chat.mode.cardCost': 'Типове споживання',
  'chat.mode.chat.cost': 'Низьке',
  'chat.mode.chat.costNote': 'Лише розмова — нічого не створюється, тож споживання найменше.',
  'chat.mode.plan.cost': 'Стандартне',
  'chat.mode.plan.costNote': 'Спершу створює редагований документ плану, а потім переходить до генерації.',
  'chat.mode.design.cost': 'Високе',
  'chat.mode.design.costNote': 'Створює файли та мультимодальний контент, тож один запуск може споживати найбільше.',
  'chat.composerHint': '⌘/Ctrl + Enter, щоб надіслати · вкажіть мету, зміст, стиль і формат',
  'chat.cliSettingsTitle': 'Налаштування CLI та моделі',
  'chat.cliSettingsAria': 'Відкрити налаштування CLI та моделі',
  'chat.attachTitle': 'Прикріпити файли (або вставити / перенести)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Прикріпити файли',
  'chat.importTitle': 'Імпортувати джерела (скоро)',
  'chat.importLabel': 'Імпортувати',
  'chat.importComingSoon': 'Скоро',
  'chat.importSoon': 'Скоро',
  'chat.importFig': 'Завантажити файл .fig',
  'chat.importGitHub': 'Підключити GitHub',
  'chat.importWeb': 'Захопити веб-елемент',
  'chat.importFolder': 'Пов\'язати папку коду',
  'chat.importSkills': 'Навички та системи дизайну',
  'chat.importProject': 'Посилання на інший проект',
  'chat.importDesignSystemHeader': 'Виберіть дизайн-систему',
  'chat.importDesignSystemBack': 'Назад',
  'chat.importDesignSystemSearch': 'Пошук дизайн-систем…',
  'chat.importDesignSystemEmpty': 'Немає дизайн-систем, що відповідають "{query}"',
  'chat.importDesignSystemNone': 'Немає — вільно',
  'chat.importDesignSystemNoneSub': 'Не прив\'язувати до системи цього разу',
  'chat.importDesignSystemActive': 'Активна',
  'chat.importDesignSystemSwitched': 'Дизайн-систему змінено на {title}',
  'chat.importDesignSystemFailed': 'Не вдалося змінити дизайн-систему. Спробуйте ще раз.',
  'chat.importDesignSystemLoadFailed': 'Не вдалося завантажити дизайн-системи.',
  'browserUse.title': 'Натхнення',
  'browserUse.summary': '{count} вебдій із пріоритетом на видобуток ресурсів, мову дизайну, анімацію, візуальні перевірки та структуру компонентів.',
  'browserUse.searchAria': 'Пошук натхнення',
  'browserUse.searchPlaceholder': 'Шукати скриншоти, шрифти, кольори, a11y...',
  'browserUse.empty': 'Немає відповідного натхнення',
  'browserUse.unavailable': 'Натхнення тут недоступне',
  'browserUse.added': 'Додано до редактора',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Зупинити завантаження',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Видобуток ресурсів',
  'browserUse.category.tokens': 'Мова дизайну',
  'browserUse.category.motion': 'Анімація',
  'browserUse.category.visual': 'Візуальні перевірки',
  'browserUse.category.structure': 'Компоненти',
  'browserUse.category.project': 'Запуск проєкту',
  'browserUse.category.general': 'Загальне',
  'browserUse.input.none': 'Немає введення',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Необов\'язковий селектор',
  'browserUse.input.requirementSelector': 'Вимога, необов\'язковий селектор',
  'browserUse.input.selectorOptional': 'Необов\'язковий селектор',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Селектор, scale=2',
  'browserUse.input.gridOverlay': '12 колонок, макс. 1200, проміжок 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, домен або пошукові запити',
  'browserUse.input.selector': 'Селектор',
  'browserUse.input.selectorText': 'Селектор і текст',
  'browserUse.input.scroll': 'Пікселі, вгору, вниз або сторінка',
  'browserUse.input.terminalRun': 'Команда, таймаут 120 с',
  'browserUse.input.command': 'Команда',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Найкращі кандидати на логотип із заголовка, навігації, імен класів, позиції, OG-зображення та запасний варіант favicon.',
  'browserUse.action.list_images.output': 'Усі зображення img, srcset, source та фонові зображення CSS із розмірами й alt-текстом.',
  'browserUse.action.download_assets.output': 'Тека завантажених ресурсів плюс _manifest.json з підтримкою referer і cookie.',
  'browserUse.action.extract_svgs.output': 'Вбудовані SVG та пов\'язані файли .svg, збережені як окремі SVG-файли.',
  'browserUse.action.optimize_svgs.output': 'Оптимізовані SVG-файли плюс коефіцієнт стиснення.',
  'browserUse.action.extract_colors.output': 'Зважена палітра плюс CSS-змінні кольору :root як palette.json і palette.html.',
  'browserUse.action.extract_fonts.output': 'Основні гарнітури шрифтів, розміри, насиченості та правила @font-face як typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Радіус, тінь, відступи та CSS-змінні як tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Типографічна шкала заголовків, основного тексту та кнопок із розміром, насиченістю, висотою рядка та співвідношеннями.',
  'browserUse.action.extract_buttons.output': 'Бібліотека стилів кнопок без дублікатів як buttons.html і buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Контейнери grid і flex, напрямок, проміжки, колонки та максимальні ширини як layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Адаптивні точки зламу медіазапитів як breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS-градієнти як gradients.css, gradients.json та HTML-попередній перегляд.',
  'browserUse.action.extract_shadows.output': 'Тіні блоків, тіні тексту та drop-тіні як shadows.json плюс попередній перегляд.',
  'browserUse.action.extract_easings.output': 'Функції плавності переходів та анімацій як easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js та style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, правила transition і transform, виявлені бібліотеки анімації, motion.css та motion.json.',
  'browserUse.action.validate_view.output': 'Шляхи до знімків екрана плюс структуровані візуальні проблеми та проблеми макета.',
  'browserUse.action.audit_layout.output': 'Дефекти макета, зокрема переповнення, межі, накладання та обрізаний текст, як audit.json.',
  'browserUse.action.audit_accessibility.output': 'Проблеми доступності із селекторами, мітками, ролями, фокусом, контрастом і знімками екрана, де це доречно.',
  'browserUse.action.responsive_screenshots.output': 'Знімки екрана для мобільного 390, планшета 834 та десктопа 1440.',
  'browserUse.action.screenshot_full.output': 'Знімок екрана всієї сторінки за межами видимої області.',
  'browserUse.action.screenshot_element.output': 'Знімок екрана одного елемента у масштабі 2x за замовчуванням.',
  'browserUse.action.screenshot_with_grid.output': 'Знімок екрана з накладеною сіткою макета.',
  'browserUse.action.screenshot_dark_mode.output': 'Знімок екрана з prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Односторінковий посібник зі стилю з кольорами, типографічною шкалою, радіусом і тінями.',
  'browserUse.action.extract_html.output': 'Чистий самодостатній HTML без script, noscript чи вбудованих атрибутів подій.',
  'browserUse.action.extract_component_inventory.output': 'Повторювані патерни компонентів, селектори, кількості та знімки екрана.',
  'browserUse.action.extract_copy.output': 'Заголовки, CTA, основний текст та описи як copy.md і copy.json.',
  'browserUse.action.extract_nav.output': 'Основна навігація та посилання у футері як sitemap.md і nav.json.',
  'browserUse.action.extract_forms.output': 'Поля форм, мітки, підказки валідації та дії надсилання як forms.json.',
  'browserUse.action.run_project.output': 'Виявлений URL сервера розробки, відкритий у вкладці Browser.',
  'browserUse.action.detect_project.output': 'Фреймворк, менеджер пакетів, команда встановлення, команда розробки та порт.',
  'browserUse.action.page_info.output': 'URL, заголовок, опис, OG-зображення, колір теми, favicon та viewport.',
  'browserUse.action.snapshot.output': 'До 120 видимих інтерактивних і текстових елементів із тегом, міткою, href та координатами.',
  'browserUse.action.navigate.output': 'Відкрити сторінку та повернути page_info.',
  'browserUse.action.click.output': 'Клацнути перший відповідний елемент після прокручування його у видиму область.',
  'browserUse.action.type_text.output': 'Заповнити поле введення та надіслати події input і change.',
  'browserUse.action.scroll.output': 'Поточна та максимальна позиція прокручування.',
  'browserUse.action.extract_og_metadata.output': 'Meta-заголовок, опис, канонічний URL, картки OG/Twitter, зображення для соцмереж та колір теми.',
  'browserUse.action.terminal_run.output': 'stdout, stderr та код виходу.',
  'browserUse.action.terminal_run_background.output': 'Ідентифікатор фонового завдання та останній вивід.',
  'browserUse.action.terminal_read.output': 'Останній спільний вивід терміналу.',
  'chat.designToolbox.title': 'Набір інструментів дизайну',
  'chat.designToolbox.tooltip': 'Набір інструментів дизайну',
  'chat.designToolbox.aria': 'Відкрити набір інструментів дизайну',
  'chat.designToolbox.searchPlaceholder': 'Пошук навичок / MCP / плагінів / конекторів / файлів дизайну...',
  'chat.designToolbox.searchAria': 'Пошук ресурсів набору інструментів дизайну',
  'chat.designToolbox.followupSection': 'Уточнення',
  'chat.designToolbox.resourcesSection': 'Глобальні ресурси',
  'chat.designToolbox.selected': 'Вибрано',
  'chat.designToolbox.noResources': 'Не знайдено ресурсів за запитом «{query}».',
  'chat.designToolbox.badge.video': 'Відео',
  'chat.designToolbox.badge.image': 'Зображення',
  'chat.designToolbox.badge.motion': 'Анімація',
  'chat.designToolbox.badge.polish': 'Доопрацювання',
  'chat.designToolbox.action.auto-match.title': 'Підібрати наступний крок',
  'chat.designToolbox.action.auto-match.badge': 'Підібрати',
  'chat.designToolbox.action.auto-match.description': 'Спочатку визначте планку смаку, потім підберіть навички, MCP, плагіни, конектори та файли.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Додати анімацію / рух',
  'chat.designToolbox.action.motion.badge': 'Анімація',
  'chat.designToolbox.action.motion.description': 'Додайте анімацію появи, прокрутки, переходів станів і мікровзаємодій до поточного HTML або елемента сторінки.',
  'chat.designToolbox.action.motion-polish.title': 'Доопрацювати анімацію',
  'chat.designToolbox.action.motion-polish.badge': 'Тайминг',
  'chat.designToolbox.action.motion-polish.description': 'Перегляньте тайминг, плавність, продуктивність і запасні варіанти reduced-motion для наявної анімації.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Прибрати ШІ-відчуття',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Смак',
  'chat.designToolbox.action.anti-ai-polish.description': 'Приберіть шаблонність, ШІ-градієнти, дешеві стоси карток і розпливчасті тексти.',
  'chat.designToolbox.action.visual-polish.title': 'Доопрацювання дизайну / готово до випуску',
  'chat.designToolbox.action.visual-polish.badge': 'Доопрацювання',
  'chat.designToolbox.action.visual-polish.description': 'Перевірте візуальну ієрархію, типографіку, відступи, адаптивну поведінку, доступність і якість постачання.',
  'chat.designToolbox.action.image-gen.title': 'Згенерувати зображення / візуальні референси',
  'chat.designToolbox.action.image-gen.badge': 'Зображення',
  'chat.designToolbox.action.image-gen.description': 'Згенеруйте референси секцій, ассети, іконки, зображення для соцмереж або мудборд для поточної сторінки.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Згенерувати відео / сценарій анімації',
  'chat.designToolbox.action.video-gen.badge': 'Відео',
  'chat.designToolbox.action.video-gen.description': 'Перетворіть дизайн на коротке відео, розкадровку Remotion / Hyperframes або готовий до генерації запит.',
  'chat.designToolbox.kind.skill': 'Навичка',
  'chat.designToolbox.kind.plugin': 'Плагін',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Шаблон MCP',
  'chat.designToolbox.kind.connector': 'Конектор',
  'chat.designToolbox.kind.designFile': 'Файл дизайну',
  'chat.designToolbox.context.browser': 'Браузер',
  'chat.designToolbox.context.designFiles': 'Файли дизайну',
  'chat.designToolbox.context.designSystem': 'Дизайн-система',
  'chat.designToolbox.context.folder': 'Тека',
  'chat.designToolbox.context.terminal': 'Термінал',
  'chat.designToolbox.context.sideChat': 'Бічний чат',
  'chat.designToolbox.context.liveArtifact': 'Живий артефакт',
  'chat.designToolbox.context.file': 'Файл',
  'chat.designToolbox.prompt.contextGeneric': 'Поточна ціль: наразі відкритий файл HTML / дизайну / вебелемент.',
  'chat.designToolbox.prompt.contextSpecific': 'Поточна ціль: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Збережіть намір, який уже є в редакторі: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Вибрана навичка: {skill}. Використовуйте її як основний робочий процес для цього кроку.',
  'chat.designToolbox.prompt.noSkill': 'Якщо жодна конкретна навичка не підійшла, спочатку оберіть найкращу комбінацію з доступних навичок, MCP, плагінів, конекторів і файлів дизайну.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Виступіть оркестратором у ролі креативного директора та завершіть робочий процес дизайну:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Спершу визначте, що означає «гарний дизайн»: аудиторія, бізнес-мета, відчуття бренду, стильові орієнтири, щільність інформації, стандарти кольору/типографіки/анімації/ресурсів, а також патерни AI/шаблонів, яких слід уникати.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Шукайте та підбирайте з повного індексу ресурсів вище. Не обмежуйтеся лише рекомендаціями набору інструментів дизайну; за потреби поєднуйте навички, MCP, плагіни, конектори та файли дизайну.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Завершіть процес у такому порядку: діагностика -> напрямок стилю -> вибір ресурсів -> конкретне редагування/генерація -> перевірка. На кожному кроці пояснюйте, чому обрано саме ці ресурси та що потрібно підтвердити далі.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Перегляньте та доопрацюйте тайминг, плавність, продуктивність і доступність наявної анімації. Приберіть різку, дешеву або шкідливу для читабельності анімацію; за потреби використайте витонченішу часову шкалу.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Зробіть один прохід доопрацювання проти ШІ-відчуття: приберіть шаблонні макети, дешеві градієнти/світіння, безглузді стоси карток і розпливчасті тексти. Збережіть інформацію та зробіть так, щоб це виглядало як робота справжнього дизайнера.',
  'chat.designToolbox.prompt.visualPolish': 'Доопрацюйте цей дизайн до стану готовності до випуску: перевірте ієрархію, типографіку, відступи, адаптивну поведінку, стани кнопок, стани порожнечі/завантаження/помилки та доступність; одразу виправте найважливіші проблеми.',
  'chat.designToolbox.prompt.imageGen': 'Створіть наступний план візуальних ресурсів для цього дизайну: референси секцій, hero-ресурси, ілюстрації, іконки, зображення для соцмереж або мудборд. Спершу визначте, якого типу зображення бракує, потім надайте готові до виконання промпти для генерації / план файлів.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Переведіть цей дизайн у відео: створіть розкадровку короткого відео, структуру кадрів HyperFrames / Remotion або готовий промпт для Sora/fal. Надавайте перевагу тому, щоб наявний HTML / вміст сторінки природно ставав кадрами.',
  'chat.designToolbox.prompt.useSkill': 'Застосуйте {skill} до поточного дизайну.',
  'chat.designToolbox.prompt.skillInstruction': 'Спершу визначте найкращу подальшу мету, потім виконайте один конкретний прохід. Якщо це залежить від зовнішніх ресурсів або API, надайте робочий запасний варіант або вкажіть, що мені потрібно надати.',
  'chat.designToolbox.prompt.selectedResource': 'Вибраний ресурс: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Опис ресурсу: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Використовуйте цей плагін як основний контекст для поточного процесу дизайну. Якщо він надає поля вводу або GenUI, скеровуйте мене щодо вибору за потреби; якщо він не підходить для цілі, оберіть кращий глобальний ресурс і поясніть чому.',
  'chat.designToolbox.prompt.mcpResource': 'Надавайте перевагу цій можливості MCP для наступного кроку дизайну. Коли потрібні зовнішні ресурси, веб-захоплення, генерація зображень/відео або дані, спершу визначте, чи здатна вона виконати завдання, потім надайте готовий до виконання план.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Цей MCP є налаштовуваним шаблоном. Якщо це найкорисніший інструмент для цього кроку дизайну, спершу скеруйте налаштування; якщо існує налаштована альтернатива, продовжуйте з нею.',
  'chat.designToolbox.prompt.connectorResource': 'Використовуйте цей конектор, коли потрібні реальні дані, ресурси, вміст облікового запису або доступ до зовнішнього робочого процесу. Перед використанням поясніть, що буде прочитано або записано, і за потреби запитайте підтвердження.',
  'chat.designToolbox.prompt.fileResource': 'Використовуйте цей файл дизайну як поточну ціль дизайну або референсний ресурс і виконайте з нього наступний крок. Якщо потрібно порівняти інші файли, продовжуйте пошук серед усіх файлів дизайну.',
  'chat.designToolbox.prompt.resourceIndex': 'Глобальний індекс ресурсів: навички({skills}), плагіни({plugins}), MCP({mcpEnabled} увімкнено / {mcpTemplates} шаблонів), конектори({connectors} підключено), файли дизайну({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Навички для пошуку',
  'chat.designToolbox.prompt.searchablePlugins': 'Плагіни для пошуку',
  'chat.designToolbox.prompt.availableMcp': 'Доступні MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Підключені конектори',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Референсні файли дизайну',
  'chat.designToolbox.prompt.mcpTemplateName': 'Шаблон {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +ще {count}',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Поверхні згадок',
  'chat.mentionTabAll': 'Усі',
  'chat.mentionTabTabs': 'Вкладки',
  'chat.mentionTabPlugins': 'Плагіни',
  'chat.mentionTabSkills': 'Навички',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Конектори',
  'chat.mentionTabFiles': 'Файли дизайну',
  'chat.mentionNoResults': 'Немає результатів для «{query}».',
  'chat.mentionSearchPrompt': 'Шукайте файли дизайну, вкладки, плагіни, навички, сервери MCP та конектори.',
  'chat.mentionSectionTabs': 'Вкладки',
  'chat.mentionSectionPlugins': 'Плагіни',
  'chat.mentionSectionSkills': 'Навички',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Конектори',
  'chat.mentionSectionFiles': 'Файли дизайну',
  'chat.mentionActiveSkill': 'Активні',
  'chat.mentionUseMcpTitle': 'Використати {name}',
  'chat.mentionUseConnectorTitle': 'Використати {name}',
  'chat.mentionPluginOfficial': 'Офіційний',
  'chat.mentionPluginMine': 'Мій плагін',
  'chat.linkedFolderRemoveAria': 'Видалити пов\'язану папку {path}',
  'chat.linkedFolderNotFound': 'Папка не існує',
  'chat.linkedFolderAlready': 'Ця папка вже пов\'язана',
  'chat.linkedFolderPickError': 'Не вдалося відкрити вибір папки',
  'chat.queuedHeader': 'У черзі',
  'chat.queuedToSend': 'для надсилання',
  'chat.queuedEditQueuedTaskAria': 'Редагувати завдання в черзі',
  'chat.queuedSave': 'Зберегти',
  'chat.queuedCancel': 'Скасувати',
  'chat.queuedReorder': 'Перетягніть, щоб змінити порядок',
  'chat.queuedEdit': 'Редагувати',
  'chat.queuedMore': 'ще в черзі',
  'chat.queuedFollowUpFallback': 'Подальша дія в черзі',
  'chat.send': 'Надіслати',
  'chat.stop': 'Зупинити',
  'chat.removeAria': 'Видалити {name}',
  'chat.example1Title': 'Редакційна піч-дека',
  'chat.example1Tag': 'Журнал',
  'chat.example1Prompt': ' 10-слайдова редакційна презентація для студії дизайну, що залучає стартовий раунд — макет швейцарської сітки, великі серифні заголовки з сміливими літерницями, моноширокі номери розділів, щедрий негативний простір та повнорозмірні фотослайди, чергуючися з текстозасадженими. Обкладинка, бачення, ринок, продукт, результати, команда, пропозиція, контакти.',
  'chat.example2Title': 'SaaS аналітична панель',
  'chat.example2Tag': 'Дані',
  'chat.example2Prompt': 'Щільна аналітична панель для SaaS з інструментами розробника — смуга KPI з дельтами від тижня до тижня, два нашаровані графіки (MRR та активні робочі простори), світова теплова карта використання, сітка утримання когорти, лідерборд найпопулярніших клієнтів та стрічка подій реального часу. Темна тема, таблична моноширока цифра, акценти спарклайна.',
  'chat.example3Title': 'Довгий скрол річного звіту',
  'chat.example3Tag': 'Редакційне',
  'chat.example3Prompt': 'Інтерактивний річний звіт для екологічної організації, що не шукає прибутку — довгий скрол редакційного макета, що змішує великі блоки цитат, візуалізацію даних (накопичені бари, анімовані лічильники, хорографічна карта місць проектів), перерви за фотографіями, стіна донорів та остаточний клич. Сучасний шрифт з засічками, безсерифні ярлики графіків, землиста палітра паперу.',
  'home.recommendation.eyebrow': 'Рекомендовано для вас',
  'home.recommendation.primaryCta': 'Почати створення',
  'home.recommendation.change': 'Спробувати інший',
  'home.recommendation.browseAll': 'Усі типи',
  'home.recommendation.defaultProjectName': 'Новий проєкт',
  'home.recommendation.startFailed': 'Не вдалося почати створення. Спробуйте ще раз.',
  'studio.firstArtifactHint.title': 'Ваш перший дизайн готовий',
  'studio.firstArtifactHint.body': 'Спробуйте відредагувати й додати позначки — експортуйте або поділіться, коли будете задоволені.',
  'studio.firstArtifactHint.dismiss': 'Зрозуміло',
  'home.starter.product_ui_prototype.title': 'Почніть з редагованого прототипу продукту',
  'home.starter.product_ui_prototype.desc': 'Виходячи з вашої мети, почніть з клікабельного інтерфейсу, який можна доопрацювати.',
  'home.starter.product_ui_prototype.firstPrompt': 'Спроєктуйте редагований прототип продукту для [ваш продукт] з ключовими екранами та зрозумілим основним сценарієм.',
  'home.starter.product_ui_component.title': 'Почніть із багаторазового компонента',
  'home.starter.product_ui_component.desc': 'Спочатку створіть один компонент, а потім зберіть із нього повноцінні екрани.',
  'home.starter.product_ui_component.firstPrompt': 'Спроєктуйте багаторазовий компонент [назва компонента] з його основними станами та варіантами.',
  'home.starter.product_ui_lowfi.title': 'Почніть з прототипу низької деталізації',
  'home.starter.product_ui_lowfi.desc': 'Спершу накидайте структуру, а потім підвищуйте деталізацію.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Створіть низькодеталізований каркас основних екранів для [ваш продукт].',
  'home.starter.marketing_landing.title': 'Почніть із цільової сторінки',
  'home.starter.marketing_landing.desc': 'Перетворіть свою кампанію на цільову сторінку, готову до запуску.',
  'home.starter.marketing_landing.firstPrompt': 'Спроєктуйте цільову сторінку для [ваш продукт] з hero-блоком, ключовими перевагами та зрозумілим закликом до дії.',
  'home.starter.marketing_multivariant.title': 'Почніть із кількох варіантів цільової сторінки',
  'home.starter.marketing_multivariant.desc': 'Згенеруйте кілька версій для порівняння, перш ніж ухвалити рішення.',
  'home.starter.marketing_multivariant.firstPrompt': 'Створіть 3 варіанти цільової сторінки для [ваш продукт] з різними hero-повідомленнями для порівняння.',
  'home.starter.internal_dashboard.title': 'Почніть із внутрішньої панелі',
  'home.starter.internal_dashboard.desc': 'Почніть із макета панелі для вашого робочого процесу.',
  'home.starter.internal_dashboard.firstPrompt': 'Спроєктуйте внутрішню панель, що показує [ключові метрики] з фільтрами та таблицею даних.',
  'home.starter.internal_report.title': 'Почніть зі звіту',
  'home.starter.internal_report.desc': 'Опишіть дані та поля, які ви хочете бачити.',
  'home.starter.internal_report.firstPrompt': 'Створіть сторінку звіту, що узагальнює [опишіть дані, поля та метрики, які вас цікавлять].',
  'home.starter.general_menu.title': 'Почніть із вашого першого проєкту',
  'home.starter.general_menu.desc': 'Опишіть, що ви хочете, і ми згенеруємо редаговану першу версію.',
  'home.starter.general_menu.firstPrompt': 'Створіть редаговану першу версію [опишіть, що ви хочете зробити].',
  'chat.example4Title': 'Продуктове motion-відео',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Створіть сториборд 15-секундного motion-відео для запуску застосунку продуктивності: вступний гачок, крупні плани UI, кінетична типографіка, переходи функцій, фінальний логотип і CTA. Додайте таймінг, сцени, рух камери та екранні тексти.',
  'preview.usePlugin': 'Використати плагін',
  'preview.usePluginOnly': 'Використати без промпта',
  'preview.usePluginOnlyDesc': 'Використати структуру плагіна без завантаження прикладу промпта',
  'preview.replicateContent': 'Використати',
  'preview.replicateContentDesc': 'Використати приклад промпта, щоб відтворити попередній перегляд',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Зробити remix цього прикладу в новий редагований проєкт',
  'preview.shareMenu': 'Поділитися',
  'preview.exportMenu': 'Експортувати',
  'preview.shareTemplateBadge': 'Шаблон',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Скопіювати посилання на шаблон',
  'preview.copyShareText': 'Скопіювати текст для поширення',
  'preview.shareSocialGroup': 'Поділитися в соцмережах',
  'preview.shareCopyGroup': 'Копіювати',
  'preview.shareExportGroup': 'Експортувати файли',
  'preview.shareCopied': 'Скопійовано',
  'preview.shareCopyFailed': 'Не вдалося скопіювати',
  'preview.shareTextDefault': 'Шаблон Open Design: {title}',
  'preview.openInNewTab': 'Відкрити в новій вкладці',
  'preview.exit': '⤓ Вихід',
  'preview.fullscreen': '⤢ Повноекранний режим',
  'preview.closeTitle': 'Закрити (Esc)',
  'preview.loading': 'Завантаження {label}…',
  'preview.errorTitle': 'Не вдалося завантажити цей приклад.',
  'preview.errorBody': 'Не вдалося отримати HTML прикладу. Переконайтеся, що Open Design запущено, і повторіть спробу.',
  'preview.retry': 'Повторити',
  'preview.unavailableTitle': 'Для {noun} немає вбудованого попереднього перегляду.',
  'preview.unavailableBody': 'Запустіть підказку в чаті, щоб згенерувати {kind}-вивід.',
  'preview.nounSkill': 'цієї навички',
  'preview.nounPlugin': 'цього плагіна',
  'preview.nounTemplate': 'цього шаблону',
  'preview.showSidebar': 'Показати {label}',
  'preview.hideSidebar': 'Приховати {label}',
  'misc.savedTemplate': 'Збережений шаблон',
  'misc.primary': 'Основна',
  'misc.designSystem': 'Система дизайну',
  'workspace.designFiles': 'Файли дизайну',
  'workspace.focusMode': 'Сфокусувати робочий простір',
  'workspace.showChat': 'Показати чат',
  'workspace.closeTab': 'Закрити вкладку',
  'workspace.deleteFileConfirm': 'Видалити "{name}" з папки проекту?',
  'workspace.deleteSelectedFilesConfirm': 'Видалити {n} вибраних файлів з папки проекту?',
  'workspace.deleteSelectedFilesPartial': 'Не вдалося видалити {n} файл(ів).',
  'workspace.openFromDesignFiles': 'Відкрити файл з',
  'workspace.designFilesLink': 'Файли дизайну',
  'workspace.loadingSketch': 'Завантаження ескізу…',
  'workspace.newTab': 'Нова вкладка',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Відкриті вкладки',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'Новий браузер',
  'workspace.newBrowserDescription': 'Відкрити вбудовану вкладку браузера для довідкових сайтів і завдань',
  'workspace.newSketchDescription': 'Накидайте чорнові макети й нотатки як дизайн-контекст для агента',
  'workspace.terminalStarting': 'Запуск термінала…',
  'workspace.terminalStartingDescription': 'Готуємо оболонку проєкту. Зазвичай це займає кілька секунд.',
  'workspace.terminalSessionEnded': 'Сеанс завершено',
  'workspace.terminalReconnecting': 'Повторне підключення…',
  'workspace.terminalStartFailed': 'Не вдалося запустити сеанс термінала',
  'workspace.terminalRestart': 'Перезапустити',
  'designFiles.title': 'Файли дизайну',
  'designFiles.upload': 'Завантажити файли',
  'designFiles.pasteText': 'Вставити як текстовий файл',
  'designFiles.newSketch': 'Новий ескіз',
  'designFiles.empty': 'Тут з\'являться ваші роботи',
  'designFiles.refresh': 'Оновити',
  'designFiles.delete': 'Видалити',
  'designFiles.searchPlaceholder': 'Пошук файлів…',
  'designFiles.up': 'Вгору',
  'designFiles.back': 'Назад',
  'designFiles.crumbs': 'проект',
  'designFiles.rowMenu': 'Меню рядка',
  'designFiles.openInTab': 'Відкрити на вкладці',
  'designFiles.download': 'Завантажити',
  'designFiles.downloadSelected': 'Завантажити {n} як ZIP',
  'designFiles.deleteSelected': 'Видалити {n}',
  'designFiles.clearSelection': 'Очистити виділення',
  'designFiles.selectPage': 'Вибрати все на сторінці',
  'designFiles.selectAll': 'Вибрати все',
  'designFiles.dropTitle': '⤓ Перенесіть файли сюди',
  'designFiles.dropDesc': 'Зображення, документи, посилання або папки — агент використовуватиме їх як контекст.',
  'designFiles.dropLabel': 'Перетягніть файли сюди',
  'designFiles.upload.title': 'Завантажити файли',
  'designFiles.paste.title': "Create document",
  'designFiles.upload.label': 'Завантажити',
  'designFiles.paste.label': "Create document",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Відкрити',
  'designFiles.previewClose': 'Закрити попередній перегляд',
  'designFiles.modified': 'Змінено {time} · {size}',
  'designFiles.weeksAgo': '{n}тижнів назад',
  'designFiles.groupBy': 'Групувати за',
  'designFiles.groupByKind': 'Тип',
  'designFiles.groupByModified': 'Змінено',
  'designFiles.filterBy': 'Фільтрувати за типом',
  'designFiles.filterClear': 'Очистити',
  'designFiles.filterCount': '{n} типів',
  'designFiles.expandGroup': 'Розгорнути',
  'designFiles.collapseGroup': 'Згорнути',
  'designFiles.sectionPages': 'Сторінки',
  'designFiles.sectionScripts': 'Скрипти',
  'designFiles.sectionImages': 'Зображення',
  'designFiles.sectionSketches': 'Ескізи',
  'designFiles.sectionLiveArtifacts': 'Live-артефакти',
  'designFiles.sectionOther': 'Інше',
  'designFiles.modifiedToday': 'Сьогодні',
  'designFiles.modifiedYesterday': 'Учора',
  'designFiles.modifiedPrevious7Days': 'Останні 7 днів',
  'designFiles.modifiedPrevious30Days': 'Останні 30 днів',
  'designFiles.modifiedOlder': 'Старіші',
  'designFiles.showMore': 'Показати ще +{n}',
  'designFiles.kindHtml': 'Веб-сторінка',
  'designFiles.kindImage': 'Зображення',
  'designFiles.kindSketch': 'Ескіз',
  'designFiles.kindText': 'Текст',
  'designFiles.kindCode': 'Скрипт',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Документ',
  'designFiles.kindPresentation': 'Презентація',
  'designFiles.kindSpreadsheet': 'Електронна таблиця',
  'designFiles.kindLiveArtifact': 'Live-артефакт',
  'designFiles.kindBinary': 'Двійковий',
  'designFiles.kindFolder': 'Папка',
  'designFiles.folderCount': '{n} файлів',
  'designFiles.newFolderTitle': 'Нова папка',
  'designFiles.newFolderLabel': 'Назва папки',
  'designFiles.moveTitle': 'Перемістити до папки',
  'designFiles.moveLabel': 'Папка призначення',
  'designFiles.moveRoot': 'Корінь проєкту',
  'designFiles.moveNewFolder': 'Нова папка…',
  'designFiles.move': 'Перемістити',
  'designFiles.copyPath': 'Скопіювати шлях',
  'designFiles.copiedPath': 'Шлях скопійовано',
  'designFiles.copyLocalPath': 'Скопіювати локальний шлях до файлу',
  'designFiles.copiedLocalPath': 'Локальний шлях до файлу скопійовано',
  'designFiles.deleteFolderConfirm': 'Видалити папку «{name}» з усім вмістом?',
  'designFiles.folderCreated': 'Папку «{name}» створено',
  'designFiles.folderDeleted': 'Папку «{name}» видалено',
  'designFiles.filesMoved': 'Переміщено {n} до {dest}',
  'designFiles.colName': 'Назва',
  'designFiles.colKind': 'Тип',
  'designFiles.colModified': 'Змінено',
  'designFiles.perPage': 'Показати',
  'designFiles.all': 'Усі',
  'designFiles.prev': 'Назад',
  'designFiles.next': 'Далі',
  'designFiles.jumpToPage': 'Перейти на сторінку',
  'designFiles.pageInfo': '{start}–{end} із {total}',
  'designFiles.sectionFolders': 'Папки',
  'designFiles.sectionStylesheets': 'Таблиці стилів',
  'designFiles.sectionDocuments': 'Документи',
  'designFiles.kindStylesheet': 'Таблиця стилів',
  'designFiles.modifiedExt': 'Змінено {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Корисна інформація',
  'designFiles.usefulInfoTip': 'Двічі клацніть будь-який файл, щоб відкрити його в окремій вкладці.',
  'designFiles.usefulInfoTip2': 'Введіть @ у чаті, щоб додати файл як контекст.',
  'designFiles.usefulInfoTip4': 'Оберіть дизайн-систему — результат відповідатиме стилю бренду.',
  'designFiles.usefulInfoTip5': 'Немає ідей? Спробуйте шаблон плагіна в розділі «Спільнота» на головній.',
  'designFiles.usefulInfoTip6': 'Питання чи пропозиції? Приєднуйтесь до нас у Discord.',
  'designFiles.usefulInfoTip7': 'Подобається Open Design? Поставте зірку на GitHub.',
  'designFiles.usefulInfoTip8': 'Стежте за @OpenDesignHQ в X, щоб дізнаватися про новинки.',
  'designFiles.usefulInfoTip9': 'Перетягніть зображення, документи чи цілі папки в цю панель — агент використає їх як контекст.',
  'designFiles.usefulInfoTip10': 'Натисніть «Новий ескіз», намалюйте макет — агент згенерує дизайн за ним.',
  'designFiles.usefulInfoTip11': 'Виділіть будь-який елемент у попередньому перегляді й залиште коментар — агент внесе точкові правки.',
  'designFiles.usefulInfoTip12': 'Не подобається результат? Обвести елемент швидше, ніж описувати знову.',
  'designFiles.usefulInfoTip13': 'Будь-який дизайн експортується в PDF, зображення або автономний HTML одним кліком.',
  'designFiles.usefulInfoTip14': 'Задоволені проєктом? Збережіть його як шаблон через меню «Поділитися».',
  'designFiles.usefulInfoTip15': 'Після розгортання можна одразу створити картки для соцмереж.',
  'designFiles.usefulInfoTip16': 'Стежте за @opendesign.ai у Threads, щоб бачити новини із-за лаштунків.',
  'designFiles.usefulInfoTip17': 'Стежте за @opendesign.ai в Instagram заради дизайн-натхнення.',
  'designFiles.usefulInfoTip18': 'Підпишіться на Open Design на YouTube заради туторіалів і демо.',
  'designFiles.usefulInfoTip19': 'Стежте за Open Design у LinkedIn заради новин продукту.',
  'designFiles.usefulInfoTip20': 'Стежте за Open Design у Xiaohongshu заради порад і натхнення.',
  'quickSwitcher.placeholder': 'Відкрити файл…',
  'quickSwitcher.empty': 'У цьому проєкті немає файлів',
  'quickSwitcher.noMatches': 'Немає збігів',
  'quickSwitcher.navigate': 'навігація',
  'quickSwitcher.open': 'відкрити',
  'quickSwitcher.close': 'закрити',
  'pasteDialog.title': 'Вставити текст',
  'pasteDialog.hint': 'Збережено в папці проекту. Виберіть будь-яку назву.',
  'pasteDialog.fileNameLabel': 'Назва файлу',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'Вміст',
  'pasteDialog.contentPlaceholder': 'Вставте що завгодно…',
  'pasteDialog.save': 'Зберегти',
  'pasteDialog.cancel': 'Скасувати',
  'sketch.save': 'Зберегти ескіз',
  'sketch.cancel': 'Скасувати',
  'sketch.saving': 'Збереження…',
  'sketch.saved': 'Збережено',
  'sketch.tooltipMainMenu': 'Головне меню: збереження, експорт, довідка та налаштування полотна',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Незбережені зміни',
  'sketch.tooltipClean': 'Збережено',
  'fileViewer.empty': 'Виберіть файл для перегляду.',
  'fileViewer.loading': 'Завантаження…',
  'fileViewer.exportPptx': 'Експортувати як PPTX',
  'fileViewer.openInNewTab': 'Відкрити в новій вкладці',
  'fileViewer.copyPath': 'Копіювати шлях',
  'fileViewer.copied': 'Скопійовано!',
  'fileViewer.share': 'Поділитися',
  'fileViewer.binaryMeta': 'Двійковий · {size}',
  'fileViewer.binaryNote': 'Двійковий файл ({size} байтів). Завантажте або відкрийте з диска для інспекції.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Документ',
  'fileViewer.presentationMeta': 'Презентація',
  'fileViewer.spreadsheetMeta': 'Електронна таблиця',
  'fileViewer.previewUnavailable': 'Попередній перегляд недоступний. Завантажте або відкрийте файл для інспекції.',
  'fileViewer.download': 'Завантажити',
  'fileViewer.open': 'Відкрити',
  'fileViewer.imageMeta': 'Зображення · {size}',
  'fileViewer.reactMeta': 'React компонент · {size}',
  'fileViewer.sketchMeta': 'Ескіз · {size}',
  'fileViewer.markdownStreamingMeta': 'Попередній перегляд потоку…',
  'fileViewer.markdownErrorMeta': 'Попередній перегляд може бути неповним (помилка генерації).',
  'fileViewer.markdownStreamingStatus': 'Потоком… показано часткове повідомлення.',
  'fileViewer.markdownErrorStatus': 'Помилка генерації. Показано останній доступний вміст.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Відеоролик · {size}',
  'fileViewer.audioMeta': 'Аудіо · {size}',
  'fileViewer.reload': 'Перезавантажити',
  'fileViewer.reloadDisk': 'Перезавантажити з диска',
  'fileViewer.copy': 'Копіювати',
  'fileViewer.copyTitle': 'Копіювати вміст файлу',
  'fileViewer.saveDisabled': 'Зберегти (переглядач лише для читання)',
  'fileViewer.save': 'Зберегти',
  'fileViewer.preview': 'Попередній перегляд',
  'fileViewer.source': 'Джерело',
  'fileViewer.tweaks': 'Настройки',
  'fileViewer.tweaksUnavailable': 'Немає панелі налаштувань у цьому артефакті',
  'fileViewer.jsxModuleTitle': 'Немає окремого попереднього перегляду',
  'fileViewer.jsxModuleBody': 'Цей файл є модулем компонента, який завантажує інша сторінка.',
  'fileViewer.jsxModuleCta': 'Відкрийте сторінку, що його відображає:',
  'fileViewer.comment': 'Коментар',
  'fileViewer.edit': 'Редагувати',
  'fileViewer.draw': 'Малювати',
  'fileViewer.mark': 'Позначити',
  'fileViewer.markTool': 'Інструмент позначення',
  'fileViewer.boxSelect': 'Прямокутне виділення',
  'fileViewer.textTool': 'Текст',
  'fileViewer.textAnnotationRemove': 'Видалити текст',
  'fileViewer.screenshot': 'Знімок екрана',
  'fileViewer.versions.entry': 'Версії',
  'fileViewer.versions.title': 'Версії',
  'fileViewer.versions.countOne': '1 версія',
  'fileViewer.versions.countMany': '{count} версій',
  'fileViewer.versions.current': 'Поточна',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Версія {version}',
  'fileViewer.versions.listAria': 'Версії файлу',
  'fileViewer.versions.loading': 'Завантаження версій...',
  'fileViewer.versions.empty': 'Версій поки немає.',
  'fileViewer.versions.loadFailed': 'Не вдалося завантажити версії.',
  'fileViewer.versions.previewFailed': 'Не вдалося завантажити попередній перегляд цієї версії.',
  'fileViewer.versions.previewLoading': 'Завантаження попереднього перегляду версії...',
  'fileViewer.versions.noPrompt': 'Промпт не записано',
  'fileViewer.versions.noPromptBody': 'Для цієї версії промпт не записано.',
  'fileViewer.versions.promptTitle': 'Промпт',
  'fileViewer.versions.copyPrompt': 'Копіювати промпт',
  'fileViewer.versions.fullscreen': 'Повноекранний перегляд',
  'fileViewer.versions.open': 'Відкрити перегляд',
  'fileViewer.versions.currentHelp': 'Це вже поточна версія.',
  'fileViewer.versions.restoreHelp': 'Перемикання відновить цей HTML як нову поточну версію.',
  'fileViewer.versions.restore': 'Перемкнутися на цю версію',
  'fileViewer.versions.restoreConfirmTitle': 'Перейти до цієї версії?',
  'fileViewer.versions.restoreConfirmCta': 'Перейти',
  'fileViewer.versions.restoring': 'Перемикання...',
  'fileViewer.versions.restoreFailed': 'Не вдалося перемкнутися на цю версію.',
  'fileViewer.versions.restoreSuccess': 'Перемкнено на цю версію.',
  'manualEdit.layers': 'Шари',
  'manualEdit.editableCount': '{count} редагованих',
  'manualEdit.hiddenBadge': 'Приховано',
  'manualEdit.title': 'Ручний редактор',
  'manualEdit.fallbackTitle': 'Редагувати',
  'manualEdit.movePanel': 'Перемістити панель редагування',
  'manualEdit.editParams': 'Редагувати параметри',
  'manualEdit.closePanel': 'Закрити панель редагування',
  'manualEdit.selectLayer': 'Виберіть шар',
  'manualEdit.empty': 'Клацніть елемент у попередньому перегляді або виберіть шар.',
  'manualEdit.noEditableLayers': 'Редагованих шарів не знайдено.',
  'manualEdit.noClass': 'без класу',
  'manualEdit.tabsAria': 'Вкладки ручного редагування',
  'manualEdit.tabContent': 'Вміст',
  'manualEdit.tabStyle': 'Стиль',
  'manualEdit.tabAttributes': 'Атрибути',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Джерело',
  'manualEdit.attributesJson': 'JSON атрибутів',
  'manualEdit.selectedHtml': 'HTML вибраного елемента',
  'manualEdit.fullSource': 'Повне джерело артефакту',
  'manualEdit.applyContent': 'Застосувати вміст',
  'manualEdit.applyStyle': 'Застосувати стиль',
  'manualEdit.applyAttributes': 'Застосувати атрибути',
  'manualEdit.applyHtml': 'Застосувати HTML',
  'manualEdit.applySource': 'Застосувати джерело',
  'manualEdit.invalidAttributes': 'Некоректний JSON атрибутів.',
  'manualEdit.changes': 'Зміни',
  'manualEdit.undo': 'Скасувати',
  'manualEdit.redo': 'Повторити',
  'manualEdit.noChanges': 'Ще немає ручних змін.',
  'manualEdit.imageUrl': 'URL зображення',
  'manualEdit.altText': 'Альтернативний текст',
  'manualEdit.label': 'Підпис',
  'manualEdit.text': 'Текст',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Колір тексту',
  'manualEdit.background': 'Тло',
  'manualEdit.fontSize': 'Розмір шрифту',
  'manualEdit.weight': 'Насиченість',
  'manualEdit.align': 'Вирівнювання',
  'manualEdit.padding': 'Внутрішній відступ',
  'manualEdit.margin': 'Зовнішній відступ',
  'manualEdit.radius': 'Радіус',
  'manualEdit.border': 'Рамка',
  'manualEdit.width': 'Ширина',
  'manualEdit.minHeight': 'Мінімальна висота',
  'manualEdit.deleteElement': 'Видалити елемент',
  'manualEdit.deleteElementConfirm': 'Видалити вибраний елемент? Цю дію можна скасувати за допомогою «Скасувати».',
  'manualEdit.uploadImage': 'Завантажити зображення',
  'manualEdit.uploadingImage': 'Завантаження зображення…',
  'manualEdit.uploadImageFailed': 'Не вдалося завантажити зображення.',
  'manualEdit.focusSlides': 'Зосередитися на слайдах',
  'manualEdit.showPanels': 'Показати панелі',
  'fileViewer.zoomOut': 'Зменшити',
  'fileViewer.zoomIn': 'Збільшити',
  'fileViewer.resetZoom': 'Скинути масштаб',
  'fileViewer.viewportAria': 'Область перегляду',
  'fileViewer.viewportDesktop': 'Комп’ютер',
  'fileViewer.viewportDesktopTitle': 'Перегляд на весь екран для комп’ютера',
  'fileViewer.viewportTablet': 'Планшет',
  'fileViewer.viewportTabletTitle': 'Перегляд для планшета 820 × 1180 (сучасна базова книжкова орієнтація)',
  'fileViewer.viewportMobile': 'Мобільний',
  'fileViewer.viewportMobileTitle': 'Перегляд для мобільного 390 × 844',
  'fileViewer.reloadAria': 'Перезавантажити',
  'fileViewer.previousSlide': 'Попередній слайд',
  'fileViewer.nextSlide': 'Наступний слайд',
  'fileViewer.slideNavAria': 'Навігація по слайдах',
  'fileViewer.speakerNotes': 'Нотатки доповідача',
  'fileViewer.speakerNotesSlide': 'Слайд {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Для цього слайда немає нотаток доповідача.',
  'fileViewer.speakerNotesEdit': 'Редагувати',
  'fileViewer.speakerNotesSave': 'Зберегти нотатки',
  'fileViewer.speakerNotesSaving': 'Збереження…',
  'fileViewer.speakerNotesSaved': 'Збережено',
  'fileViewer.speakerNotesSaveFailed': 'Не вдалося зберегти нотатки доповідача.',
  'fileViewer.speakerNotesPlaceholder': 'Додайте нотатки доповідача для цього слайда…',
  'fileViewer.presenterReset': 'Скинути',
  'fileViewer.present': 'Презентувати',
  'fileViewer.presentInTab': 'На цій вкладці',
  'fileViewer.presentFullscreen': 'Повноекранний режим',
  'fileViewer.presentNewTab': 'Нова вкладка',
  'fileViewer.exitPresentation': 'Вийти з режиму презентації',
  'fileViewer.shareLabel': 'Поділитися',
  'fileViewer.shareMenuShareLink': 'ПОДІЛИТИСЯ',
  'fileViewer.shareMenuPublishOnline': 'ОПУБЛІКУВАТИ ОНЛАЙН',
  'fileViewer.shareMenuDownload': 'ЗАВАНТАЖИТИ',
  'fileViewer.shareMenuPresentation': 'Презентація',
  'fileViewer.shareMenuSourceFiles': 'Вихідні файли',
  'fileViewer.shareMenuSave': 'ЗБЕРЕГТИ',
  'fileViewer.copyShareLink': 'Скопіювати посилання для доступу',
  'fileViewer.openSharePage': 'Відкрити сторінку доступу',
  'fileViewer.shareLinkRequiresDeploy': 'Спочатку опублікуйте онлайн, щоб отримати посилання',
  'fileViewer.shareLinkPublishGuide': 'Опублікуйте онлайн вище, щоб увімкнути доступ ↑',
  'fileViewer.shareAfterGenerationComplete': 'Доступ буде можливий після завершення генерації',
  'fileViewer.copyProviderLink': 'Скопіювати посилання {provider}',
  'fileViewer.copyCloudflareLink': 'Скопіювати посилання Cloudflare',
  'fileViewer.screenshotCopying': 'Копіювання знімка екрана...',
  'fileViewer.screenshotCopied': 'Знімок екрана скопійовано до буфера обміну',
  'fileViewer.screenshotClipboardDenied': 'Браузер заблокував доступ до буфера обміну',
  'fileViewer.screenshotPreviewLoading': 'Перегляд ще завантажується. Спробуйте за мить.',
  'fileViewer.screenshotCaptureFailed': 'Не вдалося зробити знімок перегляду. Спробуйте ще раз.',
  'fileViewer.exportPdf': 'Експортувати як PDF',
  'fileViewer.exportPdfAllSlides': 'Експортувати як PDF (усі слайди)',
  'fileViewer.exportPptxBusy': 'Чекайте, поки поточна черга завершиться.',
  'fileViewer.exportPptxHint': 'Надішліть запит агентові для перетворення цього дизайну на PPTX.',
  'fileViewer.exportPptxNa': 'Експорт PPTX недоступний тут.',
  'fileViewer.exportZip': 'Завантажити як .zip',
  'fileViewer.exportHtml': 'Експортувати як самостійний HTML',
  'fileViewer.exportMd': 'Експортувати як Markdown',
  'fileViewer.exportImage': 'Експортувати як зображення',
  'fileViewer.exportPptxImages': 'Експорт у PPTX (зображення)',
  'fileViewer.exportPptxEditable': 'Експорт у PPTX (редагований)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Експортування…',
  'fileViewer.exportSlideProgress': 'Експортування слайда {current}/{total}…',
  'fileViewer.exportingElapsed': 'Експортування… {seconds}с',
  'fileViewer.exportSlideEta': 'Слайд {current}/{total} · залишилось ~{seconds}с',
  'fileViewer.exportFailed': 'Не вдалося експортувати. Спробуйте ще раз.',
  'fileViewer.exportDone': 'Експорт завершено',
  'fileViewer.exportImageFailed': 'Не вдалося захопити зображення. Спробуйте ще раз або скористайтеся інструментом знімків екрана вашого браузера.',
  'fileViewer.exportImageModalSubtitle': 'Виберіть формат, а потім завантажте поточний попередній перегляд як зображення.',
  'fileViewer.exportImageFormatLabel': 'Формат',
  'fileViewer.exportImageSaving': 'Збереження зображення…',
  'fileViewer.exportImageSaved': 'Зображення збережено',
  'fileViewer.exportImageDownloadStarted': 'Завантаження розпочато',
  'fileViewer.exportImageDownloadDetails': '{filename} знаходиться у завантаженнях браузера, якщо вікно «Зберегти як» не з’явилося.',
  'fileViewer.exportJsx': 'Експортувати як JSX',
  'fileViewer.exportReactHtml': 'Експортувати попередній перегляд як HTML',
  'fileViewer.exportStarted': 'Експорт розпочато',
  'fileViewer.saveAsTemplate': 'Зберегти як шаблон…',
  'fileViewer.savingTemplate': 'Збереження шаблону…',
  'fileViewer.savedTemplate': 'Збережено як "{name}"',
  'fileViewer.savedTemplateFail': 'Не вдалося зберегти шаблон — спробуйте ще раз.',
  'fileViewer.templateNamePrompt': 'Назва шаблону',
  'fileViewer.templateNameDefault': 'Шаблон без назви',
  'fileViewer.templateDescPrompt': 'Короткий опис (необов\'язково — що робить цей шаблон корисним?)',
  'liveArtifact.refresh.button': 'Оновити',
  'liveArtifact.refresh.buttonTitle': 'Оновити live-артефакт',
  'liveArtifact.refresh.loadingTitle': 'Оновлення live-артефакту…',
  'liveArtifact.refresh.noSourceTitle': 'Джерело оновлення недоступне',
  'liveArtifact.refresh.running': 'Оновлення…',
  'liveArtifact.refresh.runningMessage': 'Агент оновлює цей live-артефакт.',
  'liveArtifact.refresh.runningAction': 'Переглянути виконання',
  'liveArtifact.refresh.successOne': 'Оновлення завершено. Дані оновлено.',
  'liveArtifact.refresh.successMany': 'Оновлення завершено. Дані оновлено.',
  'liveArtifact.refresh.successAction': 'Переглянути зміни',
  'liveArtifact.refresh.previousFailure': 'Попереднє оновлення не вдалося: {message}',
  'liveArtifact.refresh.failureAction': 'Переглянути деталі',
  'liveArtifact.refresh.networkFailure': 'Не вдалося звʼязатися з локальним фоновим процесом.',
  'liveArtifact.refresh.genericFailure': 'Не вдалося оновити live-артефакт.',
  'liveArtifact.refresh.statusNever': 'Ще не оновлювався',
  'liveArtifact.refresh.statusReady': 'Готовий до оновлення',
  'liveArtifact.refresh.statusSucceeded': 'Оновлено',
  'liveArtifact.refresh.statusFailed': 'Оновлення не вдалося',
  'liveArtifact.refresh.statusRunning': 'Оновлення',
  'liveArtifact.refresh.statusRunningDescription': 'Наразі виконується оновлення.',
  'liveArtifact.refresh.statusSucceededDescription': 'Останнє оновлення завершилося успішно.',
  'liveArtifact.refresh.statusFailedDescription': 'Остання спроба оновлення завершилася невдало.',
  'liveArtifact.refresh.statusReadyDescription': 'Джерела для оновлення налаштовано, але жодне оновлення не виконується.',
  'liveArtifact.refresh.statusNeverDescription': 'Цей живий артефакт ще не має джерела оновлення.',
  'liveArtifact.refresh.eventStarted': 'Розпочато',
  'liveArtifact.refresh.eventSucceeded': 'Успішно',
  'liveArtifact.refresh.eventFailed': 'Невдало',
  'liveArtifact.refresh.eventStartedDetail': 'Оновлення розпочато…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'Оновлено {n} джерело',
  'liveArtifact.refresh.sourcesUpdatedMany': 'Оновлено {n} джерел',
  'liveArtifact.refresh.timelineEmpty': 'У цьому сеансі ще не було оновлень. Запустіть оновлення, щоб записати хронологію, або зачекайте на автоматичні запуски.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Востаннє оновлено',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Ніколи',
  'liveArtifact.refresh.justNow': 'щойно',
  'liveArtifact.refresh.factCreated': 'Створено',
  'liveArtifact.refresh.factLastUpdated': 'Востаннє оновлено',
  'liveArtifact.refresh.factUnknown': 'Невідомо',
  'liveArtifact.refresh.persistedTitle': 'Збережена історія оновлень',
  'liveArtifact.refresh.persistedHint': 'Записи завантажено з refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Збереженої історії оновлень ще немає.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'успішно',
  'liveArtifact.refresh.persistedStatusRunning': 'виконується',
  'liveArtifact.refresh.persistedStatusFailed': 'не вдалося',
  'liveArtifact.refresh.persistedStatusCancelled': 'скасовано',
  'liveArtifact.refresh.persistedStatusSkipped': 'пропущено',
  'liveArtifact.refresh.sessionTitle': 'Активність сеансу',
  'liveArtifact.refresh.sessionHint': 'Події, зафіксовані, поки відкрита ця вкладка',
  'liveArtifact.refresh.docSourceTitle': 'Джерело документа',
  'liveArtifact.refresh.docSourceHint': 'Джерело налаштовано',
  'liveArtifact.refresh.docSourceType': 'Тип',
  'liveArtifact.refresh.docSourceTool': 'Інструмент',
  'liveArtifact.refresh.docSourceConnector': 'Конектор',
  'liveArtifact.refresh.debugSummary': 'Розширені діагностичні метадані',
  'liveArtifact.refresh.debugNote': 'Можуть містити ідентифікатори конекторів, назви файлів, метадані джерела та внутрішні шляхи до артефактів.',
  'liveArtifact.viewer.tabPreview': 'Попередній перегляд',
  'liveArtifact.viewer.tabCode': 'Код',
  'liveArtifact.viewer.tabData': 'Дані',
  'liveArtifact.viewer.tabRefreshHistory': 'Історія оновлень',
  'liveArtifact.viewer.dataEmpty': 'Кеш data.json недоступний.',
  'liveArtifact.viewer.code.templateHeading': 'HTML шаблону',
  'liveArtifact.viewer.code.renderedHeading': 'Згенерований HTML',
  'liveArtifact.viewer.code.templateHelp': 'Редагований шаблон, що використовується з data.json для створення попереднього перегляду.',
  'liveArtifact.viewer.code.renderedHelp': 'Згенерований index.html, який зараз завантажує попередній перегляд.',
  'liveArtifact.viewer.code.variantAria': 'Варіант коду',
  'liveArtifact.viewer.code.variantTemplate': 'Шаблон',
  'liveArtifact.viewer.code.variantRendered': 'Згенеровано',
  'liveArtifact.viewer.code.loading': 'Завантаження коду…',
  'liveArtifact.viewer.code.unavailable': 'Код ще недоступний.',
  'liveArtifact.viewer.code.empty': 'Цей файл коду порожній.',
  'fileViewer.deployToVercel': 'Розгорнути на Vercel',
  'fileViewer.redeployToVercel': 'Розгорнути повторно',
  'fileViewer.deployingToVercel': 'Розгортання на Vercel…',
  'fileViewer.deployProviderLabel': 'Провайдер',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Розгорнути на {provider}',
  'fileViewer.redeployToProvider': 'Розгорнути повторно на {provider}',
  'fileViewer.deployingToProvider': 'Розгортання на {provider}…',
  'fileViewer.preparingPublicLink': 'Підготовка публічного посилання…',
  'fileViewer.copyDeployLink': 'Копіювати посилання',
  'fileViewer.deployModalTitle': 'Розгорнути',
  'fileViewer.deployModalSubtitle': 'Використайте акаунт вибраного провайдера, щоб розгорнути цей HTML-перегляд.',
  'fileViewer.vercelToken': 'Токен Vercel',
  'fileViewer.vercelTokenGetLink': 'Отримати токен Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Вставте свій токен Vercel',
  'fileViewer.vercelTokenReuseHint': 'Збережений токен буде використаний. Введіть новий токен, щоб замінити його.',
  'fileViewer.vercelTokenRequired': 'Спочатку введіть та збережіть токен Vercel.',
  'fileViewer.cloudflareApiToken': 'Токен API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Отримати токен API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Вставте токен API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Збережений токен API Cloudflare буде використаний. Введіть новий токен, щоб замінити його.',
  'fileViewer.cloudflareApiTokenRequired': 'Спочатку введіть та збережіть токен API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Під час створення токена API виберіть Pages Edit; для власних доменів потрібні Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID команди',
  'fileViewer.vercelTeamSlug': 'Слаг команди',
  'fileViewer.cloudflareAccountId': 'ID акаунта',
  'fileViewer.cloudflareAccountIdHint': 'ID акаунта можна знайти в панелі Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Спочатку введіть і збережіть Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Домен',
  'fileViewer.cloudflareZonePlaceholder': 'Збережіть налаштування Cloudflare, щоб завантажити домени',
  'fileViewer.cloudflareZoneRequired': 'Спочатку виберіть домен Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Завантаження доменів Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Оновити домени',
  'fileViewer.cloudflareZonesLoadFailed': 'Не вдалося завантажити домени Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Для цього облікового запису не знайдено активних повних доменів Cloudflare.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Префікс субдомену',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Використовуйте лише одну DNS-мітку: малі літери, цифри та дефіси.',
  'fileViewer.cloudflareHostnamePreview': 'Попередній перегляд власного домену: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Необов’язково: прив’яжіть власний домен. Якщо залишити поле порожнім, посилання pages.dev усе одно буде створено.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Власний домен',
  'fileViewer.optional': 'Необов’язково',
  'fileViewer.vercelPreviewOnly': 'Розгортання наразі лише для попереднього перегляду.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages використовує Direct Upload.',
  'fileViewer.savingConfig': 'Збереження…',
  'fileViewer.deployConfigSaveFailed': 'Не вдалося зберегти налаштування Vercel.',
  'fileViewer.deployFailed': 'Розгортання не вдалося. Перевірте налаштування Vercel та спробуйте ще раз.',
  'fileViewer.deployProviderConfigSaveFailed': 'Не вдалося зберегти налаштування {provider}.',
  'fileViewer.deployProviderFailed': 'Розгортання на {provider} не вдалося. Перевірте налаштування й спробуйте ще раз.',
  'fileViewer.deployResultLabel': 'URL розгортання',
  'fileViewer.deployLinkReady': 'Готово',
  'fileViewer.deploySuccessToast': 'Розгортання успішно завантажено',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Публічне посилання очікує',
  'fileViewer.deployLinkDelayed': 'Сайт розгорнуто. Провайдер ще готує публічне посилання.',
  'fileViewer.deployLinkFailed': 'Не вдалося налаштувати власний домен',
  'fileViewer.deployLinkProtectedLabel': 'Захист розгортання ввімкнено',
  'fileViewer.deployLinkProtected': 'Сайт розгорнуто, але це посилання попереднього перегляду вимагає автентифікації. Вимкніть Deployment Protection або використайте власний домен.',
  'fileViewer.retryLink': 'Повторити зараз',
  'questionForm.submit': 'Надіслати',
  'questionForm.skip': 'Пропустити',
  'questionForm.locked': 'Відповідь дано',
  'conv.switch': 'Перемкнути розмову',
  'conv.label': 'Розмова',
  'conv.heading': 'Розмови',
  'conv.new': '+ Нова',
  'conv.empty': 'Розмов ще немає.',
  'conv.untitled': 'Розмова без назви',
  'conv.renameTooltip': 'Двічі натисніть, щоб перейменувати',
  'conv.delete': 'Видалити розмову',
  'conv.deleteConfirm': 'Видалити "{title}"? Це видалить усі її повідомлення.',
  'agentPicker.label': 'Агент',
  'agentPicker.modeChoose': 'Виберіть режим виконання',
  'agentPicker.localCli': 'Локальний CLI',
  'agentPicker.daemonOff': 'фоновий процес вимкнений',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Виберіть виявлений CLI кодового агента',
  'agentPicker.noAgents': 'немає агентів на PATH',
  'agentPicker.notInstalled': 'не встановлено',
  'agentPicker.rescan': 'Повторно сканувати локальний PATH для агентів',
  'tool.openInTab': 'Відкрити {name} на вкладці',
  'tool.open': 'відкрити',
  'tool.todos': 'Завдання',
  'tool.todosExpand': 'Показати завдання',
  'tool.todosCollapse': 'Сховати завдання',
  'tool.todosDone': 'Готово',
  'tool.todosDismiss': 'Закрити список завдань',
  'tool.write': 'Написати',
  'tool.edit': 'Редагувати',
  'tool.read': 'Читати',
  'tool.delete': 'Видалити',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Отримати',
  'tool.search': 'Пошук',
  'tool.lines': '{n} рядків',
  'tool.changeSingular': 'змінення',
  'tool.changePlural': 'змінення',
  'tool.in': 'в {path}',
  'tool.hide': 'приховати',
  'tool.output': 'вихід',
  'tool.running': 'виконується…',
  'tool.error': 'помилка',
  'tool.done': 'готово',
  'assistant.role': 'Асистент',
  'assistant.workingLabel': 'Роботи',
  'assistant.doneLabel': 'Готово',
  'assistant.copyMarkdown': 'Скопіювати Markdown відповіді',
  'assistant.forkConversation': 'Створити форк звідси',
  'assistant.forkingConversation': 'Створення форка…',
  'assistant.shareToOpenDesign': 'Поділитися з Open Design',
  'assistant.shareToOpenDesignBusy': 'Готуємо пакет…',
  'assistant.feedbackPrompt': 'Відгук',
  'assistant.feedbackPositive': 'Корисно',
  'assistant.feedbackNegative': 'Не корисно',
  'assistant.feedbackReasonTitle': 'Розкажіть, чому',
  'assistant.feedbackReasonPositiveMatched': 'Зрозумів мій запит',
  'assistant.feedbackReasonPositiveVisual': 'Виглядає добре',
  'assistant.feedbackReasonPositiveUseful': 'Корисна структура',
  'assistant.feedbackReasonPositiveEasy': 'Легко редагувати далі',
  'assistant.feedbackReasonPositiveDesignSystem': 'Дотримано системи дизайну',
  'assistant.feedbackReasonNegativeMissed': 'Не врахував мій запит',
  'assistant.feedbackReasonNegativeVisual': 'Візуальна якість потребує доопрацювання',
  'assistant.feedbackReasonNegativeIncomplete': 'Неповний результат',
  'assistant.feedbackReasonNegativeHard': 'Складно використовувати',
  'assistant.feedbackReasonNegativeDesignSystem': 'Не дотримано системи дизайну',
  'assistant.feedbackReasonOther': 'Інше',
  'assistant.feedbackReasonPlaceholder': 'Додайте короткий коментар...',
  'assistant.feedbackReasonSubmit': 'Надіслати',
  'assistant.emptyResponseLabel': 'Немає результату',
  'assistant.emptyResponseMessage': 'Провайдер завершив запит, не повернувши тексту чи артефакту. Спробуйте іншу модель або провайдера, перевірте квоту чи повторіть спробу.',
  'assistant.unfinishedLabel': 'Зупинено з незавершеною роботою',
  'assistant.unfinishedSummary': 'залишилось {n} завдання(нь)',
  'assistant.unfinishedMore': '+ще {n}',
  'assistant.continueRemaining': 'Продовжити залишкові завдання',
  'chat.resumeRunCta': 'Продовжити виконання',
  'assistant.outTokens': '{n} вихід',
  'assistant.producedFiles': 'Файли з цієї черги',
  'assistant.openFile': 'Відкрити',
  'assistant.downloadFile': 'Завантажити',
  'nextStep.title': 'Наступний крок',
  'nextStep.more': 'Більше',
  'nextStep.share': 'Поділитися',
  'nextStep.download': 'Завантажити',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Зробити внесок',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Створюємо дизайн...',
  'assistant.thinking': 'Мислення',
  'assistant.thought': 'Подумав',
  'assistant.thoughtFor': 'Думав {s}с',
  'assistant.systemReminder': 'Системне нагадування',
  'assistant.possiblePromptInjection': 'Можлива ін’єкція промпту',
  'assistant.waitingFirstOutput': 'Очікування першого виходу',
  'assistant.statusBootingAgent': 'Завантаження агента',
  'assistant.statusPreparing': 'Підготовка...',
  'assistant.statusStarting': 'Запуск',
  'assistant.statusRequesting': 'Надсилання запиту',
  'assistant.statusThinking': 'Мислення',
  'assistant.statusStreaming': 'Потоком',
  'assistant.slowHint': 'Займає більше часу, ніж зазвичай. Форма зазвичай з\'являється за 5–10 с — ви можете зупинити та переформулювати.',
  'assistant.verbEditing': 'Редагування',
  'assistant.verbWriting': 'Написання',
  'assistant.verbReading': 'Читання',
  'assistant.verbSearching': 'Пошук',
  'assistant.verbRunning': 'Виконання',
  'assistant.verbTodos': 'Завдання',
  'assistant.verbFetching': 'Отримання',
  'assistant.verbCalling': 'Виклик',
  'qf.answered': 'відповідь дано',
  'qf.choose': 'Виберіть…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.required': 'обов\'язково',
  'qf.lockedSubmitted': 'Відповіді надіслано — агент використовуватиме їх для решти сеансу.',
  'qf.lockedPrev': 'Ця форма з попередньої черги.',
  'qf.hint': 'Виберіть те, що підходить. Пропустіть необов\'язкові поля, які вас не цікавлять — агент використовуватиме розумні значення за замовчуванням.',
  'qf.submitDefault': 'Надіслати відповіді',
  'qf.submitDisabledTitle': 'Спочатку заповніть обов\'язкові поля',
  'qf.submitTitle': 'Надіслати відповіді',
  'qf.cardSelected': 'вибрано',
  'qf.cardRefs': 'Посилання:',
  'qf.cardSampleText': 'Швидка коричнева лисиця · 0123',
  'questions.tabLabel': 'Запитання',
  'questions.banner': 'Не проти, якщо я поставлю кілька швидких запитань?',
  'questions.bannerAnswered': 'На запитання дано відповідь',
  'questions.continue': 'Продовжити',
  'questions.generating': 'Генерація запитань…',
  'questions.skipAll': 'Пропустити все',
  'questions.autoSkipHint': 'Автоматично продовжується після завершення таймера',
  'questions.submitting': 'Надсилання…',
  'sketch.toolSelect': 'Виділення (без ефекту)',
  'sketch.toolPen': 'Ручка',
  'sketch.toolText': 'Текст',
  'sketch.toolRect': 'Прямокутник',
  'sketch.toolArrow': 'Стрілка',
  'sketch.toolEraser': 'Ластик',
  'sketch.color': 'Колір',
  'sketch.strokeSize': 'Товщина лінії',
  'sketch.undo': 'Скасувати',
  'sketch.clear': 'Очистити',
  'sketch.close': 'Закрити',
  'sketch.closeConfirm': 'Закрити ескіз і скасувати незбережені зміни?',
  'sketch.textPrompt': 'Текст:',
  'sketch.textModalTitle': 'Додати текст',
  'critiqueTheater.userFacingName': 'Журі дизайну',
  'critiqueTheater.roleDesigner': 'Дизайнер',
  'critiqueTheater.roleCritic': 'Критик',
  'critiqueTheater.roleBrand': 'Бренд',
  'critiqueTheater.roleA11y': 'Доступність',
  'critiqueTheater.roleCopy': 'Копіювати',
  'critiqueTheater.roundLabel': 'Раунд {n} з {m}',
  'critiqueTheater.mustFix': '{n} обов\'язкових до виправлення',
  'critiqueTheater.composite': 'Зведений',
  'critiqueTheater.threshold': 'Поріг',
  'critiqueTheater.consensus': 'Консенсус',
  'critiqueTheater.interrupt': 'Перервати',
  'critiqueTheater.interrupting': 'Переривання…',
  'critiqueTheater.interrupted': 'Перервано',
  'critiqueTheater.degradedHeading': 'Панель офлайн у цьому запуску',
  'critiqueTheater.degradedReasonMalformed': 'Некоректний вивід панелі (парсер відхилив блок).',
  'critiqueTheater.degradedReasonOversize': 'Вивід панелі перевищив безпечний ліміт байтів.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} не підтримує протокол Critique.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} надіслав непідтримувану версію протоколу.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Запуск завершився без підсумкового артефакту.',
  'critiqueTheater.replay': 'Відтворити',
  'critiqueTheater.replaySpeed': 'Швидкість відтворення',
  'critiqueTheater.readOnly': 'Лише для читання',
  'critiqueTheater.shippedSummary': 'Випущено на раунді {round} · композит {composite}',
  'critiqueTheater.interruptedSummary': 'Перервано на раунді {round} · найкращий композит {composite}',
  'critiqueTheater.shippedBadge': 'Відправлено',
  'critiqueTheater.belowThresholdBadge': 'Нижче порогу',
  'critiqueTheater.timedOutBadge': 'Час вичерпано',
  'critiqueTheater.failedHeading': 'Запуск не вдався',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI завершився з ненульовим кодом до завершення роботи панелі.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Раунд перевищив відведений ліміт часу.',
  'critiqueTheater.failedReasonTotalTimeout': 'Повний запуск перевищив загальний ліміт часу.',
  'critiqueTheater.failedReasonOrchestrator': 'Внутрішня помилка оркестратора.',
  'critiqueTheater.transcriptEmpty': 'Поки що немає стенограми для відтворення. Запустіть критику, щоб записати її.',
  'critiqueTheater.transcriptLoading': 'Завантаження транскрипту…',
  'critiqueTheater.transcriptError': 'Не вдалося завантажити стенограму: {error}',
  'critiqueTheater.replaySpeedPaused': 'Призупинено',
  'critiqueTheater.replaySpeedInstant': 'Миттєво',
  'critiqueTheater.replaySpeedLive': 'У реальному часі',
  'critiqueTheater.replaySpeedFast': 'Швидко',
  'critiqueTheater.settingsNav': 'Журі дизайну',
  'critiqueTheater.settingsNavHint': 'Огляд дизайну з п\'яти панелей для ваших запусків',
  'critiqueTheater.settingsEnabledLabel': 'Показувати Журі дизайну під час запусків Agent',
  'critiqueTheater.settingsEnabledDescription': 'Якщо ввімкнено, огляд із п\'яти панелей з\'являється поряд із генераціями Agent і оцінює результат перед відправленням. Ви можете перервати будь-коли.',
  'critiqueTheater.settingsEnabledProjectHint': 'Збережено для цього проєкту. Нові запуски в цьому проєкті проходитимуть через Журі дизайну на боці сервера.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Відкрийте проєкт, щоб зберегти це на боці сервера. До того часу це змінює лише налаштування в браузері.',
  'pet.title': 'Маскоти',
  'pet.subtitle': 'Встановити крихітного супутника, який пливе над вашим робочим простором.',
  'pet.navTitle': 'Маскоти',
  'pet.navHint': 'Встановити або налаштувати',
  'pet.tabBuiltIn': 'Вбудовані',
  'pet.tabBuiltInHint': 'Кураторські супутники в комплекті з Open Design — виберіть один та встановіть.',
  'pet.builtInEmpty': 'Вбудовані маскоти наразі недоступні. Спробуйте оновити вкладку Спільнота, коли фоновий процес перейде в мережу.',
  'pet.tabCustom': 'Власна',
  'pet.tabCustomHint': 'Створіть свою власну назвою, гліфом, кольором або спрайтом.',
  'pet.tabCommunity': 'Спільнота',
  'pet.tabCommunityHint': 'Маскоти, створені Codex — встановіть одну або створіть нову.',
  'pet.tabsAria': 'Джерело маскота',
  'pet.adopt': 'Встановити',
  'pet.adoptedBadge': 'Додано',
  'pet.adoptCallout': 'Додати помічника',
  'pet.changePet': 'Змінити маскота',
  'pet.wake': 'Розбудити',
  'pet.tuck': 'Сховати',
  'pet.wakeTitle': 'Розбудити помічника — показати плаваючу накладку.',
  'pet.tuckTitle': 'Сховати помічника — приховати плаваючу накладку.',
  'pet.settingsTitle': 'Відкрити налаштування маскота',
  'pet.useCustom': 'Використовувати мого маскота',
  'pet.customTitle': 'Створіть свою власну',
  'pet.customHint': 'Виберіть назву, гліф та акцент — накладка оновлюється в режимі реального часу.',
  'pet.customGreetingPlaceholder': 'Привіт від вашої домашної тварини…',
  'pet.fieldName': 'Назва',
  'pet.fieldGlyph': 'Гліф',
  'pet.fieldGlyphHint': 'Один емодзі працює найкраще (напр. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Привіт',
  'pet.fieldAccent': 'Колір акценту',
  'pet.fieldAccentCustom': 'Власний колір',
  'pet.fieldAccentDefault': 'Колір акценту за замовчуванням',
  'pet.overlayAria': 'Супутник домашної тварини',
  'pet.spriteAria': '{name} — перетягніть для переміщення, натисніть для чату',
  'pet.spriteTitle': 'Привіт від {name}! Натисніть для чату.',
  'pet.taskSummarySingle': 'Виконується {count} завдання Agent.',
  'pet.taskSummaryMultiple': '{count} завдань Agent виконуються в {projects} проєктах.',
  'pet.taskSummaryRecentSingle': 'Нещодавно завершено {count} завдання Agent.',
  'pet.taskSummaryRecentMultiple': 'Нещодавно завершено {count} завдань Agent.',
  'pet.taskListAria': 'Активні завдання Agent',
  'pet.taskOpenProject': 'Відкрити {project}',
  'pet.taskGroup.running': 'Виконується',
  'pet.taskGroup.queued': 'Очікування',
  'pet.taskGroup.recent': 'Нещодавно завершені',
  'pet.idleQuote.leonardo.text': 'Навчання ніколи не виснажує розум.',
  'pet.idleQuote.leonardo.author': 'Леонардо да Вінчі',
  'pet.idleQuote.michelangelo.text': 'Я побачив янгола в брилі мармуру й різьбив, доки не звільнив його.',
  'pet.idleQuote.michelangelo.author': 'Мікеланджело',
  'pet.idleQuote.bernini.text': 'Є два засоби, які можуть допомогти скульпторові: світло й тінь.',
  'pet.idleQuote.bernini.author': 'Джан Лоренцо Берніні',
  'pet.idleQuote.raphael.text': 'Коли пишеш картину, не думаєш.',
  'pet.idleQuote.raphael.author': 'Рафаель',
  'pet.idleQuote.caravaggio.text': 'Усі твори, байдуже які чи ким написані, — лише дрібнички та дитячі пустощі, якщо їх не створено й не написано з натури.',
  'pet.idleQuote.caravaggio.author': 'Караваджо',
  'pet.idleQuote.rodin.text': 'Головне — бути зворушеним, любити, сподіватися, тремтіти, жити.',
  'pet.idleQuote.rodin.author': 'Оґюст Роден',
  'pet.composerTitle': 'Маскоти — розбудити, Сховати або виберіть одну',
  'pet.composerMenuTitle': 'Маскоти',
  'pet.composerMenuHint': 'підказка: введіть /pet для перемикання',
  'pet.composerOpenSettings': 'Керувати вихованцями',
  'pet.welcomeTeaserTitle': 'Встановити маскота',
  'pet.welcomeTeaserBody': 'Крихітний плаваючий супутник, який зависає з вами.',
  'pet.welcomeTeaserCta': 'Виберіть один',
  'pet.imageUpload': 'Завантажити спрайт',
  'pet.imageReplace': 'Замінити спрайт',
  'pet.imageRemove': 'Використовувати емодзі',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF або SVG. Завантаження аркушу? Перенесіть горизонтальну смугу та встановіть кількість кадрів.',
  'pet.imageHintActive': 'Показувати ваш спрайт. Встановіть frames > 1, щоб прогулятися по горизонтальному аркушу спрайтів.',
  'pet.fieldFrames': 'Кадри',
  'pet.fieldFramesHint': '1 = статичне. > 1 = горизонтальний аркуш спрайтів.',
  'pet.fieldFps': 'Швидкість (fps)',
  'pet.fieldFpsHint': 'Наскільки швидко циклюються кадри.',
  'pet.atlasImport': 'Імпортувати спрайт Codex',
  'pet.atlasImportTitle': 'Імпортувати атлас hatch-pet 8x9 / 192x208 (PNG або WebP).',
  'pet.atlasPickerTitle': 'Виберіть рядок анімації',
  'pet.atlasPickerHint': 'Codex маскоти мають 9 рядків анімації. За замовчуванням ми зберігаємо повний атлас, щоб домашна тварина міняла рядки при наведенні, перетягуванні та простої. Ви також можете заморозити його на одному циклі.',
  'pet.atlasCancel': 'Відхилити атлас',
  'pet.atlasAdopt': 'Заморозити цей рядок',
  'pet.atlasAdoptFull': 'Використовувати повний атлас (анімований)',
  'pet.atlasAdoptFullTitle': 'Зберігайте кожен рядок, щоб домашна тварина реагувала на наведення, напрям перетягування та довгі простої.',
  'pet.atlasAdoptRowTitle': 'Розташуйте тільки виділений рядок у єдину циклічну смугу.',
  'pet.atlasActiveHint': 'Активний анімований атлас — домашна тварина вибирає рядок з вашої взаємодії (наведення, перетягування, простій).',
  'pet.atlasRow.idle': 'Простій',
  'pet.atlasRow.running-right': 'Біг вправо',
  'pet.atlasRow.running-left': 'Біг вліво',
  'pet.atlasRow.waving': 'Махання',
  'pet.atlasRow.jumping': 'Стрибання',
  'pet.atlasRow.failed': 'Невдача',
  'pet.atlasRow.waiting': 'Очікування',
  'pet.atlasRow.running': 'Біг',
  'pet.atlasRow.review': 'Огляд',
  'pet.hatchTitle': 'Виведіть нову домашну тварину за допомогою AI',
  'pet.hatchHint': 'Використовуйте вбудовану навичку hatch-pet у чаті для генерування спрайту у стилі Codex, а потім імпортуйте його сюди.',
  'pet.hatchConcept': 'Концепція домашної тварини (необов\'язково)',
  'pet.hatchConceptPlaceholder': 'напр. крихітна піксельна собака сиба в затишному светрі',
  'pet.hatchCopy': 'Копіювати підказку',
  'pet.hatchCopied': 'Скопійовано!',
  'pet.hatchFoot': 'Після того, як навичка збереже вашу домашну тварину, повернітеся та виберіть «Імпортувати спрайт Codex».',
  'pet.slashPopoverAria': 'Команди скісної риски',
  'pet.slashPopoverTitle': 'Команди',
  'pet.slashPopoverHint': '↑↓ навігація · enter для вибору · esc для закриття',
  'pet.slashPet': 'Перемикання, встановлення або перехід до параметрів домашної тварини.',
  'pet.slashPetWake': 'Розбудити накладку плаваючої домашної тварини.',
  'pet.slashPetTuck': 'Сховати домашну тварину на цей час.',
  'pet.slashHatch': 'Створити домашну тварину Codex через навичку hatch-pet.',
  'pet.slashHatchArg': '<concept>',
  'pet.slashSearch': 'Шукати в інтернеті через команду OD research.',
  'pet.slashSearchArg': '<запит>',
  'pet.codexTitle': 'Недавно виведені',
  'pet.codexSubtitle': 'Домашні тварини, упаковані навичкою hatch-pet, з\'являються тут для встановлення одним натисненням.',
  'pet.codexSubtitleWithDir': 'Сканування {dir} для домашних тварин, упакованих навичкою hatch-pet.',
  'pet.codexEmpty': 'Виведених домашних тварин ще немає. Введіть /hatch у чаті, щоб створити одну.',
  'pet.codexLoading': 'Пошук виведених домашних тварин…',
  'pet.codexRefresh': 'Оновити',
  'pet.codexAdopt': 'Встановити',
  'pet.codexAdopting': 'Встановлення…',
  'pet.communitySync': 'Завантажити домашних тварин спільноти',
  'pet.communitySyncing': 'Завантаження…',
  'pet.communitySyncTitle': 'Синхронізуйте останніх домашних тварин від Codex Pet Share + j20 Hatchery до ~/.codex/pets/.',
  'pet.communitySyncDone': 'Синхронізовано {wrote} нових домашних тварин ({total} всього).',
  'pet.communitySyncFailed': 'Синхронізація не вдалася: {error}',
  'pet.codexBundled': 'Упаковано',
  'pet.codexBundledTitle': 'Поставляється з Open Design — завантаження не потрібне.',
  'settings.notifications': 'Сповіщення',
  'settings.notificationsHint': 'Звук та сповіщення робочого столу при завершенні завдання',
  'settings.notifyCompletionSound': 'Звук завершення',
  'settings.notifyCompletionSoundHint': 'Відтворюється по завершенні черги. За замовчуванням вимкнено.',
  'settings.notifySuccessSound': 'Звук успіху',
  'settings.notifyFailureSound': 'Звук помилки',
  'settings.notifyDesktop': 'Сповіщення робочого столу',
  'settings.notifyDesktopHint': 'Надіслано, коли вікно не має фокусу.',
  'settings.notifyDesktopBlocked': 'Сповіщення заблоковано браузером. Дозволіть їм у налаштуваннях сайту.',
  'settings.notifyDesktopUnsupported': 'Сповіщення робочого столу недоступні в цьому середовищі.',
  'settings.notifyTest': 'Надіслати тест',
  'settings.notifyTestSent': 'Тестове сповіщення надіслано. Якщо банер не з\'явиться, перевірте налаштування сповіщень браузера та системи.',
  'settings.notifyTestFailed': 'Помилка виклику сповіщення. Перевірте налаштування спoвіщень браузера та системи.',
  'settings.notifySoundDing': 'Дзвенить',
  'settings.notifySoundChime': 'Дзвоник',
  'settings.notifySoundTwoToneUp': 'Два тони вгору',
  'settings.notifySoundPluck': 'Щипок',
  'settings.notifySoundBuzz': 'Гудіння',
  'settings.notifySoundTwoToneDown': 'Два тони вниз',
  'settings.notifySoundThud': 'Глухий звук',
  'settings.skills': 'Навички',
  'settings.skillsHint': 'Функціональні навички, які агент може викликати під час задачі',
  'settings.skillsNew': 'Нова навичка',
  'settings.skillsEmpty': 'Виберіть навичку зліва або створіть нову.',
  'settings.skillsEdit': 'Редагувати',
  'settings.skillsDelete': 'Видалити',
  'settings.skillsDeleteConfirm': 'Підтвердити видалення',
  'settings.skillsName': 'Назва',
  'settings.skillsTriggers': 'Тригери (через кому або з нового рядка)',
  'settings.skillsDescription': 'Опис',
  'settings.skillsBody': 'Вміст SKILL.md',
  'settings.skillsCreate': 'Створити',
  'settings.skillsSave': 'Зберегти',
  'settings.skillsSaving': 'Збереження…',
  'settings.skillsOverrideCreate': 'Створити користувацьке перевизначення',
  'settings.skillsOverrideSave': 'Зберегти як користувацьке перевизначення',
  'settings.skillsBuiltInOverrideWarning': 'Редагування цього вбудованого вміння створює користувацьке перевизначення. Вбудований запис буде приховано зі списку, доки ви не видалите перевизначення. Продовжити?',
  'settings.skillsFiles': 'Файли',
  'settings.skillsNoFiles': 'У теці цієї навички немає файлів.',
  'settings.skillsNameRequired': 'Ім\'я навички обов\'язкове.',
  'settings.skillsBodyRequired': 'Вміст навички обов\'язковий.',
  'settings.designSystems': 'Дизайн-системи',
  'settings.designSystemsHint': 'Переглядайте та вмикайте доступні дизайн-системи',
  'settings.designSystemsInstalled': 'Встановлено',
  'settings.designSystemsAdd': 'Додати дизайн-систему',
  'settings.designSystemsHiddenCount': '{count} приховано з домашньої галереї',
  'settings.designSystemsShowAll': 'Показати всі',
  'settings.designSystemsShowHidden': 'Показати приховані',
  'settings.designSystemsSource': 'Джерело',
  'settings.designSystemsSourceLocal': 'Локально',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Посилання на реєстр shadcn',
  'settings.designSystemsImportShadcn': 'Імпортувати з shadcn',
  'settings.designSystemsStructure': 'Структура',
  'settings.designSystemsModeHybrid': 'Гібридна',
  'settings.designSystemsModeNormalized': 'Нормалізована',
  'settings.designSystemsModeVerbatim': 'Без змін',
  'settings.designSystemsCraft': 'Майстерність',
  'settings.designSystemsCraftColor': 'Колір',
  'settings.designSystemsCraftAccessibility': 'Доступність',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Шлях проєкту',
  'settings.designSystemsImportGithub': 'Імпортувати з GitHub',
  'settings.designSystemsImportProject': 'Імпортувати з проєкту',
  'settings.designSystemsImportedStatus': 'Імпортовано {title}',
  'settings.designSystemsViewImported': 'Переглянути імпортовану дизайн-систему',
  'settings.designSystemsCategory': 'Категорія',
  'settings.designSystemsAllCategories': 'Усі категорії',
  'settings.designSystemsShowInHomeGallery': 'Показувати в домашній галереї',
  'settings.projectLocations': 'Розташування проєктів',
  'settings.projectLocationsHint': 'Корені зберігання робочих просторів',
  'settings.projectLocationsDescription': 'Додайте робочі бази, які можуть містити кілька тек проєктів Open Design. Нові проєкти зберігаються як тека всередині вибраної бази.',
  'settings.projectLocationsSaveError': 'Не вдалося зберегти розташування проєктів. Перевірте, що кожен шлях є доступною текою.',
  'settings.projectLocationsSaved': 'Розташування проєктів збережено.',
  'settings.projectLocationsScanError': 'Не вдалося просканувати розташування проєктів.',
  'settings.projectLocationsScanComplete': 'Сканування завершено: імпортовано {imported}, уже зареєстровано {existing}.',
  'settings.projectLocationsNoFolderSelected': 'Теку не вибрано.',
  'settings.projectLocationsDuplicate': 'Цю робочу базу вже додано.',
  'settings.projectLocationsWorkBaseMeta': 'Робоча база · проєкти створюються тут як підтеки',
  'settings.projectLocationsAddFolder': 'Додати теку…',
  'settings.projectLocationsDefaultBadge': 'Типове розташування',
  'settings.projectLocationsMakeDefault': 'Зробити типовим',
  'settings.projectLocationsDefaultSaved': 'Типове розташування проєкту оновлено.',
  'settings.librarySkills': 'Навички',
  'settings.libraryDesignSystems': 'Системи дизайну',
  'settings.librarySearch': 'Пошук...',
  'settings.libraryAll': 'Усі',
  'settings.libraryPreview': 'Попередній перегляд',
  'settings.libraryPreviewClose': 'Закрити',
  'settings.libraryLoading': 'Завантаження...',
  'settings.libraryNoResults': 'Нічого не знайдено за вашим запитом.',
  'settings.libraryEnabled': 'Увімкнено',
  'settings.libraryDisabled': 'Вимкнено',
  'settings.connectorsNavHint': 'Підключення до зовнішніх систем',
  'settings.connectorsHint': 'Керуйте налаштуваннями конекторів і постачальників інструментів для цього пристрою.',
  'settings.connectorsComposioApiKey': 'API-ключ Composio',
  'settings.connectorsSavedTitle': 'Збережено в локальному daemon',
  'settings.connectorsSavedWithTail': 'Збережено · ••••{tail}',
  'settings.connectorsSaved': 'Збережено',
  'settings.connectorsGetApiKey': 'Отримати API-ключ',
  'settings.connectorsReplaceKeyPlaceholder': 'Вставте новий ключ, щоб замінити збережений',
  'settings.connectorsApiKeyPlaceholder': 'Вставте API-ключ Composio',
  'settings.connectorsClear': 'Очистити',
  'settings.connectorsClearConfirmTitle': 'Очистити збережений ключ API Composio?',
  'settings.connectorsClearConfirmBody': 'Видалення ключа від’єднає усі конектори Composio, прив’язані до цього робочого простору. Підключені облікові записи, дозволи OAuth і доступи до інструментів буде вилучено.',
  'settings.connectorsClearConfirmContinue': 'Продовжити',
  'settings.connectorsClearFinalTitle': 'Це від’єднає всі конектори',
  'settings.connectorsClearFinalBody': 'Скасувати неможливо. Після вставлення нового ключа кожну інтеграцію доведеться під’єднувати з нуля.',
  'settings.connectorsClearFinalConfirm': 'Видалити ключ і від’єднати',
  'settings.connectorsClearArming': 'Хвилинку…',
  'settings.connectorsClearCancel': 'Скасувати',
  'settings.connectorsSaveKey': 'Зберегти ключ',
  'settings.connectorsSaveKeyTitle': 'Надіслати цей ключ локальному демону',
  'settings.connectorsKeySaving': 'Збереження…',
  'settings.connectorsKeySaved': 'Збережено ✓',
  'settings.connectorsKeyError': 'Не вдалося зберегти ключ. Перевірте, чи запущено локальний демон, і спробуйте ще раз.',
  'settings.connectorsHelpSaved': 'Ваш ключ відкриває каталог нижче й залишається в локальному daemon. Вставте новий ключ, щоб замінити його, або очистіть, щоб видалити.',
  'settings.connectorsHelpUnsaved': 'Незбережені зміни — натисніть «Зберегти ключ», щоб надіслати ці дані локальному демону і відкрити каталог нижче.',
  'settings.connectorsHelpEmpty': 'Додайте ключ, щоб відкрити каталог нижче. Ключі зберігаються локально в daemon і ніколи не надсилаються через змінні середовища.',
  'settings.connectorsLoadingSavedKey': 'Перевірка збереженого ключа в локальному daemon…',
  'settings.autosaveSaving': 'Збереження…',
  'settings.autosaveSaved': 'Усі зміни збережено',
  'settings.autosaveError': 'Не вдалося зберегти зміни. Можливо, локальний демон офлайн.',
  'settings.libraryToggleLabel': 'Перемкнути',
  'settings.memory': 'Пам\'ять',
  'settings.memoryHint': 'Збережені факти та контекст для майбутніх чатів',
  'settings.customInstructionsTitle': 'Глобальні правила',
  'settings.customInstructionsHint': 'Незмінні інструкції, яких Open Design має дотримуватися в кожному чаті. Зберігайте факти, уподобання та контекст проєкту як спогади.',
  'settings.customInstructionsPlaceholder': 'напр. «Завжди використовуй TypeScript. Надавай перевагу функціональним компонентам. Тримай відповіді стислими.»',
  'settings.memoryDescription': 'Керуйте тим, чи повторно використовуються збережені факти, налаштування та контекст проєкту в майбутніх чатах.',
  'settings.memoryEnabled': 'Увімкнено',
  'settings.memoryDisabled': 'Вимкнено',
  'settings.memoryEnableLabel': 'Увімкнути впровадження пам\'яті',
  'settings.memoryDisabledBanner': 'Пам\'ять зараз ВИМКНЕНА. Наявні факти зберігаються на диску, але не додаватимуться до нових чатів, а нові репліки не вилучатимуть нічого нового.',
  'settings.memoryNew': 'Новий спогад',
  'settings.memoryEdit': 'Редагувати',
  'settings.memoryDelete': 'Видалити',
  'settings.memoryPreview': 'Попередній перегляд',
  'settings.memoryEmpty': 'Поки що немає спогадів.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Я надаю перевагу темному режиму',
  'settings.memoryName': 'напр. налаштування інтерфейсу',
  'settings.memoryDesc': 'Одне речення — про що цей запис памʼяті?',
  'settings.memoryBody': '- Правило перше\n- Правило друге\n\nЧому: необовʼязкова причина\nКоли застосовувати: необовʼязкова сфера',
  'settings.memoryBodyHint': 'Спочатку перелічіть правила маркерами, потім необовʼязкові рядки «Чому» та «Коли застосовувати». Підтримується Markdown. Або натисніть стартовий шаблон вище, щоб завантажити робочий приклад.',
  'settings.memoryStartersLabel': 'Потрібна відправна точка? Натисніть, щоб заповнити форму:',
  'settings.memoryStarterUserName': 'Моя роль',
  'settings.memoryStarterUserDesc': 'Я frontend-інженер, який працює над інструментом для дизайну SaaS',
  'settings.memoryStarterUserBody': '- Роль: старший frontend-інженер\n- Стек: React, TypeScript, Vite\n- Домен: інструменти для дизайну / співпраці\n- Часовий пояс: GMT+8 (Asia/Shanghai)\n\nКоли застосовувати: будь-який чат — будуйте приклади навколо вебфронтенду.',
  'settings.memoryStarterFeedbackName': 'Налаштування інтерфейсу',
  'settings.memoryStarterFeedbackDesc': 'Темний режим, великий основний текст, низька щільність інформації',
  'settings.memoryStarterFeedbackBody': '- Тема: темна за замовчуванням\n- Основний текст: ≥ 18px\n- Щільність інформації: надавайте перевагу простору, менше елементів на екран\n\nЧому: менше навантаження на очі під час тривалих сесій.\nКоли застосовувати: щоразу, коли ви генеруєте UI, вебсторінки або слайди.',
  'settings.memoryStarterProjectName': 'Поточний проєкт',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — редактор дизайну на основі чату',
  'settings.memoryStarterProjectBody': '- Мета: випустити редактор на основі чату цього кварталу\n- Пріоритети: потокове відображення, локальна мультимодальність, offline-first\n- Стек: Next.js 16, демон Express, SQLite\n\nКоли застосовувати: у будь-якій розмові про цей проєкт.',
  'settings.memorySaveHint': 'Не зберігається автоматично — натисніть «Створити» / «Зберегти», щоб застосувати.',
  'settings.memoryIndexSaveHint': 'Зміни в індексі не зберігаються автоматично — натисніть «Зберегти індекс», щоб застосувати.',
  'settings.memoryIndexUnsaved': 'Незбережені зміни',
  'settings.memoryFlashCreated': '✓ Пам\'ять створено',
  'settings.memoryFlashSaved': '✓ Пам\'ять збережено',
  'settings.memoryFlashDeleted': '✓ Пам\'ять видалено',
  'settings.memoryFlashIndexSaved': '✓ Індекс збережено',
  'settings.memoryFlashPathCopied': '✓ Шлях скопійовано',
  'settings.memoryNameLabel': 'Заголовок',
  'settings.memoryTypeLabel': 'Тип',
  'settings.memoryDescLabel': 'Опис',
  'settings.memoryBodyLabel': 'Вміст',
  'settings.memoryTypeUser': 'Користувач',
  'settings.memoryTypeFeedback': 'Відгук',
  'settings.memoryTypeProject': 'Проєкт',
  'settings.memoryTypeReference': 'Довідка',
  'settings.memoryIndex': 'MEMORY.md (індекс)',
  'settings.memoryIndexSave': 'Зберегти індекс',
  'settings.memoryIndexReset': 'Скинути',
  'settings.memoryToastChanged': 'Пам\'ять оновлено',
  'settings.memoryToastClickHint': 'Переглянути',
  'settings.memoryAll': 'Усі',
  'settings.memoryExtractions': 'Історія вилучень',
  'settings.memoryExtractionsHint': 'Спочатку виконується Regex, LLM працює у фоновому режимі.',
  'settings.memoryExtractionsEmpty': 'Поки що немає вилучень. Наступна репліка чату заповнить цей список.',
  'settings.memoryExtractionsRefresh': 'Оновити',
  'settings.memoryExtractionsRefreshing': 'Оновлення…',
  'settings.memoryExtractionPhaseRunning': 'Виконання…',
  'settings.memoryExtractionPhaseSuccess': 'Успіх',
  'settings.memoryExtractionPhaseSkipped': 'Пропущено',
  'settings.memoryExtractionPhaseFailed': 'Не вдалося',
  'settings.memoryExtractionSkipNoProvider': 'Не налаштовано API key для вилучення пам\'яті через LLM.',
  'settings.memoryExtractionSkipDisabled': 'Пам\'ять вимкнено.',
  'settings.memoryExtractionSkipEmpty': 'Порожнє повідомлення користувача — нічого витягувати.',
  'settings.memoryExtractionSkipNoMatch': 'Жоден шаблон regex не збігся в цій репліці.',
  'settings.memoryExtractionKindHeuristic': 'регулярний вираз',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'змінні середовища',
  'settings.memoryExtractionProviderMediaConfig': 'налаштування медіа',
  'settings.memoryExtractionProviderOverride': 'налаштування пам\'яті',
  'settings.memoryExtractionProposed': 'запропоновано',
  'settings.memoryExtractionWritten': 'записано',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Видалити',
  'settings.memoryExtractionsClear': 'Очистити',
  'settings.memoryExtractionsClearTitle': 'Очистити всю історію вилучень',
  'settings.memoryExtractionsClearConfirm': 'Очистити всю історію вилучень? Цю дію не можна скасувати.',
  'settings.memoryNoProviderBannerTitle': 'Вилучення пам\'яті через LLM не запущено',
  'settings.memoryNoProviderBannerBody': 'Не знайдено API key для екстрактора пам\'яті. Додайте ключ OpenAI у розділі «Постачальники медіа» або встановіть ANTHROPIC_API_KEY / OPENAI_API_KEY у середовищі, щоб увімкнути вилучення на основі LLM. Евристичне вилучення через regex усе ще активне.',
  'settings.libraryInstall': 'Встановити',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Локальний шлях',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Встановити',
  'settings.libraryUninstall': 'Видалити',
  'settings.libraryBuiltIn': 'Вбудований',
  'settings.libraryInstalled': 'Встановлено',
  'notify.successTitle': 'Завдання завершено',
  'notify.failureTitle': 'Завдання не вдалося',
  'notify.successBody': 'Черга завершена.',
  'notify.failureBody': 'Завдання завершилось помилкою.',
  'updater.available': 'Доступне оновлення',
  'updater.availableBody': 'Open Design {version} доступний. Його буде завантажено перед відкриттям інсталятора.',
  'updater.checking': 'Перевірка оновлень',
  'updater.download': 'Завантажити оновлення',
  'updater.downloading': 'Завантаження оновлення',
  'updater.downloadingPercent': 'Завантаження оновлення {percent}%',
  'updater.done': 'Готово',
  'updater.failed': 'Оновлення не вдалося',
  'updater.installerOpenBody': 'Інсталятор відкрито. Open Design закривається, щоб ви могли завершити оновлення.',
  'updater.installerOpened': 'Інсталятор відкрито',
  'updater.later': 'Пізніше',
  "updater.allowSilentUpdates": "Дозволити тихі оновлення",
  'updater.openFailedFallback': 'Не вдалося відкрити інсталятор.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Установити оновлення',
  'updater.opening': 'Відкриття інсталятора...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Закрити Open Design',
  'updater.quitFailedBody': 'Інсталятор відкрито, але Open Design не вдалося закрити. Закрийте Open Design перед заміною застосунку.',
  'updater.quitFailedTitle': 'Не вдалося закрити',
  'updater.quitting': 'Закриття...',
  'updater.ready': 'Оновлення готове',
  'updater.readyGeneric': 'Нова версія готова. Open Design закриється і відкриє інсталятор.',
  'updater.readyVersion': 'Open Design {version} готовий. Open Design закриється і відкриє інсталятор.',
  'updater.upToDate': 'У вас уже встановлено найновішу версію.',
  'whatsNew.cta': 'Подивитися, що нового',
  'whatsNew.dismissAria': 'Закрити «Що нового»',
  'newsletter.label': 'Розсилка (необов’язково)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'artifact.odCardTaskBriefChip': 'Пам\'ять застосовано · переглянути бриф',
  'artifact.odCardScorecardTitle': 'Самоперевірка',
  'artifact.odCardScorecardStatusPass': 'Пройдено',
  'artifact.odCardScorecardStatusPartial': 'Частково',
  'artifact.odCardScorecardStatusFail': 'Потребує доопрацювання',
  'artifact.odCardRuleKicker': 'Запропоноване правило',
  'artifact.odCardRuleNameLabel': 'Назва',
  'artifact.odCardRuleDescriptionLabel': 'Опис',
  'artifact.odCardRuleAssertionLabel': 'Має виконуватися',
  'artifact.odCardRuleCheckLabel': 'Як перевірити',
  'artifact.odCardRuleRationaleLabel': 'Чому',
  'artifact.odCardRuleKeep': 'Залишити',
  'artifact.odCardRuleEdit': 'Редагувати',
  'artifact.odCardRuleDone': 'Готово',
  'artifact.odCardRuleDiscard': 'Відхилити',
  'artifact.odCardRuleSaving': 'Збереження…',
  'artifact.odCardRuleSaved': 'Збережено «{name}» як правило',
  'artifact.odCardRuleError': 'Не вдалося зберегти правило. Спробуйте ще раз.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'Профіль',
  'settings.memoryTypeRule': 'Правило',
  'settings.memoryTabMemories': 'Спогади',
  'settings.memoryTabMemoriesCaption': 'Перегляд і керування збереженою пам\'яттю',
  'settings.memoryTabHow': 'Як це працює',
  'settings.memoryTabHowCaption': 'Два цикли та їхні елементи керування',
  'settings.memoryAddDisclosure': 'Додати або імпортувати спогади',
  'settings.memoryAddDisclosureHint': 'Профіль, ручне введення або під\'єднані застосунки',
  'settings.memoryProfileTab': 'Робочий профіль',
  'settings.memoryProfileTabCaption': 'Хто ви та ваші налаштування за замовчуванням',
  'settings.memoryProfileTitle': 'Ваш робочий профіль',
  'settings.memoryProfileHint':
    'Кілька фактів про вас і ваші налаштування за замовчуванням. Пам\'ять додає це перед кожним завданням, щоб агент розумів, що ви маєте на увазі, з короткого запиту.',
  'settings.memoryProfileName': 'Робочий профіль',
  'settings.memoryProfileDescription':
    'Роль, компанія, домен, аудиторія, смак і налаштування за замовчуванням, які асистент має повторно використовувати.',
  'settings.memoryProfileSave': 'Зберегти профіль',
  'settings.memoryProfileSaving': 'Збереження…',
  'settings.memoryProfileSaved': 'Профіль збережено',
  'settings.memoryProfileRole': 'Роль',
  'settings.memoryProfileRolePlaceholder': 'напр. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Компанія / Команда',
  'settings.memoryProfileCompanyPlaceholder': 'напр. Acme, growth team',
  'settings.memoryProfileDomain': 'Домен',
  'settings.memoryProfileDomainPlaceholder': 'напр. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Основна аудиторія',
  'settings.memoryProfileAudiencePlaceholder': 'напр. керівники, інженери, кінцеві користувачі',
  'settings.memoryProfileAesthetic': 'Естетика / смак',
  'settings.memoryProfileAestheticPlaceholder':
    'напр. чисто й редакційно, світлі фони, щедрий простір',
  'settings.memoryProfileDeliverables': 'Результати за замовчуванням',
  'settings.memoryProfileDeliverablesPlaceholder': 'напр. landing pages, презентації, one-pagers',
  'settings.memoryProfileLocale': 'Локаль / Мова',
  'settings.memoryProfileLocalePlaceholder': 'напр. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Поточні цілі',
  'settings.memoryProfileGoalsPlaceholder':
    'напр. випустити нову сторінку з цінами, підвищити конверсію пробного потоку',
  'settings.memoryHooksTitle': 'Гачки пам\'яті',
  'settings.memoryHooksHint':
    'Виберіть, які частини пам\'яті виконуються автоматично. Головний перемикач вище вимикає їх усі.',
  'settings.memoryHooksProfileLabel': 'Використовувати мій профіль',
  'settings.memoryHooksProfileDesc': 'Додавати ваш робочий профіль до кожного завдання.',
  'settings.memoryHooksRewriteLabel': 'Переписувати короткі запити',
  'settings.memoryHooksRewriteDesc': 'PRE: розгортати короткий запит у повний бриф завдання.',
  'settings.memoryHooksVerifyLabel': 'Самоперевірка результату',
  'settings.memoryHooksVerifyDesc': 'POST: перевіряти результат за вашими правилами та показувати оцінювальну картку.',
  'settings.memoryHooksExtractionLabel': 'Навчатися з чатів',
  'settings.memoryHooksExtractionDesc': 'Фіксувати корисні факти та вподобання з реплік чату.',
  'settings.orbit.eyebrow': 'Автоматизація',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Щоденний підсумок конекторів',
  'settings.orbit.lede': 'Збирати активність конекторів за розкладом і публікувати результат як оновлюваний live artifact.',
  'settings.orbit.statusOnTitle': 'Щоденні запуски за розкладом увімкнені',
  'settings.orbit.statusOffTitle': 'Щоденні запуски за розкладом вимкнені',
  'settings.orbit.statusActive': 'Активно',
  'settings.orbit.statusOff': 'Вимкнено',
  'settings.orbit.runTitle': 'Запустити Orbit і відкрити живу розмову',
  'settings.orbit.running': 'Виконується…',
  'settings.orbit.runOpen': 'Запустити зараз',
  'settings.orbit.dailySummaryTitle': 'Щоденний підсумок',
  'settings.orbit.dailySummarySub': 'Виконується раз на день у запланований локальний час.',
  'settings.orbit.on': 'Увімкнено',
  'settings.orbit.off': 'Вимкнено',
  'settings.orbit.runTimeTitle': 'Час запуску',
  'settings.orbit.runTimeSub': 'За замовчуванням 08:00. Збережіть, щоб застосувати розклад daemon.',
  'settings.orbit.runTimeAria': 'Час щоденного запуску Orbit',
  'settings.orbit.nextRun': 'Наступний запуск',
  'settings.orbit.nextRunScheduledAfterSave': 'Заплановано після збереження',
  'settings.orbit.schedule': 'Розклад',
  'settings.orbit.pausedManualOnly': 'Призупинено — лише ручні запуски',
  'settings.orbit.templateTitle': 'Шаблон prompt',
  'settings.orbit.templateMissing': 'Шаблон {id} не встановлено.',
  'settings.orbit.templateMissingOption': '{id} (немає)',
  'settings.orbit.templateMissingInstall': 'Установіть skill Orbit, щоб спрямовувати prompt.',
  'settings.orbit.templateMissingPickAnother': 'Виберіть інший шаблон у списку.',
  'settings.orbit.templateResetTitle': 'Скинути до {id}',
  'settings.orbit.templateReset': 'Скинути',
  'settings.orbit.templateHelp': 'Спрямовуйте Orbit за допомогою skill — приклад prompt вибраного шаблону додається до кожного запуску Orbit, щоб підсумки мали форму цього шаблону.',
  'settings.orbit.templateAria': 'Шаблон prompt Orbit',
  'settings.orbit.templatesLoading': 'Завантаження шаблонів…',
  'settings.orbit.templatesOptgroup': 'Шаблони skills Orbit',
  'settings.orbit.lastRun': 'Останній запуск',
  'settings.orbit.triggerManual': 'Вручну',
  'settings.orbit.triggerScheduled': 'За розкладом',
  'settings.orbit.meterAria': '{succeeded} успішно, {skipped} пропущено, {failed} з помилкою з {checked} перевірено',
  'settings.orbit.countChecked': 'Перевірено',
  'settings.orbit.countSucceeded': 'Успішно',
  'settings.orbit.countSkipped': 'Пропущено',
  'settings.orbit.countFailed': 'Помилка',
  'settings.orbit.runError': 'Не вдалося запустити Orbit. Переконайтеся, що локальний daemon працює, а конектори налаштовані.',
  'settings.orbit.gateAriaLabel': 'Для роботи Orbit потрібні конектори',
  'settings.orbit.gateEyebrow': 'Потрібне налаштування',
  'settings.orbit.gateTitle': 'Підключіть інструмент, щоб запустити Orbit',
  'settings.orbit.gateBody': 'Orbit узагальнює активність ваших конекторів. Ви ще нічого не підключили — додайте хоча б одну інтеграцію, щоб Orbit мав про що повідомляти.',
  'settings.orbit.gateBodyNoKey': 'Orbit узагальнює активність конекторів, а конектори працюють через Composio. Додайте ключ API Composio у розділі «Конектори», щоб відкрити каталог і обрати першу інтеграцію.',
  'settings.orbit.gateAction': 'Відкрити конектори',
  'settings.orbit.gateActionNoKey': 'Налаштувати Composio',
  'settings.orbit.gateLoading': 'Перевірка конекторів…',
  'settings.orbit.controlsLockedBadge': 'Заблоковано',
  'settings.orbit.controlsLockedHint': 'Підключіть інструмент, щоб розблокувати розклад і шаблон Orbit.',
  'settings.orbit.artifactKickerLive': 'живий артефакт',
  'settings.orbit.artifactKickerLegacy': 'Застарілий підсумок',
  'settings.orbit.artifactTitle': 'Щоденний підсумок активності Orbit',
  'settings.orbit.artifactMetaLive': 'Оновлюваний HTML-артефакт, створений з активності конекторів.',
  'settings.orbit.artifactMetaLegacy': 'Створено до ввімкнення підтримки live artifact — запустіть Orbit знову, щоб опублікувати один.',
  'settings.orbit.copyMarkdownTitle': 'Скопіювати підсумок Markdown у буфер',
  'settings.orbit.copied': 'Скопійовано',
  'settings.orbit.copy': 'Копіювати',
  'settings.orbit.openArtifact': 'Відкрити артефакт',
  'settings.orbit.sourceMarkdown': 'Вихідний Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Пам\'ять використовує окрему від чату модель. За замовчуванням використовується ваша модель чату.',
  'diagnostics.exportTitle': 'Експорт діагностики',
  'diagnostics.exportButton': 'Експорт діагностики',
  'diagnostics.exportHint': 'Збирає останні журнали застосунку та інформацію про пристрій у zip для надсилання команді.',
  'diagnostics.exporting': 'Експортування…',
  'diagnostics.exportSuccess': 'Діагностику збережено: {path}',
  'diagnostics.exportFailed': 'Не вдалося експортувати діагностику: {message}',
  'automations.eyebrow': 'Заплановані сесії Agent',
  'automations.title': 'Автоматизації',
  'automations.lede': 'Плануйте повторювані розмови для роботи над проєктами, дайджестів Orbit та живих артефактів.',
  'automations.summaryAria': 'Зведення автоматизацій',
  'automations.metricActive': 'Активні',
  'automations.metricPaused': 'Призупинені',
  'automations.metricTemplates': 'Шаблони',
  'automations.newAutomation': 'Нова автоматизація',
  'automations.yourAutomations': 'Ваші автоматизації',
  'automations.loading': 'Завантаження',
  'automations.emptyTitle': 'Автоматизацій ще немає',
  'automations.emptyBody': 'Створіть автоматизацію з шаблону або почніть із порожнього розкладу.',
  'automations.targetNewEachRun': 'Новий проєкт під час кожного запуску',
  'automations.targetCreateEachRun': 'Новий проєкт під час кожного запуску',
  'automations.lastRun': 'Останній запуск {time}',
  'automations.openResult': 'Відкрити результат',
  'automations.run': 'Запустити',
  'automations.runNowTitle': 'Запустити зараз і відкрити розмову',
  'automations.history': 'Історія',
  'automations.hideHistory': 'Сховати історію',
  'automations.edit': 'Редагувати',
  'automations.pause': 'Призупинити',
  'automations.resume': 'Відновити',
  'automations.deleteAria': 'Видалити автоматизацію',
  'automations.deleteTitle': 'Видалити цю автоматизацію',
  'automations.deleteConfirm': 'Видалити цю автоматизацію? Минулі запуски та їхні проєкти буде збережено.',
  'automations.proposalsTitle': 'Пропозиції розвитку',
  'automations.proposalsSub': 'Перегляньте результат автоматизації, перш ніж він змінить пам’ять, навички чи дизайн-системи.',
  'automations.proposalsPending': '{n} в очікуванні',
  'automations.apply': 'Застосувати',
  'automations.reject': 'Відхилити',
  'automations.proposalsDismissReason': 'Відхилено в Автоматизаціях',
  'automations.templatesTitle': 'Шаблони',
  'automations.templatesSub': 'Orbit та живі артефакти — це шаблони в межах того самого потоку автоматизації.',
  'automations.templatesCount': '{filtered} з {total}',
  'automations.templateFiltersAria': 'Фільтри шаблонів',
  'automations.templatesEmptyTitle': 'У цій категорії ще немає шаблонів.',
  'automations.templatesEmptyBody': 'Спробуйте інший фільтр або почніть із порожньої автоматизації.',
  'automations.useTemplate': 'Використати шаблон',
  'automations.runHistoryLoading': 'Завантаження історії запусків...',
  'automations.runHistoryEmpty': 'Запусків ще немає.',
  'automations.runHistoryTitle': 'Історія запусків',
  'automations.runHistoryLatest': 'Останні 10',
  'automations.crystallize': 'Кристалізувати',
  'automations.crystallizing': 'Кристалізація',
  'automations.crystallizeTitle': 'Створити чернетки пропозицій навичок і пам’яті з цього запуску',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Відкрити розмову',
  'automations.runHistoryAria': 'Історія запусків автоматизації',
  'automations.proposalsAria': 'Пропозиції розвитку автоматизації',
  'automations.templatesAria': 'Шаблони автоматизацій',
  'automations.runInProgress': 'Виконується',
  'automations.promptPlaceholder': 'Отримати вчорашню активність у GitHub + Linear і підсумувати, що змінилося.',
  'automations.scheduleStatusPaused': 'Призупинено',
  'automations.nextRunManualOnly': 'Лише вручну',
  'automations.nextRunScheduled': 'Заплановано',
  'automations.nextRunAt': 'Наступний {time}',
  'automations.statusSucceeded': 'Успішно',
  'automations.statusFailed': 'Помилка',
  'automations.statusRunning': 'Виконується',
  'automations.statusQueued': 'У черзі',
  'automations.statusCanceled': 'Скасовано',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Живий артефакт',
  'automations.kindAutomation': 'Автоматизація',
  'automations.proposalTargetMemory': 'Пам’ять',
  'automations.proposalTargetDesignSystem': 'Дизайн-система',
  'automations.proposalTargetSkill': 'Навичка',
  'automations.proposalTargetTemplate': 'Шаблон автоматизації',
  'automations.proposalActionCreate': 'Створити',
  'automations.proposalActionUpdate': 'Оновити',
  'automations.proposalActionMerge': 'Об’єднати',
  'automations.proposalActionMove': 'Перемістити',
  'automations.proposalActionDelete': 'Видалити',
  'automations.proposalActionPromote': 'Підвищити',
  'automations.filterAll': 'Усі',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Живі артефакти',
  'automations.filterMemory': 'Пам’ять',
  'automations.filterDesignSystems': 'Дизайн-системи',
  'automations.filterSkills': 'Навички',
  'automations.filterConnectors': 'Конектори',
  'automations.filterCompression': 'Стиснення',
  'automations.filterRelease': 'Реліз',
  'automations.filterQuality': 'Якість',
  'automations.tpl.memoryRefresh.title': 'Оновити пам’ять проєкту на основі нещодавньої роботи.',
  'automations.tpl.memoryRefresh.desc': 'Перетворює повторювані рішення, уподобання та відгуки на придатні для повторного використання оновлення пам’яті.',
  'automations.tpl.designSystemRefresh.title': 'Оновити дизайн-системи на основі випущених артефактів.',
  'automations.tpl.designSystemRefresh.desc': 'Знаходить придатні для повторного використання токени, компоненти та правила в нещодавніх дизайн-роботах.',
  'automations.tpl.liveArtifactRegistry.title': 'Перевірити живі артефакти та оновити застарілі версії.',
  'automations.tpl.liveArtifactRegistry.desc': 'Підтримує актуальність постійних дашбордів, звітів і попередніх переглядів замість їх дублювання.',
  'automations.tpl.orbitDashboard.title': 'Побудувати дашборд активності конекторів.',
  'automations.tpl.orbitDashboard.desc': 'Об’єднує вибрані конектори в живий дашборд у стилі Orbit.',
  'automations.tpl.releaseNotes.title': 'Скласти примітки до релізу на основі випущених дизайн-робіт.',
  'automations.tpl.releaseNotes.desc': 'Поєднує об’єднані PR, артефакти та зміни, орієнтовані на продукт, у примітки до релізу.',
  'automations.tpl.qualityRegressionWatch.title': 'Стежити за регресіями в дизайні та реалізації.',
  'automations.tpl.qualityRegressionWatch.desc': 'Порівнює нещодавні зміни з бенчмарками, трасами та прийнятими еталонами.',
  'automations.tpl.orbitDaily.title': 'Щоденний дайджест конекторів.',
  'automations.tpl.orbitDaily.desc': 'Оновлює дайджест активності конекторів за розкладом.',
  'automations.tpl.liveStatusBoard.title': 'Підтримувати живий артефакт статусу актуальним.',
  'automations.tpl.liveStatusBoard.desc': 'Оновлює один постійний артефакт замість створення нового звіту під час кожного запуску.',
  'dsManager.areaAria': 'Область дизайн-систем',
  'dsManager.tabDesignSystem': 'Дизайн-система',
  'dsManager.tabTemplate': 'Шаблон',
  'dsManager.sourceAria': 'Джерело дизайн-системи',
  'dsManager.templateSourceAria': 'Джерело шаблону',
  'dsManager.yourSystems': 'Ваші системи',
  'dsManager.officialPresets': 'Офіційні пресети',
  'dsManager.enterprise': 'Корпоративні',
  'dsManager.yourTemplates': 'Ваші шаблони',
  'dsManager.yourSystemsAria': 'Ваші дизайн-системи',
  'dsManager.eyebrowDesignSystems': 'Дизайн-системи',
  'dsManager.yourSystemsHeading': 'Ваші системи',
  'dsManager.filterAria': 'Фільтрувати дизайн-системи',
  'dsManager.filterAll': 'Усі',
  'dsManager.filterPublished': 'Опубліковані',
  'dsManager.filterDraft': 'Чернетка',
  'dsManager.createTitle': 'Створити нову дизайн-систему',
  'dsManager.createBody': 'Навчіть Open Design свого бренду, продукту, коду, ресурсів і дизайн-референсів.',
  'dsManager.createAction': 'Створити',
  'dsManager.emptyMine': 'Дизайн-систем ще немає. Створіть її на основі реального контексту продукту, перегляньте чернетку, а потім опублікуйте для майбутніх проєктів.',
  'dsManager.badgeDefault': 'За замовчуванням',
  'dsManager.rowMetaUpdated': 'Ви · оновлено {date}',
  'dsManager.edit': 'Редагувати',
  'dsManager.openSystem': 'Відкрити',
  'dsManager.editWithAgent': 'Редагувати з Agent',
  'dsManager.downloadTitle': 'Завантажити дизайн-систему (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Завантажити {title} як .zip',
  'dsManager.downloadFailed': 'Не вдалося завантажити дизайн-систему. Спробуйте ще раз.',
  'dsManager.deleteConfirm': 'Видалити «{title}»? Це вилучить чернетку дизайн-системи з цього пристрою.',
  'dsManager.makeDefault': 'Зробити за замовчуванням',
  'dsManager.statusPublished': 'Опубліковано',
  'dsManager.statusDraft': 'Чернетка',
  'dsManager.openSystemAria': 'Відкрити {title}',
  'dsManager.deleteSystemAria': 'Видалити {title}',
  'dsManager.presetsAria': 'Офіційні пресети дизайн-систем',
  'dsManager.eyebrowLibrary': 'Бібліотека',
  'dsManager.eyebrowTemplates': 'Шаблони',
  'dsManager.yourTemplatesAria': 'Ваші шаблони',
  'dsManager.emptyTemplates': 'Шаблонів ще немає. Створіть шаблон із будь-якого згенерованого проєкту через «Поділитися», щойно стане доступним публікування шаблонів.',
  'dsManager.templateDescFallback': 'Створено з проєкту',
  'dsManager.comingSoonBadge': 'Незабаром',
  'dsManager.enterpriseDsTitle': 'Корпоративні дизайн-системи',
  'dsManager.enterpriseDsBody': 'Спільні командні дизайн-системи та керовані бренд-бібліотеки з’являться незабаром.',
  'dsManager.enterpriseTplTitle': 'Корпоративні шаблони',
  'dsManager.enterpriseTplBody': 'Затверджені командою шаблони та публікування в межах усієї організації з’являться незабаром.',
  'settings.instructionsTitle': 'Інструкції / Правила',
  'settings.instructionsSubtitle': 'Незмінна поведінка, якої має дотримуватися асистент',
  'settings.instructionsNavSub': 'Незмінна поведінка асистента',
  'settings.customInstructionsDesc': 'Незмінні інструкції, яких Open Design дотримується в кожному чаті. Це не збережені спогади; використовуйте Пам’ять для фактів, уподобань і контексту проєкту.',
  'mcpClient.forwardedToLabel': 'Переслано до:',
  'mcpClient.notForwardedToLabel': 'Не переслано до:',
  'mcpClient.forwardedAcpNote': 'Адаптери ACP, позначені як stdio, отримують із цього списку лише stdio-сервери MCP; записи HTTP та SSE відкидаються під час запуску.',
  'mcpClient.notForwardedNote': 'Для цих agent налаштуйте сервери MCP у власному файлі конфігурації agent (наприклад, ~/.codex/config.toml, ~/.gemini/settings.json); наведені нижче сервери там мовчки не використовуються.',

  // Brands library + extraction
  'brand.libraryTitle': 'Бренд-кіт',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Вставте сайт або виберіть бренд нижче — ми витягнемо його кольори, шрифти й логотип.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Бренд-кіт',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Створіть один раз — будуйте всюди',
  'onboarding.buildBody': 'Open Design перетворює ваш бренд на багаторазову дизайн-систему й зберігає єдиний фірмовий стиль у всьому, що ви створюєте.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Створити дизайн-систему',
  'onboarding.buildHome': 'На головну',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'Почніть із бренду, який вам подобається',
  'brandPicker.subtext': 'Натисніть на будь-який бренд, щоб витягти його кіт прямо з сайту.',
  'brandPicker.quickPicksLabel': 'Популярні бренди — натисніть, щоб витягти',
  'brandPicker.searchPlaceholder': 'Пошук брендів…',
  'brandPicker.allCategories': 'Усі',
  'brandPicker.extractAction': 'Витягти',
  'brandPicker.showMore': 'Показати більше',
  'brandPicker.opening': 'Запуск вилучення — відкриваємо {brand}…',
  'ds.kitVisualize': 'Перегляд',
  'ds.kitEdit': 'Редагувати',
  'ds.kitSource': 'Джерело',
  'ds.saveDesignMd': 'Зберегти DESIGN.md',
  'ds.saving': 'Збереження…',
  'ds.copyDesignMd': 'Копіювати DESIGN.md',
  'ds.editDesignMd': 'Редагувати DESIGN.md',
  'ds.openDesignMd': 'Відкрити DESIGN.md',
  'ds.copyDesignMdModule': 'Копіювати розділ {module}',
  'ds.editDesignMdModule': 'Редагувати розділ {module}',
  'ds.openDesignMdModule': 'Відкрити розділ {module}',
  'ds.uploadMd': 'Завантажити MD',
  'ds.uploadFont': 'Додати файл шрифту',
  'ds.pasteImage': 'Вставити зображення',
  'ds.refresh': 'Оновити',
  'ds.download': 'Завантажити',
  'ds.importFolder': 'Імпортувати папку',
  'ds.reset': 'Скинути',
  'ds.editingDesignMdHint': 'Редагування цього Markdown оновлює відрендерені модулі набору.',
  'ds.editingModuleHint': 'Редагується лише модуль {module}.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Зберегти модуль',
  'ds.uploadLogo': 'Завантажити логотип',
  'ds.uploadImage': 'Завантажити зображення',
  'ds.uploading': 'Завантаження…',
  'ds.moduleEmptyLogo': 'Логотипа ще немає',
  'ds.moduleEmptyFonts': 'Шрифти не зафіксовано.',
  'ds.actionDone': 'Готово',
  'ds.actionFailed': 'Щось пішло не так. Спробуйте ще раз.',
  'ds.uploadDone': 'Завантажено',
  'ds.uploadFailed': 'Не вдалося завантажити. Спробуйте ще раз.',
  'ds.deleteLogo': 'Видалити логотип',
  'ds.deleteImage': 'Видалити {caption}',
  'ds.deleteProjectConfirm': 'Видалити «{title}»? Це назавжди вилучить цю дизайн-систему та її проєкт із цього пристрою.',
  'ds.deleteProjectAction': 'Видалити {title}',
  'ds.editColor': 'Редагувати {name}',
  'ds.colorLabel': 'Колір',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Значення Hex',
  'ds.saveColor': 'Зберегти колір',
  'ds.invalidHexColor': 'Введіть коректний Hex-колір, наприклад #FF6A3D.',
  'ds.colorSaveFailed': 'Не вдалося зберегти цей колір.',
  'ds.colorResetFailed': 'Не вдалося скинути цей колір.',
  'ds.designMdSectionLabel': 'Розділ {module} у DESIGN.md',
  'ds.kitErrorTitle': 'У цьому поданні сталася помилка.',
  'ds.kitErrorRetry': 'Перезавантажити',
  'ds.shortcutsLabel': 'Гарячі клавіші',
  'ds.shortcutsHint': 'Клавіші: E редагувати · C копіювати · U завантажити · R оновити · ⌫ видалити логотип',
  'ds.moduleEmptyImages': 'Зображень ще немає',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  'newproj.startFromLabel': 'Почати з',
  'newproj.startBlank': 'Порожній',
  'newproj.startBlankHint': 'Почати з нуля',
  'workspace.pages': 'Сторінки',
  'workspace.allProjectFiles': 'Усі файли проєкту',
  'workspace.newBlankPage': 'Нова порожня сторінка',
  'workspace.noPagesYet': 'Поки немає сторінок',
  'workspace.pageCreateFailed': 'Не вдалося створити сторінку.',
  'workspace.pageCreatorTitle': 'Створити сторінку',
  'workspace.pageCreatorSearch': 'Пошук шаблонів',
  'workspace.pageCreatorCategoryAll': 'Усі сценарії',
  'workspace.pageCreatorEmpty': 'Жоден тип сторінки не відповідає вашому запиту.',
  'workspace.pageCreatorPreview': 'Попередній перегляд',
  'workspace.pageCreatorUse': 'Використати',
  'fileViewer.presentInTabDeckHint': 'Нотатки доповідача у спливному вікні',
  'fileViewer.presentEscHint': 'Натисніть Esc, щоб вийти',
  'fileViewer.presenterPause': 'Пауза',
  'fileViewer.presenterResume': 'Продовжити',
  'fileViewer.presenterPrevious': 'Назад',
  'fileViewer.presenterNext': 'Далі',
  'questions.uploadingFiles': 'Завантаження файлів…',
  'questions.uploadNeedsProject': 'Для завантаження файлів потрібен активний проєкт.',
  'questions.uploadPartialFailed': 'Завантажено файлів: {uploaded}, не вдалося: {failed}.',
  'questions.uploadFailed': 'Не вдалося завантажити файли: {failed}.',
};
